
// import React, {
//   useCallback,
//   useEffect,
//   useMemo,
//   useRef,
//   useState
// } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";

// import RouletteWheel3D from "./RouletteWheel3D";
// import authService from "../services/authService";
// import gameService from "../services/gameService";
// import { BET_TYPES, getNumberColor } from "../utils/gameLogic";
// import { sounds } from "../utils/audio";
// import "./Game.css";

// const CHIP_VALUES = [10, 50, 100, 500, 1000];

// const THEMES = [
//   { id: "classic", name: "Classic Green" },
//   { id: "royal", name: "Royal Black Gold" },
//   { id: "neon", name: "Neon Blue" },
//   { id: "ruby", name: "Ruby Casino" }
// ];

// const PRECISION_MODES = {
//   SINGLE: 1,
//   SPLIT: 2,
//   STREET: 3,
//   CORNER: 4,
//   SIX_LINE: 6
// };

// const NUMBER_ROWS = [
//   [3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36],
//   [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35],
//   [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34]
// ];

// const asSortedNumbers = (value) => {
//   if (Array.isArray(value)) {
//     return [...value]
//       .map(Number)
//       .sort((a, b) => a - b);
//   }

//   const text = String(value ?? "").trim();

//   if (text.startsWith("[") && text.endsWith("]")) {
//     try {
//       const parsed = JSON.parse(text);

//       if (Array.isArray(parsed)) {
//         return parsed
//           .map(Number)
//           .sort((a, b) => a - b);
//       }
//     } catch (error) {
//       return [];
//     }
//   }

//   if (text.includes(",")) {
//     return text
//       .split(",")
//       .map((item) => Number(item.trim()))
//       .filter(Number.isFinite)
//       .sort((a, b) => a - b);
//   }

//   const number = Number(text);

//   return Number.isFinite(number)
//     ? [number]
//     : [];
// };

// const canonicalValue = (value) => {
//   if (Array.isArray(value)) {
//     return JSON.stringify(
//       [...value]
//         .map(Number)
//         .sort((a, b) => a - b)
//     );
//   }

//   return String(value);
// };

// const betKey = (bet) =>
//   `${bet.type}:${canonicalValue(bet.value)}`;

// const aggregateBets = (actions) => {
//   const map = new Map();

//   actions.forEach((action) => {
//     const key = betKey(action);
//     const existing = map.get(key);

//     if (existing) {
//       existing.amount += Number(
//         action.amount || 0
//       );
//     } else {
//       map.set(key, {
//         ...action,
//         amount: Number(
//           action.amount || 0
//         )
//       });
//     }
//   });

//   return Array.from(map.values());
// };

// const displayValue = (type, value) => {
//   if (
//     [
//       "RED",
//       "BLACK",
//       "EVEN",
//       "ODD",
//       "LOW",
//       "HIGH"
//     ].includes(type)
//   ) {
//     return String(value)
//       .replace("LOW", "1-18")
//       .replace("HIGH", "19-36");
//   }

//   if (type.startsWith("COLUMN_")) {
//     return `${type.replace(
//       "COLUMN_",
//       ""
//     )} Column`;
//   }

//   if (type.startsWith("DOZEN_")) {
//     const index = Number(
//       type.replace("DOZEN_", "")
//     );

//     return index === 1
//       ? "1-12"
//       : index === 2
//       ? "13-24"
//       : "25-36";
//   }

//   const numbers =
//     asSortedNumbers(value);

//   return numbers.length
//     ? numbers.join(" • ")
//     : String(value);
// };

// const historyToAction = (bet) => ({
//   type: String(
//     bet.bet_type || "SINGLE"
//   ),

//   value: [
//     "SINGLE",
//     "SPLIT",
//     "STREET",
//     "CORNER",
//     "SIX_LINE"
//   ].includes(bet.bet_type)
//     ? asSortedNumbers(
//         bet.bet_value
//       ).length === 1
//       ? asSortedNumbers(
//           bet.bet_value
//         )[0]
//       : asSortedNumbers(
//           bet.bet_value
//         )
//     : String(bet.bet_value),

//   name: `${
//     BET_TYPES[bet.bet_type]?.name ||
//     bet.bet_type
//   } ${displayValue(
//     bet.bet_type,
//     bet.bet_value
//   )}`,

//   amount: Number(
//     bet.amount || 0
//   )
// });

// const isValidPrecision = (
//   type,
//   selected
// ) => {
//   const numbers = [
//     ...selected
//   ]
//     .map(Number)
//     .sort((a, b) => a - b);

//   if (type === "SINGLE") {
//     return (
//       numbers.length === 1 &&
//       numbers[0] >= 0 &&
//       numbers[0] <= 36
//     );
//   }

//   if (type === "SPLIT") {
//     if (numbers.length !== 2) {
//       return false;
//     }

//     const [a, b] = numbers;

//     if (a === 0) {
//       return [1, 2, 3].includes(b);
//     }

//     const vertical =
//       b - a === 3;

//     const horizontal =
//       b - a === 1 &&
//       Math.floor((a - 1) / 3) ===
//         Math.floor((b - 1) / 3);

//     return (
//       vertical ||
//       horizontal
//     );
//   }

//   if (type === "STREET") {
//     if (numbers.length !== 3) {
//       return false;
//     }

//     const [a, b, c] = numbers;

//     if (a === 0) {
//       return (
//         (b === 1 && c === 2) ||
//         (b === 2 && c === 3)
//       );
//     }

//     return (
//       a >= 1 &&
//       a <= 34 &&
//       a % 3 === 1 &&
//       b === a + 1 &&
//       c === a + 2
//     );
//   }

//   if (type === "CORNER") {
//     if (numbers.length !== 4) {
//       return false;
//     }

//     const [a, b, c, d] =
//       numbers;

//     if (a === 0) {
//       return (
//         b === 1 &&
//         c === 2 &&
//         d === 3
//       );
//     }

//     return (
//       a >= 1 &&
//       a <= 32 &&
//       a % 3 !== 0 &&
//       b === a + 1 &&
//       c === a + 3 &&
//       d === a + 4
//     );
//   }

//   if (type === "SIX_LINE") {
//     if (numbers.length !== 6) {
//       return false;
//     }

//     const [
//       a,
//       b,
//       c,
//       d,
//       e,
//       f
//     ] = numbers;

//     return (
//       a >= 1 &&
//       a <= 31 &&
//       a % 3 === 1 &&
//       b === a + 1 &&
//       c === a + 2 &&
//       d === a + 3 &&
//       e === a + 4 &&
//       f === a + 5
//     );
//   }

//   return false;
// };

// const Game = () => {
//   const navigate = useNavigate();

//   const [user, setUser] =
//     useState(() =>
//       authService.getCurrentUser()
//     );

//   const [
//     currentRound,
//     setCurrentRound
//   ] = useState(null);

//   const [
//     recentResults,
//     setRecentResults
//   ] = useState([]);

//   const [
//     history,
//     setHistory
//   ] = useState([]);

//   const [
//     loading,
//     setLoading
//   ] = useState(true);

//   const [
//     selectedChip,
//     setSelectedChip
//   ] = useState(10);

//   const [
//     precisionMode,
//     setPrecisionMode
//   ] = useState("SINGLE");

//   const [
//     precisionSelection,
//     setPrecisionSelection
//   ] = useState([]);

//   const [
//     betActions,
//     setBetActions
//   ] = useState([]);

//   const [
//     committedActions,
//     setCommittedActions
//   ] = useState([]);

//   const [
//     lastSubmittedActions,
//     setLastSubmittedActions
//   ] = useState([]);

//   const [
//     placingBets,
//     setPlacingBets
//   ] = useState(false);

//   const [
//     wheelResult,
//     setWheelResult
//   ] = useState(null);

//   const [
//     wheelSettled,
//     setWheelSettled
//   ] = useState(false);

//   const [
//     roundOutcome,
//     setRoundOutcome
//   ] = useState(null);

//   const [
//     theme,
//     setTheme
//   ] = useState(
//     () =>
//       localStorage.getItem(
//         "casinoPlayerTheme"
//       ) || "classic"
//   );

//   const [
//     pendingTheme,
//     setPendingTheme
//   ] = useState(null);

//   const [
//     soundEnabled,
//     setSoundEnabled
//   ] = useState(
//     () =>
//       localStorage.getItem(
//         "casinoSoundEnabled"
//       ) !== "false"
//   );

//   const currentRoundRef =
//     useRef(null);

//   const previousPhaseRef =
//     useRef(null);

//   const lastCountdownBeepRef =
//     useRef(null);

//   const outcomeRef =
//     useRef(null);

//   const bettingOpen =
//     currentRound?.betting_open ===
//     true;

//   const phase =
//     currentRound?.phase ||
//     (bettingOpen
//       ? "BETTING"
//       : "SPINNING");

//   const bettingRemaining =
//     Number(
//       currentRound
//         ?.betting_remaining_seconds ||
//         0
//     );

//   const phaseRemaining =
//     Number(
//       currentRound
//         ?.phase_remaining_seconds ||
//         0
//     );

//   const totalSeconds =
//     Number(
//       currentRound?.total_seconds ||
//         60
//     );

//   const minBet =
//     Number(
//       currentRound?.min_bet ||
//         0
//     );

//   const maxBet =
//     Number(
//       currentRound?.max_bet ||
//         0
//     );

//   // Backend exposes the already-locked roulette target only
//   // near the end of the current SPINNING phase.
//   // It is used only to settle the wheel; the wheel component
//   // reveals the number only after the ball has actually stopped.
//   const spinTarget =
//     currentRound?.spin_target !== null &&
//     currentRound?.spin_target !== undefined &&
//     Number.isInteger(
//       Number(
//         currentRound.spin_target
//       )
//     )
//       ? Number(
//           currentRound.spin_target
//         )
//       : null;

//   const wheelTarget =
//     phase === "SPINNING"
//       ? spinTarget
//       : null;

//   const stagedGroups =
//     useMemo(
//       () =>
//         aggregateBets(
//           betActions
//         ),
//       [betActions]
//     );

//   const tableGroups =
//     useMemo(
//       () =>
//         aggregateBets([
//           ...committedActions,
//           ...betActions
//         ]),
//       [
//         committedActions,
//         betActions
//       ]
//     );

//   const stagedTotal =
//     useMemo(
//       () =>
//         betActions.reduce(
//           (sum, item) =>
//             sum +
//             Number(
//               item.amount || 0
//             ),
//           0
//         ),
//       [betActions]
//     );

//   const confirmedTotal =
//     useMemo(
//       () =>
//         committedActions.reduce(
//           (sum, item) =>
//             sum +
//             Number(
//               item.amount || 0
//             ),
//           0
//         ),
//       [committedActions]
//     );

//   const pendingWinningCoins =
//     useMemo(
//       () =>
//         history
//           .filter(
//             (bet) =>
//               bet.status ===
//                 "WIN" &&
//               bet.claim_status ===
//                 "PENDING"
//           )
//           .reduce(
//             (sum, bet) =>
//               sum +
//               Number(
//                 bet.win_amount ||
//                   0
//               ),
//             0
//           ),
//       [history]
//     );

//   const invalidMinGroups =
//     useMemo(
//       () =>
//         minBet > 0
//           ? stagedGroups.filter(
//               (bet) =>
//                 bet.amount <
//                 minBet
//             )
//           : [],
//       [
//         stagedGroups,
//         minBet
//       ]
//     );

//   const invalidMaxGroups =
//     useMemo(
//       () =>
//         maxBet > 0
//           ? stagedGroups.filter(
//               (bet) =>
//                 bet.amount >
//                 maxBet
//             )
//           : [],
//       [
//         stagedGroups,
//         maxBet
//       ]
//     );

//   const refreshProfile =
//     useCallback(
//       async () => {
//         try {
//           const response =
//             await authService.getProfile();

//           if (response?.user) {
//             setUser(
//               response.user
//             );
//           } else {
//             setUser(
//               authService.getCurrentUser()
//             );
//           }
//         } catch (error) {
//           // Session interceptor
//         }
//       },
//       []
//     );

//   const refreshHistory =
//     useCallback(
//       async () => {
//         try {
//           const response =
//             await gameService.getHistory();

//           const rows =
//             Array.isArray(
//               response?.history
//             )
//               ? response.history
//               : [];

//           setHistory(rows);

//           return rows;
//         } catch (error) {
//           return [];
//         }
//       },
//       []
//     );

//   const refreshRecentResults =
//     useCallback(
//       async () => {
//         try {
//           const response =
//             await gameService.getRecentResults(
//               10
//             );

//           const rows =
//             Array.isArray(
//               response?.results
//             )
//               ? response.results
//               : [];

//           setRecentResults(rows);

//           return rows;
//         } catch (error) {
//           return [];
//         }
//       },
//       []
//     );

//   const handleCompletedRound =
//     useCallback(
//       async (
//         completedRoundId
//       ) => {
//         const [
//           results,
//           rows
//         ] =
//           await Promise.all([
//             refreshRecentResults(),
//             refreshHistory(),
//             refreshProfile()
//           ]);

//         const completed =
//           results.find(
//             (item) =>
//               Number(item.id) ===
//               Number(
//                 completedRoundId
//               )
//           );

//         if (!completed) {
//           return;
//         }

//         const playerRoundBets =
//           rows.filter(
//             (bet) =>
//               Number(
//                 bet.round_id
//               ) ===
//               Number(
//                 completedRoundId
//               )
//           );

//         const totalWin =
//           playerRoundBets
//             .filter(
//               (bet) =>
//                 bet.status ===
//                 "WIN"
//             )
//             .reduce(
//               (sum, bet) =>
//                 sum +
//                 Number(
//                   bet.win_amount ||
//                     0
//                 ),
//               0
//             );

//         const outcome = {
//           roundId:
//             Number(
//               completed.id
//             ),

//           roundNo:
//             completed.round_no,

//           winningNumber:
//             Number(
//               completed.winning_number
//             ),

//           playerBetCount:
//             playerRoundBets.length,

//           totalWin,

//           settlementPending:
//             false,

//           visible: false
//         };

//         outcomeRef.current =
//           outcome;

//         setRoundOutcome(
//           outcome
//         );

//         setWheelResult(
//           Number(
//             completed.winning_number
//           )
//         );
//       },
//       [
//         refreshHistory,
//         refreshProfile,
//         refreshRecentResults
//       ]
//     );

//   const fetchCurrentRound =
//     useCallback(
//       async () => {
//         try {
//           const response =
//             await gameService.getCurrentRound();

//           const nextRound =
//             response?.round ||
//             response?.current_round ||
//             null;

//           if (!nextRound) {
//             return null;
//           }

//           const previousRound =
//             currentRoundRef.current;

//           if (
//             previousRound &&
//             Number(
//               previousRound.id
//             ) !==
//               Number(
//                 nextRound.id
//               )
//           ) {
//             // A new backend round must start visually fresh at 60s.
//             // Do not let the previous wheel/result animation consume
//             // any seconds from the new betting round.
//             setWheelSettled(false);

//             setWheelResult(
//               null
//             );

//             // The previous round result is only for the old round.
//             // Close it exactly when the fresh 60-second round begins.
//             outcomeRef.current =
//               null;

//             setRoundOutcome(
//               null
//             );

//             setBetActions([]);

//             setCommittedActions(
//               []
//             );

//             setPrecisionSelection(
//               []
//             );

//             if (pendingTheme) {
//               setTheme(
//                 pendingTheme
//               );

//               localStorage.setItem(
//                 "casinoPlayerTheme",
//                 pendingTheme
//               );

//               setPendingTheme(
//                 null
//               );
//             }

//             handleCompletedRound(
//               previousRound.id
//             );
//           }

//           currentRoundRef.current =
//             nextRound;

//           setCurrentRound(
//             nextRound
//           );

//           return nextRound;
//         } catch (error) {
//           if (
//             error.response
//               ?.status === 404
//           ) {
//             setCurrentRound(
//               null
//             );
//           }

//           return null;
//         }
//       },
//       [
//         handleCompletedRound,
//         pendingTheme
//       ]
//     );

//   useEffect(() => {
//     sounds.setEnabled(
//       soundEnabled
//     );

//     localStorage.setItem(
//       "casinoSoundEnabled",
//       soundEnabled
//         ? "true"
//         : "false"
//     );
//   }, [soundEnabled]);

//   useEffect(() => {
//     const load = async () => {
//       setLoading(true);

//       const [
//         round,
//         results,
//         rows
//       ] =
//         await Promise.all([
//           fetchCurrentRound(),
//           refreshRecentResults(),
//           refreshHistory(),
//           refreshProfile()
//         ]);

//       if (round) {
//         currentRoundRef.current =
//           round;

//         const pendingThisRound =
//           rows
//             .filter(
//               (bet) =>
//                 Number(
//                   bet.round_id
//                 ) ===
//                   Number(
//                     round.id
//                   ) &&
//                 bet.status ===
//                   "PENDING"
//             )
//             .map(
//               historyToAction
//             );

//         setCommittedActions(
//           pendingThisRound
//         );
//       }

//       if (
//         round?.phase !==
//           "SPINNING" &&
//         results.length
//       ) {
//         setWheelResult(
//           Number(
//             results[0]
//               .winning_number
//           )
//         );
//       }

//       setLoading(false);
//     };

//     load();

//     const interval =
//       setInterval(
//         fetchCurrentRound,
//         1000
//       );

//     const historyInterval =
//       setInterval(
//         refreshHistory,
//         5000
//       );

//     return () => {
//       clearInterval(
//         interval
//       );

//       clearInterval(
//         historyInterval
//       );
//     };
//   }, [
//     fetchCurrentRound,
//     refreshHistory,
//     refreshProfile,
//     refreshRecentResults
//   ]);

//   useEffect(() => {
//     if (
//       previousPhaseRef.current !==
//       phase
//     ) {
//       if (
//         phase ===
//         "SPINNING"
//       ) {
//         setWheelSettled(
//           false
//         );

//         setWheelResult(
//           null
//         );

//         setRoundOutcome(
//           null
//         );

//         outcomeRef.current =
//           null;

//         setPrecisionSelection(
//           []
//         );

//         sounds.playNoMoreBetsSound();
//       }

//       previousPhaseRef.current =
//         phase;
//     }
//   }, [phase]);

//   useEffect(() => {
//     if (
//       phase === "BETTING" &&
//       bettingRemaining > 0 &&
//       bettingRemaining <= 5 &&
//       lastCountdownBeepRef.current !==
//         bettingRemaining
//     ) {
//       lastCountdownBeepRef.current =
//         bettingRemaining;

//       sounds.playCountdownSound();
//     }
//   }, [
//     phase,
//     bettingRemaining
//   ]);

//   useEffect(() => {
//     if (
//       phase !== "SPINNING" ||
//       wheelSettled
//     ) {
//       return undefined;
//     }

//     const interval =
//       setInterval(() => {
//         sounds.playSpinTickSound();
//       }, 360);

//     return () =>
//       clearInterval(
//         interval
//       );
//   }, [
//     phase,
//     wheelSettled
//   ]);

//   const getTableAmount =
//     useCallback(
//       (
//         type,
//         value
//       ) => {
//         const key =
//           `${type}:${canonicalValue(
//             value
//           )}`;

//         const found =
//           tableGroups.find(
//             (bet) =>
//               betKey(bet) ===
//               key
//           );

//         return Number(
//           found?.amount ||
//             0
//         );
//       },
//       [tableGroups]
//     );

//   const addBetAction =
//     useCallback(
//       (
//         type,
//         value,
//         name
//       ) => {
//         if (!bettingOpen) {
//           toast.warning(
//             "No more bets. Wait for the next round."
//           );

//           return;
//         }

//         const nextTotal =
//           stagedTotal +
//           selectedChip;

//         const wallet =
//           Number(
//             user?.wallet ||
//               0
//           );

//         if (
//           nextTotal >
//           wallet
//         ) {
//           toast.error(
//             "Insufficient playable wallet balance."
//           );

//           return;
//         }

//         setBetActions(
//           (previous) => [
//             ...previous,
//             {
//               type,
//               value,
//               name,
//               amount:
//                 selectedChip
//             }
//           ]
//         );

//         sounds.playChipSound();
//       },
//       [
//         bettingOpen,
//         selectedChip,
//         stagedTotal,
//         user?.wallet
//       ]
//     );


//   // Visual preview only for connected-number modes.
//   // This changes table highlighting only; wheel/spin code is untouched.
//   const previewConnectedNumbers = (number) => {
//     const n = Number(number);

//     if (!Number.isInteger(n) || n < 1 || n > 36) {
//       return [n];
//     }

//     const streetStart =
//       Math.floor((n - 1) / 3) * 3 + 1;

//     if (precisionMode === "STREET") {
//       return [
//         streetStart,
//         streetStart + 1,
//         streetStart + 2
//       ];
//     }

//     if (precisionMode === "SIX_LINE") {
//       const firstStreet =
//         streetStart >= 34
//           ? 31
//           : streetStart;

//       return [
//         firstStreet,
//         firstStreet + 1,
//         firstStreet + 2,
//         firstStreet + 3,
//         firstStreet + 4,
//         firstStreet + 5
//       ];
//     }

//     return [n];
//   };

//   const handleNumberClick =
//     (number) => {
//       if (!bettingOpen) {
//         toast.warning(
//           "Betting is closed."
//         );

//         return;
//       }

//       if (
//         precisionMode ===
//         "SINGLE"
//       ) {
//         addBetAction(
//           "SINGLE",
//           number,
//           `Number ${number}`
//         );

//         return;
//       }

//       if (
//         precisionMode === "STREET" ||
//         precisionMode === "SIX_LINE"
//       ) {
//         setPrecisionSelection(
//           previewConnectedNumbers(number)
//         );
//         return;
//       }

//       const required =
//         PRECISION_MODES[
//           precisionMode
//         ];

//       let updated =
//         precisionSelection.includes(
//           number
//         )
//           ? precisionSelection.filter(
//               (item) =>
//                 item !== number
//             )
//           : [
//               ...precisionSelection,
//               number
//             ];

//       if (
//         updated.length >
//         required
//       ) {
//         updated = [number];
//       }

//       setPrecisionSelection(
//         updated
//       );

//       if (
//         updated.length ===
//         required
//       ) {
//         if (
//           !isValidPrecision(
//             precisionMode,
//             updated
//           )
//         ) {
//           toast.error(
//             `Invalid ${
//               BET_TYPES[
//                 precisionMode
//               ]?.name ||
//               precisionMode
//             } selection.`
//           );

//           setPrecisionSelection(
//             []
//           );

//           return;
//         }

//         const sorted = [
//           ...updated
//         ].sort(
//           (a, b) => a - b
//         );

//         addBetAction(
//           precisionMode,
//           sorted,
//           `${
//             BET_TYPES[
//               precisionMode
//             ]?.name ||
//             precisionMode
//           } ${sorted.join("-")}`
//         );

//         setPrecisionSelection(
//           []
//         );
//       }
//     };

//   const addOutsideBet = (
//     type,
//     value,
//     label
//   ) => {
//     addBetAction(
//       type,
//       value,
//       label
//     );
//   };

//   const handleUndo = () => {
//     setBetActions(
//       (previous) =>
//         previous.slice(
//           0,
//           -1
//         )
//     );
//   };

//   const handleClear = () => {
//     setBetActions([]);

//     setPrecisionSelection(
//       []
//     );
//   };

//   const handleRepeat = () => {
//     if (
//       !bettingOpen ||
//       lastSubmittedActions.length ===
//         0
//     ) {
//       return;
//     }

//     const repeatTotal =
//       lastSubmittedActions.reduce(
//         (sum, item) =>
//           sum +
//           Number(
//             item.amount ||
//               0
//           ),
//         0
//       );

//     if (
//       repeatTotal >
//       Number(
//         user?.wallet ||
//           0
//       )
//     ) {
//       toast.error(
//         "Wallet balance is not enough to repeat the previous bet."
//       );

//       return;
//     }

//     setBetActions(
//       lastSubmittedActions.map(
//         (item) => ({
//           ...item
//         })
//       )
//     );

//     sounds.playChipSound();
//   };

//   const handleDouble = () => {
//     if (!bettingOpen) {
//       return;
//     }

//     const source =
//       betActions.length > 0
//         ? betActions
//         : committedActions;

//     if (
//       source.length === 0
//     ) {
//       return;
//     }

//     const additional =
//       source.reduce(
//         (sum, item) =>
//           sum +
//           Number(
//             item.amount ||
//               0
//           ),
//         0
//       );

//     if (
//       additional >
//       Number(
//         user?.wallet ||
//           0
//       )
//     ) {
//       toast.error(
//         "Wallet balance is not enough to double the bet."
//       );

//       return;
//     }

//     if (
//       betActions.length >
//       0
//     ) {
//       setBetActions(
//         (previous) =>
//           previous.map(
//             (item) => ({
//               ...item,
//               amount:
//                 Number(
//                   item.amount ||
//                     0
//                 ) * 2
//             })
//           )
//       );
//     } else {
//       setBetActions(
//         source.map(
//           (item) => ({
//             ...item
//           })
//         )
//       );
//     }

//     sounds.playChipSound();
//   };

//   const handlePlaceBets =
//     async () => {
//       if (
//         !currentRound ||
//         !bettingOpen ||
//         placingBets ||
//         stagedGroups.length ===
//           0
//       ) {
//         return;
//       }

//       if (
//         invalidMinGroups.length >
//         0
//       ) {
//         toast.error(
//           `Minimum bet per position is ${minBet}. Add more chips on highlighted positions.`
//         );

//         return;
//       }

//       if (
//         invalidMaxGroups.length >
//         0
//       ) {
//         toast.error(
//           `Maximum bet per position is ${maxBet}.`
//         );

//         return;
//       }

//       if (
//         stagedTotal >
//         Number(
//           user?.wallet ||
//             0
//         )
//       ) {
//         toast.error(
//           "Insufficient playable wallet balance."
//         );

//         return;
//       }

//       const payloadBets =
//         stagedGroups.map(
//           (bet) => ({
//             bet_type:
//               bet.type,

//             bet_value:
//               Array.isArray(
//                 bet.value
//               )
//                 ? JSON.stringify(
//                     bet.value
//                   )
//                 : String(
//                     bet.value
//                   ),

//             amount:
//               Number(
//                 bet.amount
//               )
//           })
//         );

//       try {
//         setPlacingBets(
//           true
//         );

//         const response =
//           await gameService.placeBets(
//             {
//               round_id:
//                 currentRound.id,

//               bets:
//                 payloadBets
//             }
//           );

//         if (
//           !response?.success
//         ) {
//           throw new Error(
//             response?.message ||
//               "Unable to place bets."
//           );
//         }

//         setCommittedActions(
//           (previous) => [
//             ...previous,
//             ...stagedGroups
//           ]
//         );

//         setLastSubmittedActions(
//           betActions.map(
//             (item) => ({
//               ...item
//             })
//           )
//         );

//         setBetActions([]);

//         setPrecisionSelection(
//           []
//         );

//         await refreshProfile();

//         await refreshHistory();

//         toast.success(
//           `Bets confirmed: ${Number(
//             response.total_amount ||
//               stagedTotal
//           ).toLocaleString()} coins`
//         );
//       } catch (error) {
//         toast.error(
//           error.response?.data
//             ?.message ||
//             error.message ||
//             "Unable to place bets."
//         );

//         await fetchCurrentRound();
//       } finally {
//         setPlacingBets(
//           false
//         );
//       }
//     };

//   const handleThemeChange =
//     (event) => {
//       const nextTheme =
//         event.target.value;

//       if (
//         phase ===
//         "SPINNING"
//       ) {
//         setPendingTheme(
//           nextTheme
//         );

//         toast.info(
//           "Theme will change on the next round."
//         );

//         return;
//       }

//       setTheme(
//         nextTheme
//       );

//       localStorage.setItem(
//         "casinoPlayerTheme",
//         nextTheme
//       );
//     };

//   const handleWheelSettled =
//     () => {
//       setWheelSettled(
//         true
//       );

//       sounds.playBallSettleSound();

//       const activeRound =
//         currentRoundRef.current;

//       const target =
//         Number(
//           activeRound
//             ?.spin_target
//         );

//       // The backend has already locked this target and betting is closed.
//       // Show it NOW, exactly after the ball has stopped.
//       if (
//         !activeRound ||
//         !Number.isInteger(
//           target
//         ) ||
//         target < 0 ||
//         target > 36
//       ) {
//         return;
//       }

//       const provisionalOutcome = {
//         roundId:
//           Number(
//             activeRound.id
//           ),

//         roundNo:
//           activeRound.round_no,

//         winningNumber:
//           target,

//         // Final bet settlement happens server-side at 0 sec.
//         // Until then we only reveal the winning number.
//         playerBetCount:
//           0,

//         totalWin:
//           0,

//         settlementPending:
//           true,

//         visible:
//           true
//       };

//       outcomeRef.current =
//         provisionalOutcome;

//       setRoundOutcome(
//         provisionalOutcome
//       );
//     };

//   const handleLogout = () => {
//     authService.logout();

//     navigate(
//       "/login"
//     );
//   };

//   const timerValue =
//     phase === "BETTING"
//       ? bettingRemaining
//       : phaseRemaining;

//   const timerMax =
//     phase === "BETTING"
//       ? Number(
//           currentRound
//             ?.betting_seconds ||
//             40
//         )
//       : Number(
//           currentRound
//             ?.spin_result_seconds ||
//             20
//         );

//   const timerProgress =
//     timerMax > 0
//       ? Math.max(
//           0,
//           Math.min(
//             1,
//             timerValue /
//               timerMax
//           )
//         )
//       : 0;

//   if (loading) {
//     return (
//       <div className="roulette-loading-screen">
//         <div className="roulette-loading-wheel">
//           ♛
//         </div>

//         <div>
//           Preparing Roulette
//           Table...
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div
//       className={`casino-game-shell theme-${theme}`}
//     >
// 
//       {/* HEADER */}
//       <header className="casino-game-header">
//         <div className="casino-brand-block">
//           <div className="casino-brand-mark">
//             0
//           </div>

//           <div>
//             <strong>
//               EUROPEAN ROULETTE
//             </strong>

//             <span>
//               Live 60 Second
//               Round
//             </span>
//           </div>
//         </div>

//         <div className="casino-header-round">
//           <span>
//             ROUND
//           </span>

//           <strong>
//             #
//             {currentRound
//               ?.round_no ||
//               "--"}
//           </strong>

//           <em
//             className={
//               phase ===
//               "BETTING"
//                 ? "phase-open"
//                 : "phase-closed"
//             }
//           >
//             {phase ===
//             "BETTING"
//               ? "BETTING OPEN"
//               : "NO MORE BETS"}
//           </em>
//         </div>

//         <div className="casino-player-strip">
//           <div className="casino-balance-card">
//             <span>
//               PLAYABLE
//             </span>

//             <strong>
//               🪙{" "}
//               {Number(
//                 user?.wallet ||
//                   0
//               ).toLocaleString()}
//             </strong>
//           </div>

//           <div className="casino-balance-card winning-balance">
//             <span>
//               WINNING COINS
//             </span>

//             <strong>
//               🏆{" "}
//               {pendingWinningCoins.toLocaleString()}
//             </strong>
//           </div>

//           <label className="theme-select-wrap">
//             <span>
//               THEME
//             </span>

//             <select
//               value={
//                 pendingTheme ||
//                 theme
//               }
//               onChange={
//                 handleThemeChange
//               }
//             >
//               {THEMES.map(
//                 (item) => (
//                   <option
//                     key={
//                       item.id
//                     }
//                     value={
//                       item.id
//                     }
//                   >
//                     {item.name}
//                   </option>
//                 )
//               )}
//             </select>
//           </label>

//           <button
//             type="button"
//             className="casino-icon-button"
//             onClick={() =>
//               setSoundEnabled(
//                 (value) =>
//                   !value
//               )
//             }
//             title={
//               soundEnabled
//                 ? "Mute sounds"
//                 : "Enable sounds"
//             }
//           >
//             {soundEnabled
//               ? "🔊"
//               : "🔇"}
//           </button>

//           <button
//             type="button"
//             className="casino-icon-button"
//             onClick={() =>
//               navigate(
//                 "/dashboard"
//               )
//             }
//             title="Dashboard"
//           >
//             ⌂
//           </button>

//           <button
//             type="button"
//             className="casino-logout-button"
//             onClick={
//               handleLogout
//             }
//           >
//             {user?.username ||
//               "Player"}{" "}
//             · Logout
//           </button>
//         </div>
//       </header>

//       {/* MAIN */}
//       <main className="casino-game-content">
//         {/* WHEEL + TIMER */}
//         <section className="casino-stage-grid">
//           <div className="roulette-stage-card">
//             <div className="stage-light stage-light-left" />

//             <div className="stage-light stage-light-right" />

// <RouletteWheel3D
//   key={
//     currentRound?.id ||
//     "no-round"
//   }
//   winningNumber={wheelTarget}
//   isSpinning={
//     phase === "SPINNING" &&
//     wheelTarget === null
//   }
//   onSettled={handleWheelSettled}
// />
//           </div>

//           <aside className="round-console">
//             <div
//               className={`round-status-panel ${
//                 phase ===
//                 "BETTING"
//                   ? "status-open"
//                   : "status-spin"
//               }`}
//             >
//               <div
//                 className="round-timer-ring"
//                 style={{
//                   "--timer-progress":
//                     `${
//                       timerProgress *
//                       360
//                     }deg`
//                 }}
//               >
//                 <div className="round-timer-inner">
//                   <strong>
//                     {timerValue}
//                   </strong>

//                   <span>
//                     SEC
//                   </span>
//                 </div>
//               </div>

//               <div className="round-status-copy">
//                 <span>
//                   {phase ===
//                   "BETTING"
//                     ? "PLACE YOUR BETS"
//                     : "NO MORE BETS"}
//                 </span>

//                 <strong>
//                   {phase ===
//                   "BETTING"
//                     ? "Betting is open"
//                     : wheelSettled
//                     ? "Winning number displayed"
//                     : "Wheel is spinning"}
//                 </strong>

//                 <small>
//                   {phase ===
//                   "BETTING"
//                     ? `${bettingRemaining}s left to confirm bets`
//                     : wheelSettled
//                     ? `Next round in ${phaseRemaining}s`
//                     : `Result phase · ${phaseRemaining}s`}
//                 </small>
//               </div>
//             </div>

//             {/* RECENT RESULTS */}
//             <div className="recent-results-card">
//               <div className="console-section-title">
//                 <span>
//                   RECENT RESULTS
//                 </span>

//                 <button
//                   type="button"
//                   onClick={() =>
//                     navigate(
//                       "/bet-history"
//                     )
//                   }
//                 >
//                   History
//                 </button>
//               </div>

//               <div className="recent-result-row">
//                 {recentResults.length ===
//                 0 ? (
//                   <span className="empty-result">
//                     No completed
//                     rounds yet
//                   </span>
//                 ) : (
//                   recentResults
//                     .slice(
//                       0,
//                       10
//                     )
//                     .map(
//                       (item) => (
//                         <div
//                           key={
//                             item.id
//                           }
//                           className={`recent-number recent-${getNumberColor(
//                             Number(
//                               item.winning_number
//                             )
//                           )}`}
//                           title={`Round #${item.round_no}`}
//                         >
//                           {
//                             item.winning_number
//                           }
//                         </div>
//                       )
//                     )
//                 )}
//               </div>
//             </div>

//             {/* ROUND INFO */}
//             <div className="round-info-grid">
//               <div>
//                 <span>
//                   Round Time
//                 </span>

//                 <strong>
//                   {totalSeconds}s
//                 </strong>
//               </div>

//               <div>
//                 <span>
//                   Betting
//                 </span>

//                 <strong>
//                   {currentRound
//                     ?.betting_seconds ||
//                     40}
//                   s
//                 </strong>
//               </div>

//               <div>
//                 <span>
//                   Min /
//                   Position
//                 </span>

//                 <strong>
//                   {minBet ||
//                     "--"}
//                 </strong>
//               </div>

//               <div>
//                 <span>
//                   Max /
//                   Position
//                 </span>

//                 <strong>
//                   {maxBet ||
//                     "--"}
//                 </strong>
//               </div>
//             </div>
//           </aside>
//         </section>

//         {/* BETTING TABLE + SLIP */}
//         <section className="betting-layout">
//           <div
//             className={`roulette-table-card ${
//               !bettingOpen
//                 ? "table-locked"
//                 : ""
//             }`}
//           >
//             {/* BET MODE */}
//             <div className="table-toolbar">
//               <div>
//                 <span className="eyebrow">
//                   BET MODE
//                 </span>

//                 <div className="precision-mode-row">
//                   {Object.keys(
//                     PRECISION_MODES
//                   ).map(
//                     (mode) => (
//                       <button
//                         key={
//                           mode
//                         }
//                         type="button"
//                         className={
//                           precisionMode ===
//                           mode
//                             ? "active"
//                             : ""
//                         }
//                         onClick={() => {
//                           setPrecisionMode(
//                             mode
//                           );

//                           setPrecisionSelection(
//                             []
//                           );
//                         }}
//                         disabled={
//                           !bettingOpen
//                         }
//                       >
//                         {BET_TYPES[
//                           mode
//                         ]?.name ||
//                           mode}
//                       </button>
//                     )
//                   )}
//                 </div>
//               </div>

//               <div className="precision-help">
//                 {precisionMode ===
//                 "SINGLE"
//                   ? "Click any number to place a chip"
//                   : `Select ${
//                       PRECISION_MODES[
//                         precisionMode
//                       ]
//                     } connected numbers`}

//                 {precisionSelection.length >
//                   0 && (
//                   <strong>
//                     {precisionSelection.join(
//                       " · "
//                     )}
//                   </strong>
//                 )}
//               </div>
//             </div>

//             {/* TABLE CHIP RACK */}
//             <div className="table-chip-rack">
//               <span className="table-chip-rack-label">
//                 SELECT CHIP
//               </span>

//               <div className="table-chip-rack-coins">
//                 {CHIP_VALUES.map((chip) => (
//                   <button
//                     key={chip}
//                     type="button"
//                     className={`casino-chip chip-${chip} ${
//                       selectedChip === chip ? "selected" : ""
//                     }`}
//                     onClick={() => {
//                       setSelectedChip(chip);
//                       sounds.playChipSound();
//                     }}
//                     disabled={!bettingOpen}
//                   >
//                     {chip >= 1000 ? `${chip / 1000}K` : chip}
//                   </button>
//                 ))}
//               </div>

//               <span className="table-chip-rack-copy">
//                 {minBet > 0 ? `MIN ${minBet}` : "SELECT CHIP"}
//               </span>
//             </div>

//             {/* TABLE */}
//             
//             <div className="roulette-table-scroll">
//                 <button
//                   type="button"
//                   className={`number-cell zero-cell ${
//                     precisionSelection.includes(
//                       0
//                     )
//                       ? "precision-selected"
//                       : ""
//                   }`}
//                   onClick={() =>
//                     handleNumberClick(
//                       0
//                     )
//                   }
//                   disabled={
//                     !bettingOpen
//                   }
//                 >
//                   <span>
//                     0
//                   </span>

//                   {getTableAmount(
//                     "SINGLE",
//                     0
//                   ) > 0 && (
//                     <b>
//                       {getTableAmount(
//                         "SINGLE",
//                         0
//                       )}
//                     </b>
//                   )}
//                 </button>

//                 {/* 1-36 */}
//                 <div className="number-grid" style={{ gap: 0 }}>
//                   {NUMBER_ROWS.flatMap(
//                     (row) =>
//                       row.map(
//                         (
//                           number
//                         ) => {
//                           const color =
//                             getNumberColor(
//                               number
//                             );

//                           const amount =
//                             getTableAmount(
//                               "SINGLE",
//                               number
//                             );

//                           const selected =
//                             precisionSelection.includes(
//                               number
//                             );

//                           return (
//                             <button
//                               type="button"
//                               key={
//                                 number
//                               }
//                               className={`number-cell ${color}-cell ${
//                                 selected
//                                   ? "precision-selected"
//                                   : ""
//                               }`}
//                               onClick={() =>
//                                 handleNumberClick(
//                                   number
//                                 )
//                               }
//                               disabled={
//                                 !bettingOpen
//                               }
//                             >
//                               <span>
//                                 {
//                                   number
//                                 }
//                               </span>

//                               {amount >
//                                 0 && (
//                                 <b>
//                                   {
//                                     amount
//                                   }
//                                 </b>
//                               )}
//                             </button>
//                           );
//                         }
//                       )
//                   )}
//                 </div>

//                 {/* COLUMNS */}
//                 <div className="column-bets" style={{ borderTop: '1px solid #fff', borderRight: '1px solid #fff', borderBottom: '1px solid #fff' }}>
//                   {[
//                     [
//                       "COLUMN_3",
//                       "COLUMN_3",
//                       "2:1"
//                     ],
//                     [
//                       "COLUMN_2",
//                       "COLUMN_2",
//                       "2:1"
//                     ],
//                     [
//                       "COLUMN_1",
//                       "COLUMN_1",
//                       "2:1"
//                     ]
//                   ].map(
//                     ([
//                       type,
//                       value,
//                       label
//                     ]) => (
//                       <button
//                         key={
//                           type
//                         }
//                         type="button"
//                         onClick={() =>
//                           addOutsideBet(
//                             type,
//                             value,
//                             BET_TYPES[
//                               type
//                             ].name
//                           )
//                         }
//                         disabled={
//                           !bettingOpen
//                         }
//                       >
//                         <span>
//                           {
//                             label
//                           }
//                         </span>

//                         {getTableAmount(
//                           type,
//                           value
//                         ) > 0 && (
//                           <b>
//                             {getTableAmount(
//                               type,
//                               value
//                             )}
//                           </b>
//                         )}
//                       </button>
//                     )
//                   )}
//                 </div>

//                 {/* DOZENS */}
//                 <div className="dozen-row" style={{ borderLeft: '1px solid #fff', borderRight: '1px solid #fff' }}>
//                   {[
//                     [
//                       "DOZEN_1",
//                       "DOZEN_1",
//                       "1st 12"
//                     ],
//                     [
//                       "DOZEN_2",
//                       "DOZEN_2",
//                       "2nd 12"
//                     ],
//                     [
//                       "DOZEN_3",
//                       "DOZEN_3",
//                       "3rd 12"
//                     ]
//                   ].map(
//                     ([
//                       type,
//                       value,
//                       label
//                     ]) => (
//                       <button
//                         key={
//                           type
//                         }
//                         type="button"
//                         onClick={() =>
//                           addOutsideBet(
//                             type,
//                             value,
//                             label
//                           )
//                         }
//                         disabled={
//                           !bettingOpen
//                         }
//                       >
//                         <span>
//                           {
//                             label
//                           }
//                         </span>

//                         <small>
//                           2:1
//                         </small>

//                         {getTableAmount(
//                           type,
//                           value
//                         ) > 0 && (
//                           <b>
//                             {getTableAmount(
//                               type,
//                               value
//                             )}
//                           </b>
//                         )}
//                       </button>
//                     )
//                   )}
//                 </div>

//                 {/* OUTSIDE */}
//                 <div className="outside-row">
//                   {[
//                     [
//                       "LOW",
//                       "LOW",
//                       "1 to 18",
//                       ""
//                     ],
//                     [
//                       "EVEN",
//                       "EVEN",
//                       "EVEN",
//                       ""
//                     ],
//                     [
//                       "RED",
//                       "RED",
//                       "RED",
//                       "red-zone"
//                     ],
//                     [
//                       "BLACK",
//                       "BLACK",
//                       "BLACK",
//                       "black-zone"
//                     ],
//                     [
//                       "ODD",
//                       "ODD",
//                       "ODD",
//                       ""
//                     ],
//                     [
//                       "HIGH",
//                       "HIGH",
//                       "19 to 36",
//                       ""
//                     ]
//                   ].map(
//                     ([
//                       type,
//                       value,
//                       label,
//                       className
//                     ]) => (
//                       <button
//                         key={
//                           type
//                         }
//                         type="button"
//                         className={
//                           className
//                         }
//                         onClick={() =>
//                           addOutsideBet(
//                             type,
//                             value,
//                             label
//                           )
//                         }
//                         disabled={
//                           !bettingOpen
//                         }
//                       >
//                         <span>
//                           {
//                             label
//                           }
//                         </span>

//                         {getTableAmount(
//                           type,
//                           value
//                         ) > 0 && (
//                           <b>
//                             {getTableAmount(
//                               type,
//                               value
//                             )}
//                           </b>
//                         )}
//                       </button>
//                     )
//                   )}
//                 </div>

//                 {/* SPECIAL ZERO BETS */}
//                 <div className="zero-special-row">
//                   <span>
//                     ZERO BETS
//                   </span>

//                   {[
//                     [
//                       "SPLIT",
//                       [0, 1],
//                       "0-1"
//                     ],
//                     [
//                       "SPLIT",
//                       [0, 2],
//                       "0-2"
//                     ],
//                     [
//                       "SPLIT",
//                       [0, 3],
//                       "0-3"
//                     ],
//                     [
//                       "STREET",
//                       [0, 1, 2],
//                       "0-1-2"
//                     ],
//                     [
//                       "STREET",
//                       [0, 2, 3],
//                       "0-2-3"
//                     ],
//                     [
//                       "CORNER",
//                       [0, 1, 2, 3],
//                       "0-1-2-3"
//                     ]
//                   ].map(
//                     ([
//                       type,
//                       value,
//                       label
//                     ]) => (
//                       <button
//                         key={`${type}-${label}`}
//                         type="button"
//                         onClick={() =>
//                           addBetAction(
//                             type,
//                             value,
//                             `${
//                               BET_TYPES[
//                                 type
//                               ].name
//                             } ${label}`
//                           )
//                         }
//                         disabled={
//                           !bettingOpen
//                         }
//                       >
//                         {
//                           label
//                         }

//                         {getTableAmount(
//                           type,
//                           value
//                         ) > 0 && (
//                           <b>
//                             {getTableAmount(
//                               type,
//                               value
//                             )}
//                           </b>
//                         )}
//                       </button>
//                     )
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* CLOSED OVERLAY */}
//             {!bettingOpen && (
//               <div className="betting-closed-overlay">
//                 <strong>
//                   NO MORE BETS
//                 </strong>

//                 <span>
//                   Wheel spinning ·
//                   result coming
//                 </span>
//               </div>
//             )}
//           </div>

//           {/* BET SLIP */}
//           <aside className="bet-slip-card">
//             <div className="bet-slip-title">
//               <div>
//                 <span>
//                   BET SLIP
//                 </span>

//                 <strong>
//                   {
//                     stagedGroups.length
//                   }{" "}
//                   positions ready
//                 </strong>
//               </div>

//               <span
//                 className={
//                   bettingOpen
//                     ? "open-dot"
//                     : "closed-dot"
//                 }
//               />
//             </div>

//             <div className="bet-summary-list">
//               {stagedGroups.length ===
//               0 ? (
//                 <div className="empty-bet-slip">
//                   <span>
//                     ◎
//                   </span>

//                   <strong>
//                     Place chips on
//                     the table
//                   </strong>

//                   <small>
//                     Your
//                     unconfirmed
//                     bets will
//                     appear here.
//                   </small>
//                 </div>
//               ) : (
//                 stagedGroups.map(
//                   (bet) => (
//                     <div
//                       key={
//                         betKey(
//                           bet
//                         )
//                       }
//                       className={
//                         bet.amount <
//                         minBet
//                           ? "bet-under-min"
//                           : ""
//                       }
//                     >
//                       <span>
//                         <strong>
//                           {
//                             bet.name
//                           }
//                         </strong>

//                         <small>
//                           {BET_TYPES[
//                             bet.type
//                           ]?.ratio ||
//                             ""}
//                         </small>
//                       </span>

//                       <b>
//                         🪙{" "}
//                         {bet.amount.toLocaleString()}
//                       </b>
//                     </div>
//                   )
//                 )
//               )}
//             </div>

//             {/* TOTALS */}
//             <div className="bet-totals">
//               <div>
//                 <span>
//                   Ready to
//                   confirm
//                 </span>

//                 <strong>
//                   {stagedTotal.toLocaleString()}
//                 </strong>
//               </div>

//               <div>
//                 <span>
//                   Already
//                   confirmed
//                 </span>

//                 <strong>
//                   {confirmedTotal.toLocaleString()}
//                 </strong>
//               </div>
//             </div>

//             {/* ACTIONS */}
//             <div className="bet-action-grid">
//               <button
//                 type="button"
//                 onClick={
//                   handleUndo
//                 }
//                 disabled={
//                   !bettingOpen ||
//                   betActions.length ===
//                     0
//                 }
//               >
//                 ↶ Undo
//               </button>

//               <button
//                 type="button"
//                 onClick={
//                   handleClear
//                 }
//                 disabled={
//                   !bettingOpen ||
//                   betActions.length ===
//                     0
//                 }
//               >
//                 ✕ Clear
//               </button>

//               <button
//                 type="button"
//                 onClick={
//                   handleRepeat
//                 }
//                 disabled={
//                   !bettingOpen ||
//                   lastSubmittedActions.length ===
//                     0
//                 }
//               >
//                 ⟳ Repeat
//               </button>

//               <button
//                 type="button"
//                 onClick={
//                   handleDouble
//                 }
//                 disabled={
//                   !bettingOpen ||
//                   (betActions.length ===
//                     0 &&
//                     committedActions.length ===
//                       0)
//                 }
//               >
//                 2× Double
//               </button>
//             </div>

//             {/* CONFIRM */}
//             <button
//               type="button"
//               className="confirm-bets-button"
//               onClick={
//                 handlePlaceBets
//               }
//               disabled={
//                 !bettingOpen ||
//                 placingBets ||
//                 stagedGroups.length ===
//                   0 ||
//                 invalidMinGroups.length >
//                   0 ||
//                 invalidMaxGroups.length >
//                   0 ||
//                 stagedTotal >
//                   Number(
//                     user?.wallet ||
//                       0
//                   )
//               }
//             >
//               {placingBets
//                 ? "CONFIRMING..."
//                 : `CONFIRM BETS · 🪙 ${stagedTotal.toLocaleString()}`}
//             </button>

//             {invalidMinGroups.length >
//               0 && (
//               <div className="bet-warning">
//                 Add more chips:
//                 minimum {minBet}{" "}
//                 per position.
//               </div>
//             )}

//             {invalidMaxGroups.length >
//               0 && (
//               <div className="bet-warning">
//                 Maximum{" "}
//                 {maxBet} coins
//                 per position.
//               </div>
//             )}
//           </aside>
//         </section>
//       </main>

//       {/* RESULT */}
//       {roundOutcome?.visible && (
//         <div
//           className="round-result-overlay"
//           onClick={() =>
//             setRoundOutcome(
//               null
//             )
//           }
//         >
//           <div
//             className="round-result-card"
//             onClick={(
//               event
//             ) =>
//               event.stopPropagation()
//             }
//           >
//             <span className="result-kicker">
//               ROUND #
//               {
//                 roundOutcome.roundNo
//               }{" "}
//               RESULT
//             </span>

//             <div
//               className={`result-number result-${getNumberColor(
//                 roundOutcome.winningNumber
//               )}`}
//             >
//               {
//                 roundOutcome.winningNumber
//               }
//             </div>

//             {roundOutcome.settlementPending ? (
//               <>
//                 <h2>
//                   WINNING NUMBER
//                 </h2>

//                 <p>
//                   Ball settled.
//                   Final settlement
//                   completes at
//                   0 seconds.
//                 </p>
//               </>
//             ) : roundOutcome.playerBetCount >
//               0 ? (
//               roundOutcome.totalWin >
//               0 ? (
//                 <>
//                   <h2>
//                     YOU WIN
//                   </h2>

//                   <strong className="winning-coin-result">
//                     + 🪙{" "}
//                     {roundOutcome.totalWin.toLocaleString()}{" "}
//                     Winning Coins
//                   </strong>

//                   <p>
//                     Winning coins
//                     are ready as a
//                     pending claim
//                     with your Shop.
//                   </p>
//                 </>
//               ) : (
//                 <>
//                   <h2>
//                     ROUND
//                     COMPLETE
//                   </h2>

//                   <p>
//                     Next betting
//                     round is
//                     already open.
//                   </p>
//                 </>
//               )
//             ) : (
//               <>
//                 <h2>
//                   WINNING NUMBER
//                 </h2>

//                 <p>
//                   No bet was
//                   placed in this
//                   round.
//                 </p>
//               </>
//             )}

//             <button
//               type="button"
//               onClick={() =>
//                 setRoundOutcome(
//                   null
//                 )
//               }
//             >
//               CONTINUE
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Game;









// import React, {
//   useCallback,
//   useEffect,
//   useMemo,
//   useRef,
//   useState
// } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";

// import RouletteWheel3D from "./RouletteWheel3D";
// import authService from "../services/authService";
// import gameService from "../services/gameService";
// import { BET_TYPES, getNumberColor } from "../utils/gameLogic";
// import { sounds } from "../utils/audio";
// import "./Game.css";

// const CHIP_VALUES = [10, 50, 100, 500, 1000];

// const THEMES = [
//   { id: "classic", name: "Classic Green" },
//   { id: "royal", name: "Royal Black Gold" },
//   { id: "neon", name: "Neon Blue" },
//   { id: "ruby", name: "Ruby Casino" }
// ];

// const PRECISION_MODES = {
//   SINGLE: 1,
//   SPLIT: 2,
//   STREET: 3,
//   CORNER: 4,
//   SIX_LINE: 6
// };

// const NUMBER_ROWS = [
//   [3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36],
//   [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35],
//   [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34]
// ];

// const asSortedNumbers = (value) => {
//   if (Array.isArray(value)) {
//     return [...value]
//       .map(Number)
//       .sort((a, b) => a - b);
//   }

//   const text = String(value ?? "").trim();

//   if (text.startsWith("[") && text.endsWith("]")) {
//     try {
//       const parsed = JSON.parse(text);

//       if (Array.isArray(parsed)) {
//         return parsed
//           .map(Number)
//           .sort((a, b) => a - b);
//       }
//     } catch (error) {
//       return [];
//     }
//   }

//   if (text.includes(",")) {
//     return text
//       .split(",")
//       .map((item) => Number(item.trim()))
//       .filter(Number.isFinite)
//       .sort((a, b) => a - b);
//   }

//   const number = Number(text);

//   return Number.isFinite(number)
//     ? [number]
//     : [];
// };

// const canonicalValue = (value) => {
//   if (Array.isArray(value)) {
//     return JSON.stringify(
//       [...value]
//         .map(Number)
//         .sort((a, b) => a - b)
//     );
//   }

//   return String(value);
// };

// const betKey = (bet) =>
//   `${bet.type}:${canonicalValue(bet.value)}`;

// const aggregateBets = (actions) => {
//   const map = new Map();

//   actions.forEach((action) => {
//     const key = betKey(action);
//     const existing = map.get(key);

//     if (existing) {
//       existing.amount += Number(
//         action.amount || 0
//       );
//     } else {
//       map.set(key, {
//         ...action,
//         amount: Number(
//           action.amount || 0
//         )
//       });
//     }
//   });

//   return Array.from(map.values());
// };

// const displayValue = (type, value) => {
//   if (
//     [
//       "RED",
//       "BLACK",
//       "EVEN",
//       "ODD",
//       "LOW",
//       "HIGH"
//     ].includes(type)
//   ) {
//     return String(value)
//       .replace("LOW", "1-18")
//       .replace("HIGH", "19-36");
//   }

//   if (type.startsWith("COLUMN_")) {
//     return `${type.replace(
//       "COLUMN_",
//       ""
//     )} Column`;
//   }

//   if (type.startsWith("DOZEN_")) {
//     const index = Number(
//       type.replace("DOZEN_", "")
//     );

//     return index === 1
//       ? "1-12"
//       : index === 2
//       ? "13-24"
//       : "25-36";
//   }

//   const numbers =
//     asSortedNumbers(value);

//   return numbers.length
//     ? numbers.join(" • ")
//     : String(value);
// };

// const historyToAction = (bet) => ({
//   type: String(
//     bet.bet_type || "SINGLE"
//   ),

//   value: [
//     "SINGLE",
//     "SPLIT",
//     "STREET",
//     "CORNER",
//     "SIX_LINE"
//   ].includes(bet.bet_type)
//     ? asSortedNumbers(
//         bet.bet_value
//       ).length === 1
//       ? asSortedNumbers(
//           bet.bet_value
//         )[0]
//       : asSortedNumbers(
//           bet.bet_value
//         )
//     : String(bet.bet_value),

//   name: `${
//     BET_TYPES[bet.bet_type]?.name ||
//     bet.bet_type
//   } ${displayValue(
//     bet.bet_type,
//     bet.bet_value
//   )}`,

//   amount: Number(
//     bet.amount || 0
//   )
// });

// const isValidPrecision = (
//   type,
//   selected
// ) => {
//   const numbers = [
//     ...selected
//   ]
//     .map(Number)
//     .sort((a, b) => a - b);

//   if (type === "SINGLE") {
//     return (
//       numbers.length === 1 &&
//       numbers[0] >= 0 &&
//       numbers[0] <= 36
//     );
//   }

//   if (type === "SPLIT") {
//     if (numbers.length !== 2) {
//       return false;
//     }

//     const [a, b] = numbers;

//     if (a === 0) {
//       return [1, 2, 3].includes(b);
//     }

//     const vertical =
//       b - a === 3;

//     const horizontal =
//       b - a === 1 &&
//       Math.floor((a - 1) / 3) ===
//         Math.floor((b - 1) / 3);

//     return (
//       vertical ||
//       horizontal
//     );
//   }

//   if (type === "STREET") {
//     if (numbers.length !== 3) {
//       return false;
//     }

//     const [a, b, c] = numbers;

//     if (a === 0) {
//       return (
//         (b === 1 && c === 2) ||
//         (b === 2 && c === 3)
//       );
//     }

//     return (
//       a >= 1 &&
//       a <= 34 &&
//       a % 3 === 1 &&
//       b === a + 1 &&
//       c === a + 2
//     );
//   }

//   if (type === "CORNER") {
//     if (numbers.length !== 4) {
//       return false;
//     }

//     const [a, b, c, d] =
//       numbers;

//     if (a === 0) {
//       return (
//         b === 1 &&
//         c === 2 &&
//         d === 3
//       );
//     }

//     return (
//       a >= 1 &&
//       a <= 32 &&
//       a % 3 !== 0 &&
//       b === a + 1 &&
//       c === a + 3 &&
//       d === a + 4
//     );
//   }

//   if (type === "SIX_LINE") {
//     if (numbers.length !== 6) {
//       return false;
//     }

//     const [
//       a,
//       b,
//       c,
//       d,
//       e,
//       f
//     ] = numbers;

//     return (
//       a >= 1 &&
//       a <= 31 &&
//       a % 3 === 1 &&
//       b === a + 1 &&
//       c === a + 2 &&
//       d === a + 3 &&
//       e === a + 4 &&
//       f === a + 5
//     );
//   }

//   return false;
// };

// const Game = () => {
//   const navigate = useNavigate();

//   // Computer session (separate from legacy Player auth)
//   const computerToken = sessionStorage.getItem("computer_token");
//   let computer = null;

//   try {
//     const storedComputer = sessionStorage.getItem("computer");
//     if (storedComputer) computer = JSON.parse(storedComputer);
//   } catch (error) {
//     console.error("Invalid Computer Session:", error);
//     sessionStorage.removeItem("computer_token");
//     sessionStorage.removeItem("computer");
//   }

//   const isComputerSession = Boolean(computerToken) && Boolean(computer);

//   const [user, setUser] =
//     useState(() =>
//       authService.getCurrentUser()
//     );

//   const [
//     currentRound,
//     setCurrentRound
//   ] = useState(null);

//   const [
//     recentResults,
//     setRecentResults
//   ] = useState([]);

//   const [
//     history,
//     setHistory
//   ] = useState([]);

//   const [
//     loading,
//     setLoading
//   ] = useState(true);

//   const [
//     selectedChip,
//     setSelectedChip
//   ] = useState(10);

//   const [
//     precisionMode,
//     setPrecisionMode
//   ] = useState("SINGLE");

//   const [
//     precisionSelection,
//     setPrecisionSelection
//   ] = useState([]);

//   const [
//     betActions,
//     setBetActions
//   ] = useState([]);

//   const [
//     committedActions,
//     setCommittedActions
//   ] = useState([]);

//   const [
//     lastSubmittedActions,
//     setLastSubmittedActions
//   ] = useState([]);

//   const [
//     placingBets,
//     setPlacingBets
//   ] = useState(false);

//   const [
//     wheelResult,
//     setWheelResult
//   ] = useState(null);

//   const [
//     wheelSettled,
//     setWheelSettled
//   ] = useState(false);

//   const [
//     roundOutcome,
//     setRoundOutcome
//   ] = useState(null);

//   const [
//     theme,
//     setTheme
//   ] = useState(
//     () =>
//       localStorage.getItem(
//         "casinoPlayerTheme"
//       ) || "classic"
//   );

//   const [
//     pendingTheme,
//     setPendingTheme
//   ] = useState(null);

//   const [
//     soundEnabled,
//     setSoundEnabled
//   ] = useState(
//     () =>
//       localStorage.getItem(
//         "casinoSoundEnabled"
//       ) !== "false"
//   );

//   const currentRoundRef =
//     useRef(null);

//   const previousPhaseRef =
//     useRef(null);

//   const lastCountdownBeepRef =
//     useRef(null);

//   const outcomeRef =
//     useRef(null);

//   const bettingOpen =
//     currentRound?.betting_open ===
//     true;

//   const phase =
//     currentRound?.phase ||
//     (bettingOpen
//       ? "BETTING"
//       : "SPINNING");

//   const bettingRemaining =
//     Number(
//       currentRound
//         ?.betting_remaining_seconds ||
//         0
//     );

//   const phaseRemaining =
//     Number(
//       currentRound
//         ?.phase_remaining_seconds ||
//         0
//     );

//   const totalSeconds =
//     Number(
//       currentRound?.total_seconds ||
//         60
//     );

//   const minBet =
//     Number(
//       currentRound?.min_bet ||
//         0
//     );

//   const maxBet =
//     Number(
//       currentRound?.max_bet ||
//         0
//     );

//   // Backend exposes the already-locked roulette target only
//   // near the end of the current SPINNING phase.
//   // It is used only to settle the wheel; the wheel component
//   // reveals the number only after the ball has actually stopped.
//   const spinTarget =
//     currentRound?.spin_target !== null &&
//     currentRound?.spin_target !== undefined &&
//     Number.isInteger(
//       Number(
//         currentRound.spin_target
//       )
//     )
//       ? Number(
//           currentRound.spin_target
//         )
//       : null;

//   const wheelTarget =
//     phase === "SPINNING"
//       ? spinTarget
//       : null;

//   const stagedGroups =
//     useMemo(
//       () =>
//         aggregateBets(
//           betActions
//         ),
//       [betActions]
//     );

//   const tableGroups =
//     useMemo(
//       () =>
//         aggregateBets([
//           ...committedActions,
//           ...betActions
//         ]),
//       [
//         committedActions,
//         betActions
//       ]
//     );

//   const stagedTotal =
//     useMemo(
//       () =>
//         betActions.reduce(
//           (sum, item) =>
//             sum +
//             Number(
//               item.amount || 0
//             ),
//           0
//         ),
//       [betActions]
//     );

//   const confirmedTotal =
//     useMemo(
//       () =>
//         committedActions.reduce(
//           (sum, item) =>
//             sum +
//             Number(
//               item.amount || 0
//             ),
//           0
//         ),
//       [committedActions]
//     );

//   const pendingWinningCoins =
//     useMemo(
//       () =>
//         history
//           .filter(
//             (bet) =>
//               bet.status ===
//                 "WIN" &&
//               bet.claim_status ===
//                 "PENDING"
//           )
//           .reduce(
//             (sum, bet) =>
//               sum +
//               Number(
//                 bet.win_amount ||
//                   0
//               ),
//             0
//           ),
//       [history]
//     );

//   const invalidMinGroups =
//     useMemo(
//       () =>
//         minBet > 0
//           ? stagedGroups.filter(
//               (bet) =>
//                 bet.amount <
//                 minBet
//             )
//           : [],
//       [
//         stagedGroups,
//         minBet
//       ]
//     );

//   const invalidMaxGroups =
//     useMemo(
//       () =>
//         maxBet > 0
//           ? stagedGroups.filter(
//               (bet) =>
//                 bet.amount >
//                 maxBet
//             )
//           : [],
//       [
//         stagedGroups,
//         maxBet
//       ]
//     );

//   const refreshProfile =
//     useCallback(
//       async () => {
//         if (isComputerSession) return;

//         try {
//           const response =
//             await authService.getProfile();

//           if (response?.user) {
//             setUser(
//               response.user
//             );
//           } else {
//             setUser(
//               authService.getCurrentUser()
//             );
//           }
//         } catch (error) {
//           // Session interceptor
//         }
//       },
//       [isComputerSession]
//     );

//   const refreshHistory =
//     useCallback(
//       async () => {
//         if (isComputerSession) {
//           setHistory([]);
//           return [];
//         }

//         try {
//           const response =
//             await gameService.getHistory();

//           const rows =
//             Array.isArray(
//               response?.history
//             )
//               ? response.history
//               : [];

//           setHistory(rows);

//           return rows;
//         } catch (error) {
//           return [];
//         }
//       },
//       [isComputerSession]
//     );

//   const refreshRecentResults =
//     useCallback(
//       async () => {
//         try {
//           const response =
//             await gameService.getRecentResults(
//               10
//             );

//           const rows =
//             Array.isArray(
//               response?.results
//             )
//               ? response.results
//               : [];

//           setRecentResults(rows);

//           return rows;
//         } catch (error) {
//           return [];
//         }
//       },
//       []
//     );

//   const handleCompletedRound =
//     useCallback(
//       async (
//         completedRoundId
//       ) => {
//         const [
//           results,
//           rows
//         ] =
//           await Promise.all([
//             refreshRecentResults(),
//             refreshHistory(),
//             refreshProfile()
//           ]);

//         const completed =
//           results.find(
//             (item) =>
//               Number(item.id) ===
//               Number(
//                 completedRoundId
//               )
//           );

//         if (!completed) {
//           return;
//         }

//         const playerRoundBets =
//           rows.filter(
//             (bet) =>
//               Number(
//                 bet.round_id
//               ) ===
//               Number(
//                 completedRoundId
//               )
//           );

//         const totalWin =
//           playerRoundBets
//             .filter(
//               (bet) =>
//                 bet.status ===
//                 "WIN"
//             )
//             .reduce(
//               (sum, bet) =>
//                 sum +
//                 Number(
//                   bet.win_amount ||
//                     0
//                 ),
//               0
//             );

//         const outcome = {
//           roundId:
//             Number(
//               completed.id
//             ),

//           roundNo:
//             completed.round_no,

//           winningNumber:
//             Number(
//               completed.winning_number
//             ),

//           playerBetCount:
//             playerRoundBets.length,

//           totalWin,

//           settlementPending:
//             false,

//           visible: false
//         };

//         outcomeRef.current =
//           outcome;

//         setRoundOutcome(
//           outcome
//         );

//         setWheelResult(
//           Number(
//             completed.winning_number
//           )
//         );
//       },
//       [
//         refreshHistory,
//         refreshProfile,
//         refreshRecentResults
//       ]
//     );

//   const fetchCurrentRound =
//     useCallback(
//       async () => {
//         try {
//           const response =
//             await gameService.getCurrentRound();

//           const nextRound =
//             response?.round ||
//             response?.current_round ||
//             null;

//           if (!nextRound) {
//             return null;
//           }

//           const previousRound =
//             currentRoundRef.current;

//           if (
//             previousRound &&
//             Number(
//               previousRound.id
//             ) !==
//               Number(
//                 nextRound.id
//               )
//           ) {
//             // A new backend round must start visually fresh at 60s.
//             // Do not let the previous wheel/result animation consume
//             // any seconds from the new betting round.
//             setWheelSettled(false);

//             setWheelResult(
//               null
//             );

//             // The previous round result is only for the old round.
//             // Close it exactly when the fresh 60-second round begins.
//             outcomeRef.current =
//               null;

//             setRoundOutcome(
//               null
//             );

//             setBetActions([]);

//             setCommittedActions(
//               []
//             );

//             setPrecisionSelection(
//               []
//             );

//             if (pendingTheme) {
//               setTheme(
//                 pendingTheme
//               );

//               localStorage.setItem(
//                 "casinoPlayerTheme",
//                 pendingTheme
//               );

//               setPendingTheme(
//                 null
//               );
//             }

//             handleCompletedRound(
//               previousRound.id
//             );
//           }

//           currentRoundRef.current =
//             nextRound;

//           setCurrentRound(
//             nextRound
//           );

//           return nextRound;
//         } catch (error) {
//           if (
//             error.response
//               ?.status === 404
//           ) {
//             setCurrentRound(
//               null
//             );
//           }

//           return null;
//         }
//       },
//       [
//         handleCompletedRound,
//         pendingTheme
//       ]
//     );

//   useEffect(() => {
//     sounds.setEnabled(
//       soundEnabled
//     );

//     localStorage.setItem(
//       "casinoSoundEnabled",
//       soundEnabled
//         ? "true"
//         : "false"
//     );
//   }, [soundEnabled]);

//   useEffect(() => {
//     const load = async () => {
//       setLoading(true);

//       const [
//         round,
//         results,
//         rows
//       ] =
//         await Promise.all([
//           fetchCurrentRound(),
//           refreshRecentResults(),
//           refreshHistory(),
//           refreshProfile()
//         ]);

//       if (round) {
//         currentRoundRef.current =
//           round;

//         const pendingThisRound =
//           rows
//             .filter(
//               (bet) =>
//                 Number(
//                   bet.round_id
//                 ) ===
//                   Number(
//                     round.id
//                   ) &&
//                 bet.status ===
//                   "PENDING"
//             )
//             .map(
//               historyToAction
//             );

//         setCommittedActions(
//           pendingThisRound
//         );
//       }

//       if (
//         round?.phase !==
//           "SPINNING" &&
//         results.length
//       ) {
//         setWheelResult(
//           Number(
//             results[0]
//               .winning_number
//           )
//         );
//       }

//       setLoading(false);
//     };

//     load();

//     const interval =
//       setInterval(
//         fetchCurrentRound,
//         1000
//       );

//     const historyInterval =
//       setInterval(
//         refreshHistory,
//         5000
//       );

//     return () => {
//       clearInterval(
//         interval
//       );

//       clearInterval(
//         historyInterval
//       );
//     };
//   }, [
//     fetchCurrentRound,
//     refreshHistory,
//     refreshProfile,
//     refreshRecentResults
//   ]);

//   useEffect(() => {
//     if (
//       previousPhaseRef.current !==
//       phase
//     ) {
//       if (
//         phase ===
//         "SPINNING"
//       ) {
//         setWheelSettled(
//           false
//         );

//         setWheelResult(
//           null
//         );

//         setRoundOutcome(
//           null
//         );

//         outcomeRef.current =
//           null;

//         setPrecisionSelection(
//           []
//         );

//         sounds.playNoMoreBetsSound();
//       }

//       previousPhaseRef.current =
//         phase;
//     }
//   }, [phase]);

//   useEffect(() => {
//     if (
//       phase === "BETTING" &&
//       bettingRemaining > 0 &&
//       bettingRemaining <= 5 &&
//       lastCountdownBeepRef.current !==
//         bettingRemaining
//     ) {
//       lastCountdownBeepRef.current =
//         bettingRemaining;

//       sounds.playCountdownSound();
//     }
//   }, [
//     phase,
//     bettingRemaining
//   ]);

//   useEffect(() => {
//     if (
//       phase !== "SPINNING" ||
//       wheelSettled
//     ) {
//       return undefined;
//     }

//     const interval =
//       setInterval(() => {
//         sounds.playSpinTickSound();
//       }, 360);

//     return () =>
//       clearInterval(
//         interval
//       );
//   }, [
//     phase,
//     wheelSettled
//   ]);

//   const getTableAmount =
//     useCallback(
//       (
//         type,
//         value
//       ) => {
//         const key =
//           `${type}:${canonicalValue(
//             value
//           )}`;

//         const found =
//           tableGroups.find(
//             (bet) =>
//               betKey(bet) ===
//               key
//           );

//         return Number(
//           found?.amount ||
//             0
//         );
//       },
//       [tableGroups]
//     );

//   const addBetAction =
//     useCallback(
//       (
//         type,
//         value,
//         name
//       ) => {
//         if (isComputerSession) {
//           return;
//         }

//         if (!bettingOpen) {
//           toast.warning(
//             "No more bets. Wait for the next round."
//           );

//           return;
//         }

//         const nextTotal =
//           stagedTotal +
//           selectedChip;

//         const wallet =
//           Number(
//             user?.wallet ||
//               0
//           );

//         if (
//           nextTotal >
//           wallet
//         ) {
//           toast.error(
//             "Insufficient playable wallet balance."
//           );

//           return;
//         }

//         setBetActions(
//           (previous) => [
//             ...previous,
//             {
//               type,
//               value,
//               name,
//               amount:
//                 selectedChip
//             }
//           ]
//         );

//         sounds.playChipSound();
//       },
//       [
//         bettingOpen,
//         selectedChip,
//         stagedTotal,
//         user?.wallet,
//         isComputerSession
//       ]
//     );


//   // Visual preview only for connected-number modes.
//   // This changes table highlighting only; wheel/spin code is untouched.
//   const previewConnectedNumbers = (number) => {
//     const n = Number(number);

//     if (!Number.isInteger(n) || n < 1 || n > 36) {
//       return [n];
//     }

//     const streetStart =
//       Math.floor((n - 1) / 3) * 3 + 1;

//     if (precisionMode === "STREET") {
//       return [
//         streetStart,
//         streetStart + 1,
//         streetStart + 2
//       ];
//     }

//     if (precisionMode === "SIX_LINE") {
//       const firstStreet =
//         streetStart >= 34
//           ? 31
//           : streetStart;

//       return [
//         firstStreet,
//         firstStreet + 1,
//         firstStreet + 2,
//         firstStreet + 3,
//         firstStreet + 4,
//         firstStreet + 5
//       ];
//     }

//     return [n];
//   };

//   const handleNumberClick =
//     (number) => {
//       if (isComputerSession) return;

//       if (!bettingOpen) {
//         toast.warning(
//           "Betting is closed."
//         );

//         return;
//       }

//       if (
//         precisionMode ===
//         "SINGLE"
//       ) {
//         addBetAction(
//           "SINGLE",
//           number,
//           `Number ${number}`
//         );

//         return;
//       }

//       if (
//         precisionMode === "STREET" ||
//         precisionMode === "SIX_LINE"
//       ) {
//         setPrecisionSelection(
//           previewConnectedNumbers(number)
//         );
//         return;
//       }

//       const required =
//         PRECISION_MODES[
//           precisionMode
//         ];

//       let updated =
//         precisionSelection.includes(
//           number
//         )
//           ? precisionSelection.filter(
//               (item) =>
//                 item !== number
//             )
//           : [
//               ...precisionSelection,
//               number
//             ];

//       if (
//         updated.length >
//         required
//       ) {
//         updated = [number];
//       }

//       setPrecisionSelection(
//         updated
//       );

//       if (
//         updated.length ===
//         required
//       ) {
//         if (
//           !isValidPrecision(
//             precisionMode,
//             updated
//           )
//         ) {
//           toast.error(
//             `Invalid ${
//               BET_TYPES[
//                 precisionMode
//               ]?.name ||
//               precisionMode
//             } selection.`
//           );

//           setPrecisionSelection(
//             []
//           );

//           return;
//         }

//         const sorted = [
//           ...updated
//         ].sort(
//           (a, b) => a - b
//         );

//         addBetAction(
//           precisionMode,
//           sorted,
//           `${
//             BET_TYPES[
//               precisionMode
//             ]?.name ||
//             precisionMode
//           } ${sorted.join("-")}`
//         );

//         setPrecisionSelection(
//           []
//         );
//       }
//     };

//   const addOutsideBet = (
//     type,
//     value,
//     label
//   ) => {
//     addBetAction(
//       type,
//       value,
//       label
//     );
//   };

//   const handleUndo = () => {
//     setBetActions(
//       (previous) =>
//         previous.slice(
//           0,
//           -1
//         )
//     );
//   };

//   const handleClear = () => {
//     setBetActions([]);

//     setPrecisionSelection(
//       []
//     );
//   };

//   const handleRepeat = () => {
//     if (isComputerSession) return;

//     if (
//       !bettingOpen ||
//       lastSubmittedActions.length ===
//         0
//     ) {
//       return;
//     }

//     const repeatTotal =
//       lastSubmittedActions.reduce(
//         (sum, item) =>
//           sum +
//           Number(
//             item.amount ||
//               0
//           ),
//         0
//       );

//     if (
//       repeatTotal >
//       Number(
//         user?.wallet ||
//           0
//       )
//     ) {
//       toast.error(
//         "Wallet balance is not enough to repeat the previous bet."
//       );

//       return;
//     }

//     setBetActions(
//       lastSubmittedActions.map(
//         (item) => ({
//           ...item
//         })
//       )
//     );

//     sounds.playChipSound();
//   };

//   const handleDouble = () => {
//     if (isComputerSession) return;

//     if (!bettingOpen) {
//       return;
//     }

//     const source =
//       betActions.length > 0
//         ? betActions
//         : committedActions;

//     if (
//       source.length === 0
//     ) {
//       return;
//     }

//     const additional =
//       source.reduce(
//         (sum, item) =>
//           sum +
//           Number(
//             item.amount ||
//               0
//           ),
//         0
//       );

//     if (
//       additional >
//       Number(
//         user?.wallet ||
//           0
//       )
//     ) {
//       toast.error(
//         "Wallet balance is not enough to double the bet."
//       );

//       return;
//     }

//     if (
//       betActions.length >
//       0
//     ) {
//       setBetActions(
//         (previous) =>
//           previous.map(
//             (item) => ({
//               ...item,
//               amount:
//                 Number(
//                   item.amount ||
//                     0
//                 ) * 2
//             })
//           )
//       );
//     } else {
//       setBetActions(
//         source.map(
//           (item) => ({
//             ...item
//           })
//         )
//       );
//     }

//     sounds.playChipSound();
//   };

//   const handlePlaceBets =
//     async () => {
//       if (isComputerSession) return;

//       if (
//         !currentRound ||
//         !bettingOpen ||
//         placingBets ||
//         stagedGroups.length ===
//           0
//       ) {
//         return;
//       }

//       if (
//         invalidMinGroups.length >
//         0
//       ) {
//         toast.error(
//           `Minimum bet per position is ${minBet}. Add more chips on highlighted positions.`
//         );

//         return;
//       }

//       if (
//         invalidMaxGroups.length >
//         0
//       ) {
//         toast.error(
//           `Maximum bet per position is ${maxBet}.`
//         );

//         return;
//       }

//       if (
//         stagedTotal >
//         Number(
//           user?.wallet ||
//             0
//         )
//       ) {
//         toast.error(
//           "Insufficient playable wallet balance."
//         );

//         return;
//       }

//       const payloadBets =
//         stagedGroups.map(
//           (bet) => ({
//             bet_type:
//               bet.type,

//             bet_value:
//               Array.isArray(
//                 bet.value
//               )
//                 ? JSON.stringify(
//                     bet.value
//                   )
//                 : String(
//                     bet.value
//                   ),

//             amount:
//               Number(
//                 bet.amount
//               )
//           })
//         );

//       try {
//         setPlacingBets(
//           true
//         );

//         const response =
//           await gameService.placeBets(
//             {
//               round_id:
//                 currentRound.id,

//               bets:
//                 payloadBets
//             }
//           );

//         if (
//           !response?.success
//         ) {
//           throw new Error(
//             response?.message ||
//               "Unable to place bets."
//           );
//         }

//         setCommittedActions(
//           (previous) => [
//             ...previous,
//             ...stagedGroups
//           ]
//         );

//         setLastSubmittedActions(
//           betActions.map(
//             (item) => ({
//               ...item
//             })
//           )
//         );

//         setBetActions([]);

//         setPrecisionSelection(
//           []
//         );

//         await refreshProfile();

//         await refreshHistory();

//         toast.success(
//           `Bets confirmed: ${Number(
//             response.total_amount ||
//               stagedTotal
//           ).toLocaleString()} coins`
//         );
//       } catch (error) {
//         toast.error(
//           error.response?.data
//             ?.message ||
//             error.message ||
//             "Unable to place bets."
//         );

//         await fetchCurrentRound();
//       } finally {
//         setPlacingBets(
//           false
//         );
//       }
//     };

//   const handleThemeChange =
//     (event) => {
//       const nextTheme =
//         event.target.value;

//       if (
//         phase ===
//         "SPINNING"
//       ) {
//         setPendingTheme(
//           nextTheme
//         );

//         toast.info(
//           "Theme will change on the next round."
//         );

//         return;
//       }

//       setTheme(
//         nextTheme
//       );

//       localStorage.setItem(
//         "casinoPlayerTheme",
//         nextTheme
//       );
//     };

//   const handleWheelSettled =
//     () => {
//       setWheelSettled(
//         true
//       );

//       sounds.playBallSettleSound();

//       const activeRound =
//         currentRoundRef.current;

//       const target =
//         Number(
//           activeRound
//             ?.spin_target
//         );

//       // The backend has already locked this target and betting is closed.
//       // Show it NOW, exactly after the ball has stopped.
//       if (
//         !activeRound ||
//         !Number.isInteger(
//           target
//         ) ||
//         target < 0 ||
//         target > 36
//       ) {
//         return;
//       }

//       const provisionalOutcome = {
//         roundId:
//           Number(
//             activeRound.id
//           ),

//         roundNo:
//           activeRound.round_no,

//         winningNumber:
//           target,

//         // Final bet settlement happens server-side at 0 sec.
//         // Until then we only reveal the winning number.
//         playerBetCount:
//           0,

//         totalWin:
//           0,

//         settlementPending:
//           true,

//         visible:
//           true
//       };

//       outcomeRef.current =
//         provisionalOutcome;

//       setRoundOutcome(
//         provisionalOutcome
//       );
//     };

//   const handleLogout = () => {
//     if (isComputerSession) {
//       sessionStorage.removeItem("computer_token");
//       sessionStorage.removeItem("computer");
//       navigate("/login", { replace: true });
//       return;
//     }

//     authService.logout();
//     navigate("/login", { replace: true });
//   };

//   const timerValue =
//     phase === "BETTING"
//       ? bettingRemaining
//       : phaseRemaining;

//   const timerMax =
//     phase === "BETTING"
//       ? Number(
//           currentRound
//             ?.betting_seconds ||
//             40
//         )
//       : Number(
//           currentRound
//             ?.spin_result_seconds ||
//             20
//         );

//   const timerProgress =
//     timerMax > 0
//       ? Math.max(
//           0,
//           Math.min(
//             1,
//             timerValue /
//               timerMax
//           )
//         )
//       : 0;

//   if (loading) {
//     return (
//       <div className="roulette-loading-screen">
//         <div className="roulette-loading-wheel">
//           ♛
//         </div>

//         <div>
//           Preparing Roulette
//           Table...
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div
//       className={`casino-game-shell theme-${theme}`}
//     >
// 
//       {/* HEADER */}
//       <header className="casino-game-header">
//         <div className="casino-brand-block">
//           <div className="casino-brand-mark">
//             0
//           </div>

//           <div>
//             <strong>
//               EUROPEAN ROULETTE
//             </strong>

//             <span>
//               Live 60 Second
//               Round
//             </span>
//           </div>
//         </div>

//         <div className="casino-header-round">
//           <span>
//             ROUND
//           </span>

//           <strong>
//             #
//             {currentRound
//               ?.round_no ||
//               "--"}
//           </strong>

//           <em
//             className={
//               phase ===
//               "BETTING"
//                 ? "phase-open"
//                 : "phase-closed"
//             }
//           >
//             {phase ===
//             "BETTING"
//               ? "BETTING OPEN"
//               : "NO MORE BETS"}
//           </em>
//         </div>

//         <div className="casino-player-strip">
//           <div className="casino-balance-card">
//             <span>
//               {isComputerSession ? "CREDITS" : "PLAYABLE"}
//             </span>

//             <strong>
//               🪙{" "}
//               {Number(
//                 isComputerSession
//                   ? computer?.current_balance || 0
//                   : user?.wallet || 0
//               ).toLocaleString()}
//             </strong>
//           </div>

//           <div className="casino-balance-card winning-balance">
//             <span>
//               WINNING COINS
//             </span>

//             <strong>
//               🏆{" "}
//               {pendingWinningCoins.toLocaleString()}
//             </strong>
//           </div>

//           <label className="theme-select-wrap">
//             <span>
//               THEME
//             </span>

//             <select
//               value={
//                 pendingTheme ||
//                 theme
//               }
//               onChange={
//                 handleThemeChange
//               }
//             >
//               {THEMES.map(
//                 (item) => (
//                   <option
//                     key={
//                       item.id
//                     }
//                     value={
//                       item.id
//                     }
//                   >
//                     {item.name}
//                   </option>
//                 )
//               )}
//             </select>
//           </label>

//           <button
//             type="button"
//             className="casino-icon-button"
//             onClick={() =>
//               setSoundEnabled(
//                 (value) =>
//                   !value
//               )
//             }
//             title={
//               soundEnabled
//                 ? "Mute sounds"
//                 : "Enable sounds"
//             }
//           >
//             {soundEnabled
//               ? "🔊"
//               : "🔇"}
//           </button>

//           <button
//             type="button"
//             className="casino-icon-button"
//             onClick={() =>
//               navigate(
//                 isComputerSession
//                   ? "/computer-dashboard"
//                   : "/dashboard"
//               )
//             }
//             title="Dashboard"
//           >
//             ⌂
//           </button>

//           <button
//             type="button"
//             className="casino-logout-button"
//             onClick={
//               handleLogout
//             }
//           >
//             {isComputerSession
//               ? computer?.computer_code || "Computer"
//               : user?.username || "Player"}{" "}
//             · Logout
//           </button>
//         </div>
//       </header>

//       {isComputerSession && (
//         <div style={{
//           padding: "8px 16px",
//           textAlign: "center",
//           background: "rgba(212, 175, 55, 0.10)",
//           borderBottom: "1px solid rgba(212, 175, 55, 0.25)",
//           color: "#D4AF37",
//           fontSize: "12px",
//           fontWeight: 800,
//           letterSpacing: "0.08em"
//         }}>
//           COMPUTER VIEW · TABLE CONTROLS ARE READ-ONLY
//         </div>
//       )}

//       {/* MAIN */}
//       <main className="casino-game-content">
//         {/* WHEEL + TIMER */}
//         <section className="casino-stage-grid">
//           <div className="roulette-stage-card">
//             <div className="stage-light stage-light-left" />

//             <div className="stage-light stage-light-right" />

// <RouletteWheel3D
//   key={
//     currentRound?.id ||
//     "no-round"
//   }
//   winningNumber={wheelTarget}
//   isSpinning={
//     phase === "SPINNING" &&
//     wheelTarget === null
//   }
//   onSettled={handleWheelSettled}
// />
//           </div>

//           <aside className="round-console">
//             <div
//               className={`round-status-panel ${
//                 phase ===
//                 "BETTING"
//                   ? "status-open"
//                   : "status-spin"
//               }`}
//             >
//               <div
//                 className="round-timer-ring"
//                 style={{
//                   "--timer-progress":
//                     `${
//                       timerProgress *
//                       360
//                     }deg`
//                 }}
//               >
//                 <div className="round-timer-inner">
//                   <strong>
//                     {timerValue}
//                   </strong>

//                   <span>
//                     SEC
//                   </span>
//                 </div>
//               </div>

//               <div className="round-status-copy">
//                 <span>
//                   {phase ===
//                   "BETTING"
//                     ? "PLACE YOUR BETS"
//                     : "NO MORE BETS"}
//                 </span>

//                 <strong>
//                   {phase ===
//                   "BETTING"
//                     ? "Betting is open"
//                     : wheelSettled
//                     ? "Winning number displayed"
//                     : "Wheel is spinning"}
//                 </strong>

//                 <small>
//                   {phase ===
//                   "BETTING"
//                     ? `${bettingRemaining}s left to confirm bets`
//                     : wheelSettled
//                     ? `Next round in ${phaseRemaining}s`
//                     : `Result phase · ${phaseRemaining}s`}
//                 </small>
//               </div>
//             </div>

//             {/* RECENT RESULTS */}
//             <div className="recent-results-card">
//               <div className="console-section-title">
//                 <span>
//                   RECENT RESULTS
//                 </span>

//                 <button
//                   type="button"
//                   onClick={() =>
//                     navigate(
//                       isComputerSession
//                         ? "/computer-history"
//                         : "/bet-history"
//                     )
//                   }
//                 >
//                   History
//                 </button>
//               </div>

//               <div className="recent-result-row">
//                 {recentResults.length ===
//                 0 ? (
//                   <span className="empty-result">
//                     No completed
//                     rounds yet
//                   </span>
//                 ) : (
//                   recentResults
//                     .slice(
//                       0,
//                       10
//                     )
//                     .map(
//                       (item) => (
//                         <div
//                           key={
//                             item.id
//                           }
//                           className={`recent-number recent-${getNumberColor(
//                             Number(
//                               item.winning_number
//                             )
//                           )}`}
//                           title={`Round #${item.round_no}`}
//                         >
//                           {
//                             item.winning_number
//                           }
//                         </div>
//                       )
//                     )
//                 )}
//               </div>
//             </div>

//             {/* ROUND INFO */}
//             <div className="round-info-grid">
//               <div>
//                 <span>
//                   Round Time
//                 </span>

//                 <strong>
//                   {totalSeconds}s
//                 </strong>
//               </div>

//               <div>
//                 <span>
//                   Betting
//                 </span>

//                 <strong>
//                   {currentRound
//                     ?.betting_seconds ||
//                     40}
//                   s
//                 </strong>
//               </div>

//               <div>
//                 <span>
//                   Min /
//                   Position
//                 </span>

//                 <strong>
//                   {minBet ||
//                     "--"}
//                 </strong>
//               </div>

//               <div>
//                 <span>
//                   Max /
//                   Position
//                 </span>

//                 <strong>
//                   {maxBet ||
//                     "--"}
//                 </strong>
//               </div>
//             </div>
//           </aside>
//         </section>

//         {/* BETTING TABLE + SLIP */}
//         <section className="betting-layout">
//           <div
//             className={`roulette-table-card ${
//               !bettingOpen
//                 ? "table-locked"
//                 : ""
//             }`}
//           >
//             {/* BET MODE */}
//             <div className="table-toolbar">
//               <div>
//                 <span className="eyebrow">
//                   BET MODE
//                 </span>

//                 <div className="precision-mode-row">
//                   {Object.keys(
//                     PRECISION_MODES
//                   ).map(
//                     (mode) => (
//                       <button
//                         key={
//                           mode
//                         }
//                         type="button"
//                         className={
//                           precisionMode ===
//                           mode
//                             ? "active"
//                             : ""
//                         }
//                         onClick={() => {
//                           setPrecisionMode(
//                             mode
//                           );

//                           setPrecisionSelection(
//                             []
//                           );
//                         }}
//                         disabled={
//                           !bettingOpen
//                         }
//                       >
//                         {BET_TYPES[
//                           mode
//                         ]?.name ||
//                           mode}
//                       </button>
//                     )
//                   )}
//                 </div>
//               </div>

//               <div className="precision-help">
//                 {precisionMode ===
//                 "SINGLE"
//                   ? "Click any number to place a chip"
//                   : `Select ${
//                       PRECISION_MODES[
//                         precisionMode
//                       ]
//                     } connected numbers`}

//                 {precisionSelection.length >
//                   0 && (
//                   <strong>
//                     {precisionSelection.join(
//                       " · "
//                     )}
//                   </strong>
//                 )}
//               </div>
//             </div>

//             {/* TABLE CHIP RACK */}
//             <div className="table-chip-rack">
//               <span className="table-chip-rack-label">
//                 SELECT CHIP
//               </span>

//               <div className="table-chip-rack-coins">
//                 {CHIP_VALUES.map((chip) => (
//                   <button
//                     key={chip}
//                     type="button"
//                     className={`casino-chip chip-${chip} ${
//                       selectedChip === chip ? "selected" : ""
//                     }`}
//                     onClick={() => {
//                       setSelectedChip(chip);
//                       sounds.playChipSound();
//                     }}
//                     disabled={!bettingOpen}
//                   >
//                     {chip >= 1000 ? `${chip / 1000}K` : chip}
//                   </button>
//                 ))}
//               </div>

//               <span className="table-chip-rack-copy">
//                 {minBet > 0 ? `MIN ${minBet}` : "SELECT CHIP"}
//               </span>
//             </div>

//             {/* TABLE */}
//             <div className="roulette-table-scroll">
//               <div className="roulette-table">
//                 {/* ZERO */}
//                 <button
//                   type="button"
//                   className={`number-cell zero-cell ${
//                     precisionSelection.includes(
//                       0
//                     )
//                       ? "precision-selected"
//                       : ""
//                   }`}
//                   onClick={() =>
//                     handleNumberClick(
//                       0
//                     )
//                   }
//                   disabled={
//                     !bettingOpen
//                   }
//                 >
//                   <span>
//                     0
//                   </span>

//                   {getTableAmount(
//                     "SINGLE",
//                     0
//                   ) > 0 && (
//                     <b>
//                       {getTableAmount(
//                         "SINGLE",
//                         0
//                       )}
//                     </b>
//                   )}
//                 </button>

//                 {/* 1-36 */}
//                 <div className="number-grid">
//                   {NUMBER_ROWS.flatMap(
//                     (row) =>
//                       row.map(
//                         (
//                           number
//                         ) => {
//                           const color =
//                             getNumberColor(
//                               number
//                             );

//                           const amount =
//                             getTableAmount(
//                               "SINGLE",
//                               number
//                             );

//                           const selected =
//                             precisionSelection.includes(
//                               number
//                             );

//                           return (
//                             <button
//                               type="button"
//                               key={
//                                 number
//                               }
//                               className={`number-cell ${color}-cell ${
//                                 selected
//                                   ? "precision-selected"
//                                   : ""
//                               }`}
//                               onClick={() =>
//                                 handleNumberClick(
//                                   number
//                                 )
//                               }
//                               disabled={
//                                 !bettingOpen
//                               }
//                             >
//                               <span>
//                                 {
//                                   number
//                                 }
//                               </span>

//                               {amount >
//                                 0 && (
//                                 <b>
//                                   {
//                                     amount
//                                   }
//                                 </b>
//                               )}
//                             </button>
//                           );
//                         }
//                       )
//                   )}
//                 </div>

//                 {/* COLUMNS */}
//                 <div className="column-bets" style={{ borderTop: '1px solid #fff', borderRight: '1px solid #fff', borderBottom: '1px solid #fff' }}>
//                   {[
//                     [
//                       "COLUMN_3",
//                       "COLUMN_3",
//                       "2:1"
//                     ],
//                     [
//                       "COLUMN_2",
//                       "COLUMN_2",
//                       "2:1"
//                     ],
//                     [
//                       "COLUMN_1",
//                       "COLUMN_1",
//                       "2:1"
//                     ]
//                   ].map(
//                     ([
//                       type,
//                       value,
//                       label
//                     ]) => (
//                       <button
//                         key={
//                           type
//                         }
//                         type="button"
//                         onClick={() =>
//                           addOutsideBet(
//                             type,
//                             value,
//                             BET_TYPES[
//                               type
//                             ].name
//                           )
//                         }
//                         disabled={
//                           !bettingOpen
//                         }
//                       >
//                         <span>
//                           {
//                             label
//                           }
//                         </span>

//                         {getTableAmount(
//                           type,
//                           value
//                         ) > 0 && (
//                           <b>
//                             {getTableAmount(
//                               type,
//                               value
//                             )}
//                           </b>
//                         )}
//                       </button>
//                     )
//                   )}
//                 </div>

//                 {/* DOZENS */}
//                 <div className="dozen-row" style={{ borderLeft: '1px solid #fff', borderRight: '1px solid #fff' }}>
//                   {[
//                     [
//                       "DOZEN_1",
//                       "DOZEN_1",
//                       "1st 12"
//                     ],
//                     [
//                       "DOZEN_2",
//                       "DOZEN_2",
//                       "2nd 12"
//                     ],
//                     [
//                       "DOZEN_3",
//                       "DOZEN_3",
//                       "3rd 12"
//                     ]
//                   ].map(
//                     ([
//                       type,
//                       value,
//                       label
//                     ]) => (
//                       <button
//                         key={
//                           type
//                         }
//                         type="button"
//                         onClick={() =>
//                           addOutsideBet(
//                             type,
//                             value,
//                             label
//                           )
//                         }
//                         disabled={
//                           !bettingOpen
//                         }
//                       >
//                         <span>
//                           {
//                             label
//                           }
//                         </span>

//                         <small>
//                           2:1
//                         </small>

//                         {getTableAmount(
//                           type,
//                           value
//                         ) > 0 && (
//                           <b>
//                             {getTableAmount(
//                               type,
//                               value
//                             )}
//                           </b>
//                         )}
//                       </button>
//                     )
//                   )}
//                 </div>

//                 {/* OUTSIDE */}
//                 <div className="outside-row">
//                   {[
//                     [
//                       "LOW",
//                       "LOW",
//                       "1 to 18",
//                       ""
//                     ],
//                     [
//                       "EVEN",
//                       "EVEN",
//                       "EVEN",
//                       ""
//                     ],
//                     [
//                       "RED",
//                       "RED",
//                       "RED",
//                       "red-zone"
//                     ],
//                     [
//                       "BLACK",
//                       "BLACK",
//                       "BLACK",
//                       "black-zone"
//                     ],
//                     [
//                       "ODD",
//                       "ODD",
//                       "ODD",
//                       ""
//                     ],
//                     [
//                       "HIGH",
//                       "HIGH",
//                       "19 to 36",
//                       ""
//                     ]
//                   ].map(
//                     ([
//                       type,
//                       value,
//                       label,
//                       className
//                     ]) => (
//                       <button
//                         key={
//                           type
//                         }
//                         type="button"
//                         className={
//                           className
//                         }
//                         onClick={() =>
//                           addOutsideBet(
//                             type,
//                             value,
//                             label
//                           )
//                         }
//                         disabled={
//                           !bettingOpen
//                         }
//                       >
//                         <span>
//                           {
//                             label
//                           }
//                         </span>

//                         {getTableAmount(
//                           type,
//                           value
//                         ) > 0 && (
//                           <b>
//                             {getTableAmount(
//                               type,
//                               value
//                             )}
//                           </b>
//                         )}
//                       </button>
//                     )
//                   )}
//                 </div>

//                 {/* SPECIAL ZERO BETS */}
//                 <div className="zero-special-row">
//                   <span>
//                     ZERO BETS
//                   </span>

//                   {[
//                     [
//                       "SPLIT",
//                       [0, 1],
//                       "0-1"
//                     ],
//                     [
//                       "SPLIT",
//                       [0, 2],
//                       "0-2"
//                     ],
//                     [
//                       "SPLIT",
//                       [0, 3],
//                       "0-3"
//                     ],
//                     [
//                       "STREET",
//                       [0, 1, 2],
//                       "0-1-2"
//                     ],
//                     [
//                       "STREET",
//                       [0, 2, 3],
//                       "0-2-3"
//                     ],
//                     [
//                       "CORNER",
//                       [0, 1, 2, 3],
//                       "0-1-2-3"
//                     ]
//                   ].map(
//                     ([
//                       type,
//                       value,
//                       label
//                     ]) => (
//                       <button
//                         key={`${type}-${label}`}
//                         type="button"
//                         onClick={() =>
//                           addBetAction(
//                             type,
//                             value,
//                             `${
//                               BET_TYPES[
//                                 type
//                               ].name
//                             } ${label}`
//                           )
//                         }
//                         disabled={
//                           !bettingOpen
//                         }
//                       >
//                         {
//                           label
//                         }

//                         {getTableAmount(
//                           type,
//                           value
//                         ) > 0 && (
//                           <b>
//                             {getTableAmount(
//                               type,
//                               value
//                             )}
//                           </b>
//                         )}
//                       </button>
//                     )
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* CLOSED OVERLAY */}
//             {!bettingOpen && (
//               <div className="betting-closed-overlay">
//                 <strong>
//                   NO MORE BETS
//                 </strong>

//                 <span>
//                   Wheel spinning ·
//                   result coming
//                 </span>
//               </div>
//             )}
//           </div>

//           {/* BET SLIP */}
//           <aside className="bet-slip-card">
//             <div className="bet-slip-title">
//               <div>
//                 <span>
//                   BET SLIP
//                 </span>

//                 <strong>
//                   {
//                     stagedGroups.length
//                   }{" "}
//                   positions ready
//                 </strong>
//               </div>

//               <span
//                 className={
//                   bettingOpen
//                     ? "open-dot"
//                     : "closed-dot"
//                 }
//               />
//             </div>

//             <div className="bet-summary-list">
//               {stagedGroups.length ===
//               0 ? (
//                 <div className="empty-bet-slip">
//                   <span>
//                     ◎
//                   </span>

//                   <strong>
//                     Place chips on
//                     the table
//                   </strong>

//                   <small>
//                     Your
//                     unconfirmed
//                     bets will
//                     appear here.
//                   </small>
//                 </div>
//               ) : (
//                 stagedGroups.map(
//                   (bet) => (
//                     <div
//                       key={
//                         betKey(
//                           bet
//                         )
//                       }
//                       className={
//                         bet.amount <
//                         minBet
//                           ? "bet-under-min"
//                           : ""
//                       }
//                     >
//                       <span>
//                         <strong>
//                           {
//                             bet.name
//                           }
//                         </strong>

//                         <small>
//                           {BET_TYPES[
//                             bet.type
//                           ]?.ratio ||
//                             ""}
//                         </small>
//                       </span>

//                       <b>
//                         🪙{" "}
//                         {bet.amount.toLocaleString()}
//                       </b>
//                     </div>
//                   )
//                 )
//               )}
//             </div>

//             {/* TOTALS */}
//             <div className="bet-totals">
//               <div>
//                 <span>
//                   Ready to
//                   confirm
//                 </span>

//                 <strong>
//                   {stagedTotal.toLocaleString()}
//                 </strong>
//               </div>

//               <div>
//                 <span>
//                   Already
//                   confirmed
//                 </span>

//                 <strong>
//                   {confirmedTotal.toLocaleString()}
//                 </strong>
//               </div>
//             </div>

//             {/* ACTIONS */}
//             <div className="bet-action-grid">
//               <button
//                 type="button"
//                 onClick={
//                   handleUndo
//                 }
//                 disabled={
//                   !bettingOpen ||
//                   betActions.length ===
//                     0
//                 }
//               >
//                 ↶ Undo
//               </button>

//               <button
//                 type="button"
//                 onClick={
//                   handleClear
//                 }
//                 disabled={
//                   !bettingOpen ||
//                   betActions.length ===
//                     0
//                 }
//               >
//                 ✕ Clear
//               </button>

//               <button
//                 type="button"
//                 onClick={
//                   handleRepeat
//                 }
//                 disabled={
//                   !bettingOpen ||
//                   lastSubmittedActions.length ===
//                     0
//                 }
//               >
//                 ⟳ Repeat
//               </button>

//               <button
//                 type="button"
//                 onClick={
//                   handleDouble
//                 }
//                 disabled={
//                   !bettingOpen ||
//                   (betActions.length ===
//                     0 &&
//                     committedActions.length ===
//                       0)
//                 }
//               >
//                 2× Double
//               </button>
//             </div>

//             {/* CONFIRM */}
//             <button
//               type="button"
//               className="confirm-bets-button"
//               onClick={
//                 isComputerSession ? undefined : handlePlaceBets
//               }
//               disabled={
//                 isComputerSession ||
//                 !bettingOpen ||
//                 placingBets ||
//                 stagedGroups.length ===
//                   0 ||
//                 invalidMinGroups.length >
//                   0 ||
//                 invalidMaxGroups.length >
//                   0 ||
//                 stagedTotal >
//                   Number(
//                     user?.wallet ||
//                       0
//                   )
//               }
//             >
//               {isComputerSession
//                 ? "VIEW ONLY"
//                 : placingBets
//                 ? "CONFIRMING..."
//                 : `CONFIRM BETS · 🪙 ${stagedTotal.toLocaleString()}`}
//             </button>

//             {invalidMinGroups.length >
//               0 && (
//               <div className="bet-warning">
//                 Add more chips:
//                 minimum {minBet}{" "}
//                 per position.
//               </div>
//             )}

//             {invalidMaxGroups.length >
//               0 && (
//               <div className="bet-warning">
//                 Maximum{" "}
//                 {maxBet} coins
//                 per position.
//               </div>
//             )}
//           </aside>
//         </section>
//       </main>

//       {/* RESULT */}
//       {roundOutcome?.visible && (
//         <div
//           className="round-result-overlay"
//           onClick={() =>
//             setRoundOutcome(
//               null
//             )
//           }
//         >
//           <div
//             className="round-result-card"
//             onClick={(
//               event
//             ) =>
//               event.stopPropagation()
//             }
//           >
//             <span className="result-kicker">
//               ROUND #
//               {
//                 roundOutcome.roundNo
//               }{" "}
//               RESULT
//             </span>

//             <div
//               className={`result-number result-${getNumberColor(
//                 roundOutcome.winningNumber
//               )}`}
//             >
//               {
//                 roundOutcome.winningNumber
//               }
//             </div>

//             {roundOutcome.settlementPending ? (
//               <>
//                 <h2>
//                   WINNING NUMBER
//                 </h2>

//                 <p>
//                   Ball settled.
//                   Final settlement
//                   completes at
//                   0 seconds.
//                 </p>
//               </>
//             ) : roundOutcome.playerBetCount >
//               0 ? (
//               roundOutcome.totalWin >
//               0 ? (
//                 <>
//                   <h2>
//                     YOU WIN
//                   </h2>

//                   <strong className="winning-coin-result">
//                     + 🪙{" "}
//                     {roundOutcome.totalWin.toLocaleString()}{" "}
//                     Winning Coins
//                   </strong>

//                   <p>
//                     Winning coins
//                     are ready as a
//                     pending claim
//                     with your Shop.
//                   </p>
//                 </>
//               ) : (
//                 <>
//                   <h2>
//                     ROUND
//                     COMPLETE
//                   </h2>

//                   <p>
//                     Next betting
//                     round is
//                     already open.
//                   </p>
//                 </>
//               )
//             ) : (
//               <>
//                 <h2>
//                   WINNING NUMBER
//                 </h2>

//                 <p>
//                   No bet was
//                   placed in this
//                   round.
//                 </p>
//               </>
//             )}

//             <button
//               type="button"
//               onClick={() =>
//                 setRoundOutcome(
//                   null
//                 )
//               }
//             >
//               CONTINUE
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Game;







// import React, {
//   useCallback,
//   useEffect,
//   useMemo,
//   useRef,
//   useState
// } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";

// import RouletteWheel3D from "./RouletteWheel3D";
// import authService from "../services/authService";
// import computerAuthService from "../services/computerAuthService";
// import gameService from "../services/gameService";
// import { BET_TYPES, getNumberColor } from "../utils/gameLogic";
// import { sounds } from "../utils/audio";
// import "./Game.css";

// const CHIP_VALUES = [10, 50, 100, 500, 1000];

// const THEMES = [
//   { id: "classic", name: "Classic Green" },
//   { id: "royal", name: "Royal Black Gold" },
//   { id: "neon", name: "Neon Blue" },
//   { id: "ruby", name: "Ruby Casino" }
// ];

// const PRECISION_MODES = {
//   SINGLE: 1,
//   SPLIT: 2,
//   STREET: 3,
//   CORNER: 4,
//   SIX_LINE: 6
// };

// const NUMBER_ROWS = [
//   [3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36],
//   [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35],
//   [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34]
// ];

// const asSortedNumbers = (value) => {
//   if (Array.isArray(value)) {
//     return [...value]
//       .map(Number)
//       .sort((a, b) => a - b);
//   }

//   const text = String(value ?? "").trim();

//   if (text.startsWith("[") && text.endsWith("]")) {
//     try {
//       const parsed = JSON.parse(text);

//       if (Array.isArray(parsed)) {
//         return parsed
//           .map(Number)
//           .sort((a, b) => a - b);
//       }
//     } catch (error) {
//       return [];
//     }
//   }

//   if (text.includes(",")) {
//     return text
//       .split(",")
//       .map((item) => Number(item.trim()))
//       .filter(Number.isFinite)
//       .sort((a, b) => a - b);
//   }

//   const number = Number(text);

//   return Number.isFinite(number)
//     ? [number]
//     : [];
// };

// const canonicalValue = (value) => {
//   if (Array.isArray(value)) {
//     return JSON.stringify(
//       [...value]
//         .map(Number)
//         .sort((a, b) => a - b)
//     );
//   }

//   return String(value);
// };

// const betKey = (bet) =>
//   `${bet.type}:${canonicalValue(bet.value)}`;

// const aggregateBets = (actions) => {
//   const map = new Map();

//   actions.forEach((action) => {
//     const key = betKey(action);
//     const existing = map.get(key);

//     if (existing) {
//       existing.amount += Number(
//         action.amount || 0
//       );
//     } else {
//       map.set(key, {
//         ...action,
//         amount: Number(
//           action.amount || 0
//         )
//       });
//     }
//   });

//   return Array.from(map.values());
// };

// const displayValue = (type, value) => {
//   if (
//     [
//       "RED",
//       "BLACK",
//       "EVEN",
//       "ODD",
//       "LOW",
//       "HIGH"
//     ].includes(type)
//   ) {
//     return String(value)
//       .replace("LOW", "1-18")
//       .replace("HIGH", "19-36");
//   }

//   if (type.startsWith("COLUMN_")) {
//     return `${type.replace(
//       "COLUMN_",
//       ""
//     )} Column`;
//   }

//   if (type.startsWith("DOZEN_")) {
//     const index = Number(
//       type.replace("DOZEN_", "")
//     );

//     return index === 1
//       ? "1-12"
//       : index === 2
//       ? "13-24"
//       : "25-36";
//   }

//   const numbers =
//     asSortedNumbers(value);

//   return numbers.length
//     ? numbers.join(" • ")
//     : String(value);
// };

// const historyToAction = (bet) => ({
//   type: String(
//     bet.bet_type || "SINGLE"
//   ),

//   value: [
//     "SINGLE",
//     "SPLIT",
//     "STREET",
//     "CORNER",
//     "SIX_LINE"
//   ].includes(bet.bet_type)
//     ? asSortedNumbers(
//         bet.bet_value
//       ).length === 1
//       ? asSortedNumbers(
//           bet.bet_value
//         )[0]
//       : asSortedNumbers(
//           bet.bet_value
//         )
//     : String(bet.bet_value),

//   name: `${
//     BET_TYPES[bet.bet_type]?.name ||
//     bet.bet_type
//   } ${displayValue(
//     bet.bet_type,
//     bet.bet_value
//   )}`,

//   amount: Number(
//     bet.amount || 0
//   )
// });

// const isValidPrecision = (
//   type,
//   selected
// ) => {
//   const numbers = [
//     ...selected
//   ]
//     .map(Number)
//     .sort((a, b) => a - b);

//   if (type === "SINGLE") {
//     return (
//       numbers.length === 1 &&
//       numbers[0] >= 0 &&
//       numbers[0] <= 36
//     );
//   }

//   if (type === "SPLIT") {
//     if (numbers.length !== 2) {
//       return false;
//     }

//     const [a, b] = numbers;

//     if (a === 0) {
//       return [1, 2, 3].includes(b);
//     }

//     const vertical =
//       b - a === 3;

//     const horizontal =
//       b - a === 1 &&
//       Math.floor((a - 1) / 3) ===
//         Math.floor((b - 1) / 3);

//     return (
//       vertical ||
//       horizontal
//     );
//   }

//   if (type === "STREET") {
//     if (numbers.length !== 3) {
//       return false;
//     }

//     const [a, b, c] = numbers;

//     if (a === 0) {
//       return (
//         (b === 1 && c === 2) ||
//         (b === 2 && c === 3)
//       );
//     }

//     return (
//       a >= 1 &&
//       a <= 34 &&
//       a % 3 === 1 &&
//       b === a + 1 &&
//       c === a + 2
//     );
//   }

//   if (type === "CORNER") {
//     if (numbers.length !== 4) {
//       return false;
//     }

//     const [a, b, c, d] =
//       numbers;

//     if (a === 0) {
//       return (
//         b === 1 &&
//         c === 2 &&
//         d === 3
//       );
//     }

//     return (
//       a >= 1 &&
//       a <= 32 &&
//       a % 3 !== 0 &&
//       b === a + 1 &&
//       c === a + 3 &&
//       d === a + 4
//     );
//   }

//   if (type === "SIX_LINE") {
//     if (numbers.length !== 6) {
//       return false;
//     }

//     const [
//       a,
//       b,
//       c,
//       d,
//       e,
//       f
//     ] = numbers;

//     return (
//       a >= 1 &&
//       a <= 31 &&
//       a % 3 === 1 &&
//       b === a + 1 &&
//       c === a + 2 &&
//       d === a + 3 &&
//       e === a + 4 &&
//       f === a + 5
//     );
//   }

//   return false;
// };

// const Game = () => {
//   const navigate = useNavigate();

//   // Computer session (separate from legacy Player auth)
//   const computerToken = sessionStorage.getItem("computer_token");

//   const [computer, setComputer] = useState(() =>
//     computerAuthService.getComputer()
//   );

//   const isComputerSession =
//     Boolean(computerToken) && Boolean(computer);

//   // Keep Computer header/profile data synced with the latest
//   // read-only Computer profile from the backend.
//   useEffect(() => {
//     if (!isComputerSession) {
//       return;
//     }

//     let active = true;

//     const loadComputerProfile = async () => {
//       try {
//         const response =
//           await computerAuthService.getProfile();

//         if (
//           active &&
//           response?.success &&
//           response?.computer
//         ) {
//           setComputer(response.computer);
//         }
//       } catch (error) {
//         console.error(
//           "Computer profile load error:",
//           error
//         );
//       }
//     };

//     loadComputerProfile();

//     return () => {
//       active = false;
//     };
//   }, [isComputerSession]);

//   const [user, setUser] =
//     useState(() =>
//       authService.getCurrentUser()
//     );

//   const [
//     currentRound,
//     setCurrentRound
//   ] = useState(null);

//   const [
//     recentResults,
//     setRecentResults
//   ] = useState([]);

//   const [
//     history,
//     setHistory
//   ] = useState([]);

//   const [
//     loading,
//     setLoading
//   ] = useState(true);

//   const [
//     selectedChip,
//     setSelectedChip
//   ] = useState(10);

//   const [
//     precisionMode,
//     setPrecisionMode
//   ] = useState("SINGLE");

//   const [
//     precisionSelection,
//     setPrecisionSelection
//   ] = useState([]);

//   const [
//     betActions,
//     setBetActions
//   ] = useState([]);

//   const [
//     committedActions,
//     setCommittedActions
//   ] = useState([]);

//   const [
//     lastSubmittedActions,
//     setLastSubmittedActions
//   ] = useState([]);

//   const [
//     placingBets,
//     setPlacingBets
//   ] = useState(false);

//   const [
//     wheelResult,
//     setWheelResult
//   ] = useState(null);

//   const [
//     wheelSettled,
//     setWheelSettled
//   ] = useState(false);

//   const [
//     roundOutcome,
//     setRoundOutcome
//   ] = useState(null);

//   const [
//     theme,
//     setTheme
//   ] = useState(
//     () =>
//       localStorage.getItem(
//         "casinoPlayerTheme"
//       ) || "classic"
//   );

//   const [
//     pendingTheme,
//     setPendingTheme
//   ] = useState(null);

//   const [
//     soundEnabled,
//     setSoundEnabled
//   ] = useState(
//     () =>
//       localStorage.getItem(
//         "casinoSoundEnabled"
//       ) !== "false"
//   );

//   const currentRoundRef =
//     useRef(null);

//   const previousPhaseRef =
//     useRef(null);

//   const lastCountdownBeepRef =
//     useRef(null);

//   const outcomeRef =
//     useRef(null);

//   const bettingOpen =
//     currentRound?.betting_open ===
//     true;

//   const phase =
//     currentRound?.phase ||
//     (bettingOpen
//       ? "BETTING"
//       : "SPINNING");

//   const bettingRemaining =
//     Number(
//       currentRound
//         ?.betting_remaining_seconds ||
//         0
//     );

//   const phaseRemaining =
//     Number(
//       currentRound
//         ?.phase_remaining_seconds ||
//         0
//     );

//   const totalSeconds =
//     Number(
//       currentRound?.total_seconds ||
//         60
//     );

//   const minBet =
//     Number(
//       currentRound?.min_bet ||
//         0
//     );

//   const maxBet =
//     Number(
//       currentRound?.max_bet ||
//         0
//     );

//   // Backend exposes the already-locked roulette target only
//   // near the end of the current SPINNING phase.
//   // It is used only to settle the wheel; the wheel component
//   // reveals the number only after the ball has actually stopped.
//   const spinTarget =
//     currentRound?.spin_target !== null &&
//     currentRound?.spin_target !== undefined &&
//     Number.isInteger(
//       Number(
//         currentRound.spin_target
//       )
//     )
//       ? Number(
//           currentRound.spin_target
//         )
//       : null;

//   const wheelTarget =
//     phase === "SPINNING"
//       ? spinTarget
//       : null;

//   const stagedGroups =
//     useMemo(
//       () =>
//         aggregateBets(
//           betActions
//         ),
//       [betActions]
//     );

//   const tableGroups =
//     useMemo(
//       () =>
//         aggregateBets([
//           ...committedActions,
//           ...betActions
//         ]),
//       [
//         committedActions,
//         betActions
//       ]
//     );

//   const stagedTotal =
//     useMemo(
//       () =>
//         betActions.reduce(
//           (sum, item) =>
//             sum +
//             Number(
//               item.amount || 0
//             ),
//           0
//         ),
//       [betActions]
//     );

//   const confirmedTotal =
//     useMemo(
//       () =>
//         committedActions.reduce(
//           (sum, item) =>
//             sum +
//             Number(
//               item.amount || 0
//             ),
//           0
//         ),
//       [committedActions]
//     );

//   const pendingWinningCoins =
//     useMemo(
//       () =>
//         history
//           .filter(
//             (bet) =>
//               bet.status ===
//                 "WIN" &&
//               bet.claim_status ===
//                 "PENDING"
//           )
//           .reduce(
//             (sum, bet) =>
//               sum +
//               Number(
//                 bet.win_amount ||
//                   0
//               ),
//             0
//           ),
//       [history]
//     );

//   const invalidMinGroups =
//     useMemo(
//       () =>
//         minBet > 0
//           ? stagedGroups.filter(
//               (bet) =>
//                 bet.amount <
//                 minBet
//             )
//           : [],
//       [
//         stagedGroups,
//         minBet
//       ]
//     );

//   const invalidMaxGroups =
//     useMemo(
//       () =>
//         maxBet > 0
//           ? stagedGroups.filter(
//               (bet) =>
//                 bet.amount >
//                 maxBet
//             )
//           : [],
//       [
//         stagedGroups,
//         maxBet
//       ]
//     );

//   const refreshProfile =
//     useCallback(
//       async () => {
//         if (isComputerSession) return;

//         try {
//           const response =
//             await authService.getProfile();

//           if (response?.user) {
//             setUser(
//               response.user
//             );
//           } else {
//             setUser(
//               authService.getCurrentUser()
//             );
//           }
//         } catch (error) {
//           // Session interceptor
//         }
//       },
//       [isComputerSession]
//     );

//   const refreshHistory =
//     useCallback(
//       async () => {
//         if (isComputerSession) {
//           setHistory([]);
//           return [];
//         }

//         try {
//           const response =
//             await gameService.getHistory();

//           const rows =
//             Array.isArray(
//               response?.history
//             )
//               ? response.history
//               : [];

//           setHistory(rows);

//           return rows;
//         } catch (error) {
//           return [];
//         }
//       },
//       [isComputerSession]
//     );

//   const refreshRecentResults =
//     useCallback(
//       async () => {
//         try {
//           const response =
//             await gameService.getRecentResults(
//               10
//             );

//           const rows =
//             Array.isArray(
//               response?.results
//             )
//               ? response.results
//               : [];

//           setRecentResults(rows);

//           return rows;
//         } catch (error) {
//           return [];
//         }
//       },
//       []
//     );

//   const handleCompletedRound =
//     useCallback(
//       async (
//         completedRoundId
//       ) => {
//         const [
//           results,
//           rows
//         ] =
//           await Promise.all([
//             refreshRecentResults(),
//             refreshHistory(),
//             refreshProfile()
//           ]);

//         const completed =
//           results.find(
//             (item) =>
//               Number(item.id) ===
//               Number(
//                 completedRoundId
//               )
//           );

//         if (!completed) {
//           return;
//         }

//         const playerRoundBets =
//           rows.filter(
//             (bet) =>
//               Number(
//                 bet.round_id
//               ) ===
//               Number(
//                 completedRoundId
//               )
//           );

//         const totalWin =
//           playerRoundBets
//             .filter(
//               (bet) =>
//                 bet.status ===
//                 "WIN"
//             )
//             .reduce(
//               (sum, bet) =>
//                 sum +
//                 Number(
//                   bet.win_amount ||
//                     0
//                 ),
//               0
//             );

//         const outcome = {
//           roundId:
//             Number(
//               completed.id
//             ),

//           roundNo:
//             completed.round_no,

//           winningNumber:
//             Number(
//               completed.winning_number
//             ),

//           playerBetCount:
//             playerRoundBets.length,

//           totalWin,

//           settlementPending:
//             false,

//           visible: false
//         };

//         outcomeRef.current =
//           outcome;

//         setRoundOutcome(
//           outcome
//         );

//         setWheelResult(
//           Number(
//             completed.winning_number
//           )
//         );
//       },
//       [
//         refreshHistory,
//         refreshProfile,
//         refreshRecentResults
//       ]
//     );

//   const fetchCurrentRound =
//     useCallback(
//       async () => {
//         try {
//           const response =
//             await gameService.getCurrentRound();

//           const nextRound =
//             response?.round ||
//             response?.current_round ||
//             null;

//           if (!nextRound) {
//             return null;
//           }

//           const previousRound =
//             currentRoundRef.current;

//           if (
//             previousRound &&
//             Number(
//               previousRound.id
//             ) !==
//               Number(
//                 nextRound.id
//               )
//           ) {
//             // A new backend round must start visually fresh at 60s.
//             // Do not let the previous wheel/result animation consume
//             // any seconds from the new betting round.
//             setWheelSettled(false);

//             setWheelResult(
//               null
//             );

//             // The previous round result is only for the old round.
//             // Close it exactly when the fresh 60-second round begins.
//             outcomeRef.current =
//               null;

//             setRoundOutcome(
//               null
//             );

//             setBetActions([]);

//             setCommittedActions(
//               []
//             );

//             setPrecisionSelection(
//               []
//             );

//             if (pendingTheme) {
//               setTheme(
//                 pendingTheme
//               );

//               localStorage.setItem(
//                 "casinoPlayerTheme",
//                 pendingTheme
//               );

//               setPendingTheme(
//                 null
//               );
//             }

//             handleCompletedRound(
//               previousRound.id
//             );
//           }

//           currentRoundRef.current =
//             nextRound;

//           setCurrentRound(
//             nextRound
//           );

//           return nextRound;
//         } catch (error) {
//           if (
//             error.response
//               ?.status === 404
//           ) {
//             setCurrentRound(
//               null
//             );
//           }

//           return null;
//         }
//       },
//       [
//         handleCompletedRound,
//         pendingTheme
//       ]
//     );

//   useEffect(() => {
//     sounds.setEnabled(
//       soundEnabled
//     );

//     localStorage.setItem(
//       "casinoSoundEnabled",
//       soundEnabled
//         ? "true"
//         : "false"
//     );
//   }, [soundEnabled]);

//   useEffect(() => {
//     const load = async () => {
//       setLoading(true);

//       const [
//         round,
//         results,
//         rows
//       ] =
//         await Promise.all([
//           fetchCurrentRound(),
//           refreshRecentResults(),
//           refreshHistory(),
//           refreshProfile()
//         ]);

//       if (round) {
//         currentRoundRef.current =
//           round;

//         const pendingThisRound =
//           rows
//             .filter(
//               (bet) =>
//                 Number(
//                   bet.round_id
//                 ) ===
//                   Number(
//                     round.id
//                   ) &&
//                 bet.status ===
//                   "PENDING"
//             )
//             .map(
//               historyToAction
//             );

//         setCommittedActions(
//           pendingThisRound
//         );
//       }

//       if (
//         round?.phase !==
//           "SPINNING" &&
//         results.length
//       ) {
//         setWheelResult(
//           Number(
//             results[0]
//               .winning_number
//           )
//         );
//       }

//       setLoading(false);
//     };

//     load();

//     const interval =
//       setInterval(
//         fetchCurrentRound,
//         1000
//       );

//     const historyInterval =
//       setInterval(
//         refreshHistory,
//         5000
//       );

//     return () => {
//       clearInterval(
//         interval
//       );

//       clearInterval(
//         historyInterval
//       );
//     };
//   }, [
//     fetchCurrentRound,
//     refreshHistory,
//     refreshProfile,
//     refreshRecentResults
//   ]);

//   useEffect(() => {
//     if (
//       previousPhaseRef.current !==
//       phase
//     ) {
//       if (
//         phase ===
//         "SPINNING"
//       ) {
//         setWheelSettled(
//           false
//         );

//         setWheelResult(
//           null
//         );

//         setRoundOutcome(
//           null
//         );

//         outcomeRef.current =
//           null;

//         setPrecisionSelection(
//           []
//         );

//         sounds.playNoMoreBetsSound();
//       }

//       previousPhaseRef.current =
//         phase;
//     }
//   }, [phase]);

//   useEffect(() => {
//     if (
//       phase === "BETTING" &&
//       bettingRemaining > 0 &&
//       bettingRemaining <= 5 &&
//       lastCountdownBeepRef.current !==
//         bettingRemaining
//     ) {
//       lastCountdownBeepRef.current =
//         bettingRemaining;

//       sounds.playCountdownSound();
//     }
//   }, [
//     phase,
//     bettingRemaining
//   ]);

//   useEffect(() => {
//     if (
//       phase !== "SPINNING" ||
//       wheelSettled
//     ) {
//       return undefined;
//     }

//     const interval =
//       setInterval(() => {
//         sounds.playSpinTickSound();
//       }, 360);

//     return () =>
//       clearInterval(
//         interval
//       );
//   }, [
//     phase,
//     wheelSettled
//   ]);

//   const getTableAmount =
//     useCallback(
//       (
//         type,
//         value
//       ) => {
//         const key =
//           `${type}:${canonicalValue(
//             value
//           )}`;

//         const found =
//           tableGroups.find(
//             (bet) =>
//               betKey(bet) ===
//               key
//           );

//         return Number(
//           found?.amount ||
//             0
//         );
//       },
//       [tableGroups]
//     );

//   const addBetAction =
//     useCallback(
//       (
//         type,
//         value,
//         name
//       ) => {
//         if (isComputerSession) {
//           return;
//         }

//         if (!bettingOpen) {
//           toast.warning(
//             "No more bets. Wait for the next round."
//           );

//           return;
//         }

//         const nextTotal =
//           stagedTotal +
//           selectedChip;

//         const wallet =
//           Number(
//             user?.wallet ||
//               0
//           );

//         if (
//           nextTotal >
//           wallet
//         ) {
//           toast.error(
//             "Insufficient playable wallet balance."
//           );

//           return;
//         }

//         setBetActions(
//           (previous) => [
//             ...previous,
//             {
//               type,
//               value,
//               name,
//               amount:
//                 selectedChip
//             }
//           ]
//         );

//         sounds.playChipSound();
//       },
//       [
//         bettingOpen,
//         selectedChip,
//         stagedTotal,
//         user?.wallet,
//         isComputerSession
//       ]
//     );


//   // Visual preview only for connected-number modes.
//   // This changes table highlighting only; wheel/spin code is untouched.
//   const previewConnectedNumbers = (number) => {
//     const n = Number(number);

//     if (!Number.isInteger(n) || n < 1 || n > 36) {
//       return [n];
//     }

//     const streetStart =
//       Math.floor((n - 1) / 3) * 3 + 1;

//     if (precisionMode === "STREET") {
//       return [
//         streetStart,
//         streetStart + 1,
//         streetStart + 2
//       ];
//     }

//     if (precisionMode === "SIX_LINE") {
//       const firstStreet =
//         streetStart >= 34
//           ? 31
//           : streetStart;

//       return [
//         firstStreet,
//         firstStreet + 1,
//         firstStreet + 2,
//         firstStreet + 3,
//         firstStreet + 4,
//         firstStreet + 5
//       ];
//     }

//     return [n];
//   };

//   const handleNumberClick =
//     (number) => {
//       if (isComputerSession) return;

//       if (!bettingOpen) {
//         toast.warning(
//           "Betting is closed."
//         );

//         return;
//       }

//       if (
//         precisionMode ===
//         "SINGLE"
//       ) {
//         addBetAction(
//           "SINGLE",
//           number,
//           `Number ${number}`
//         );

//         return;
//       }

//       if (
//         precisionMode === "STREET" ||
//         precisionMode === "SIX_LINE"
//       ) {
//         setPrecisionSelection(
//           previewConnectedNumbers(number)
//         );
//         return;
//       }

//       const required =
//         PRECISION_MODES[
//           precisionMode
//         ];

//       let updated =
//         precisionSelection.includes(
//           number
//         )
//           ? precisionSelection.filter(
//               (item) =>
//                 item !== number
//             )
//           : [
//               ...precisionSelection,
//               number
//             ];

//       if (
//         updated.length >
//         required
//       ) {
//         updated = [number];
//       }

//       setPrecisionSelection(
//         updated
//       );

//       if (
//         updated.length ===
//         required
//       ) {
//         if (
//           !isValidPrecision(
//             precisionMode,
//             updated
//           )
//         ) {
//           toast.error(
//             `Invalid ${
//               BET_TYPES[
//                 precisionMode
//               ]?.name ||
//               precisionMode
//             } selection.`
//           );

//           setPrecisionSelection(
//             []
//           );

//           return;
//         }

//         const sorted = [
//           ...updated
//         ].sort(
//           (a, b) => a - b
//         );

//         addBetAction(
//           precisionMode,
//           sorted,
//           `${
//             BET_TYPES[
//               precisionMode
//             ]?.name ||
//             precisionMode
//           } ${sorted.join("-")}`
//         );

//         setPrecisionSelection(
//           []
//         );
//       }
//     };

//   const addOutsideBet = (
//     type,
//     value,
//     label
//   ) => {
//     addBetAction(
//       type,
//       value,
//       label
//     );
//   };

//   const handleUndo = () => {
//     setBetActions(
//       (previous) =>
//         previous.slice(
//           0,
//           -1
//         )
//     );
//   };

//   const handleClear = () => {
//     setBetActions([]);

//     setPrecisionSelection(
//       []
//     );
//   };

//   const handleRepeat = () => {
//     if (isComputerSession) return;

//     if (
//       !bettingOpen ||
//       lastSubmittedActions.length ===
//         0
//     ) {
//       return;
//     }

//     const repeatTotal =
//       lastSubmittedActions.reduce(
//         (sum, item) =>
//           sum +
//           Number(
//             item.amount ||
//               0
//           ),
//         0
//       );

//     if (
//       repeatTotal >
//       Number(
//         user?.wallet ||
//           0
//       )
//     ) {
//       toast.error(
//         "Wallet balance is not enough to repeat the previous bet."
//       );

//       return;
//     }

//     setBetActions(
//       lastSubmittedActions.map(
//         (item) => ({
//           ...item
//         })
//       )
//     );

//     sounds.playChipSound();
//   };

//   const handleDouble = () => {
//     if (isComputerSession) return;

//     if (!bettingOpen) {
//       return;
//     }

//     const source =
//       betActions.length > 0
//         ? betActions
//         : committedActions;

//     if (
//       source.length === 0
//     ) {
//       return;
//     }

//     const additional =
//       source.reduce(
//         (sum, item) =>
//           sum +
//           Number(
//             item.amount ||
//               0
//           ),
//         0
//       );

//     if (
//       additional >
//       Number(
//         user?.wallet ||
//           0
//       )
//     ) {
//       toast.error(
//         "Wallet balance is not enough to double the bet."
//       );

//       return;
//     }

//     if (
//       betActions.length >
//       0
//     ) {
//       setBetActions(
//         (previous) =>
//           previous.map(
//             (item) => ({
//               ...item,
//               amount:
//                 Number(
//                   item.amount ||
//                     0
//                 ) * 2
//             })
//           )
//       );
//     } else {
//       setBetActions(
//         source.map(
//           (item) => ({
//             ...item
//           })
//         )
//       );
//     }

//     sounds.playChipSound();
//   };

//   const handlePlaceBets =
//     async () => {
//       if (isComputerSession) return;

//       if (
//         !currentRound ||
//         !bettingOpen ||
//         placingBets ||
//         stagedGroups.length ===
//           0
//       ) {
//         return;
//       }

//       if (
//         invalidMinGroups.length >
//         0
//       ) {
//         toast.error(
//           `Minimum bet per position is ${minBet}. Add more chips on highlighted positions.`
//         );

//         return;
//       }

//       if (
//         invalidMaxGroups.length >
//         0
//       ) {
//         toast.error(
//           `Maximum bet per position is ${maxBet}.`
//         );

//         return;
//       }

//       if (
//         stagedTotal >
//         Number(
//           user?.wallet ||
//             0
//         )
//       ) {
//         toast.error(
//           "Insufficient playable wallet balance."
//         );

//         return;
//       }

//       const payloadBets =
//         stagedGroups.map(
//           (bet) => ({
//             bet_type:
//               bet.type,

//             bet_value:
//               Array.isArray(
//                 bet.value
//               )
//                 ? JSON.stringify(
//                     bet.value
//                   )
//                 : String(
//                     bet.value
//                   ),

//             amount:
//               Number(
//                 bet.amount
//               )
//           })
//         );

//       try {
//         setPlacingBets(
//           true
//         );

//         const response =
//           await gameService.placeBets(
//             {
//               round_id:
//                 currentRound.id,

//               bets:
//                 payloadBets
//             }
//           );

//         if (
//           !response?.success
//         ) {
//           throw new Error(
//             response?.message ||
//               "Unable to place bets."
//           );
//         }

//         setCommittedActions(
//           (previous) => [
//             ...previous,
//             ...stagedGroups
//           ]
//         );

//         setLastSubmittedActions(
//           betActions.map(
//             (item) => ({
//               ...item
//             })
//           )
//         );

//         setBetActions([]);

//         setPrecisionSelection(
//           []
//         );

//         await refreshProfile();

//         await refreshHistory();

//         toast.success(
//           `Bets confirmed: ${Number(
//             response.total_amount ||
//               stagedTotal
//           ).toLocaleString()} coins`
//         );
//       } catch (error) {
//         toast.error(
//           error.response?.data
//             ?.message ||
//             error.message ||
//             "Unable to place bets."
//         );

//         await fetchCurrentRound();
//       } finally {
//         setPlacingBets(
//           false
//         );
//       }
//     };

//   const handleThemeChange =
//     (event) => {
//       const nextTheme =
//         event.target.value;

//       if (
//         phase ===
//         "SPINNING"
//       ) {
//         setPendingTheme(
//           nextTheme
//         );

//         toast.info(
//           "Theme will change on the next round."
//         );

//         return;
//       }

//       setTheme(
//         nextTheme
//       );

//       localStorage.setItem(
//         "casinoPlayerTheme",
//         nextTheme
//       );
//     };

//   const handleWheelSettled =
//     () => {
//       setWheelSettled(
//         true
//       );

//       sounds.playBallSettleSound();

//       const activeRound =
//         currentRoundRef.current;

//       const target =
//         Number(
//           activeRound
//             ?.spin_target
//         );

//       // The backend has already locked this target and betting is closed.
//       // Show it NOW, exactly after the ball has stopped.
//       if (
//         !activeRound ||
//         !Number.isInteger(
//           target
//         ) ||
//         target < 0 ||
//         target > 36
//       ) {
//         return;
//       }

//       const provisionalOutcome = {
//         roundId:
//           Number(
//             activeRound.id
//           ),

//         roundNo:
//           activeRound.round_no,

//         winningNumber:
//           target,

//         // Final bet settlement happens server-side at 0 sec.
//         // Until then we only reveal the winning number.
//         playerBetCount:
//           0,

//         totalWin:
//           0,

//         settlementPending:
//           true,

//         visible:
//           true
//       };

//       outcomeRef.current =
//         provisionalOutcome;

//       setRoundOutcome(
//         provisionalOutcome
//       );
//     };

//   const handleLogout = () => {
//     if (isComputerSession) {
//       sessionStorage.removeItem("computer_token");
//       sessionStorage.removeItem("computer");
//       navigate("/login", { replace: true });
//       return;
//     }

//     authService.logout();
//     navigate("/login", { replace: true });
//   };

//   const timerValue =
//     phase === "BETTING"
//       ? bettingRemaining
//       : phaseRemaining;

//   const timerMax =
//     phase === "BETTING"
//       ? Number(
//           currentRound
//             ?.betting_seconds ||
//             40
//         )
//       : Number(
//           currentRound
//             ?.spin_result_seconds ||
//             20
//         );

//   const timerProgress =
//     timerMax > 0
//       ? Math.max(
//           0,
//           Math.min(
//             1,
//             timerValue /
//               timerMax
//           )
//         )
//       : 0;

//   if (loading) {
//     return (
//       <div className="roulette-loading-screen">
//         <div className="roulette-loading-wheel">
//           ♛
//         </div>

//         <div>
//           Preparing Roulette
//           Table...
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div
//       className={`casino-game-shell theme-${theme}`}
//     >
//       
//       {/* HEADER */}
//       <header className="casino-game-header">
//         <div className="casino-brand-block">
//           <div className="casino-brand-mark">
//             0
//           </div>

//           <div>
//             <strong>
//               EUROPEAN ROULETTE
//             </strong>

//             <span>
//               Live 60 Second
//               Round
//             </span>
//           </div>
//         </div>

//         <div className="casino-header-round">
//           <span>
//             ROUND
//           </span>

//           <strong>
//             #
//             {currentRound
//               ?.round_no ||
//               "--"}
//           </strong>

//           <em
//             className={
//               phase ===
//               "BETTING"
//                 ? "phase-open"
//                 : "phase-closed"
//             }
//           >
//             {phase ===
//             "BETTING"
//               ? "BETTING OPEN"
//               : "NO MORE BETS"}
//           </em>
//         </div>

//         <div className="casino-player-strip">
//           <div className="casino-balance-card">
//             <span>
//               {isComputerSession ? "CREDITS" : "PLAYABLE"}
//             </span>

//             <strong>
//               🪙{" "}
//               {Number(
//                 isComputerSession
//                   ? computer?.current_balance || 0
//                   : user?.wallet || 0
//               ).toLocaleString()}
//             </strong>
//           </div>

//           <div className="casino-balance-card winning-balance">
//             <span>
//               WINNING COINS
//             </span>

//             <strong>
//               🏆{" "}
//               {pendingWinningCoins.toLocaleString()}
//             </strong>
//           </div>

//           <label className="theme-select-wrap">
//             <span>
//               THEME
//             </span>

//             <select
//               value={
//                 pendingTheme ||
//                 theme
//               }
//               onChange={
//                 handleThemeChange
//               }
//             >
//               {THEMES.map(
//                 (item) => (
//                   <option
//                     key={
//                       item.id
//                     }
//                     value={
//                       item.id
//                     }
//                   >
//                     {item.name}
//                   </option>
//                 )
//               )}
//             </select>
//           </label>

//           <button
//             type="button"
//             className="casino-icon-button"
//             onClick={() =>
//               setSoundEnabled(
//                 (value) =>
//                   !value
//               )
//             }
//             title={
//               soundEnabled
//                 ? "Mute sounds"
//                 : "Enable sounds"
//             }
//           >
//             {soundEnabled
//               ? "🔊"
//               : "🔇"}
//           </button>

//           <button
//             type="button"
//             className="casino-icon-button"
//             onClick={() =>
//               navigate(
//                 isComputerSession
//                   ? "/computer-dashboard"
//                   : "/dashboard"
//               )
//             }
//             title="Dashboard"
//           >
//             ⌂
//           </button>

//           <button
//             type="button"
//             className="casino-logout-button"
//             onClick={
//               handleLogout
//             }
//           >
//             {isComputerSession
//               ? computer?.computer_code || "Computer"
//               : user?.username || "Player"}{" "}
//             · Logout
//           </button>
//         </div>
//       </header>

//       {isComputerSession && (
//         <div style={{
//           padding: "8px 16px",
//           textAlign: "center",
//           background: "rgba(212, 175, 55, 0.10)",
//           borderBottom: "1px solid rgba(212, 175, 55, 0.25)",
//           color: "#D4AF37",
//           fontSize: "12px",
//           fontWeight: 800,
//           letterSpacing: "0.08em"
//         }}>
//           COMPUTER VIEW · TABLE CONTROLS ARE READ-ONLY
//         </div>
//       )}

//       {/* MAIN */}
//       <main className="casino-game-content">
//         {/* WHEEL + TIMER */}
//         <section className="casino-stage-grid">
//           <div className="roulette-stage-card">
//             <div className="stage-light stage-light-left" />

//             <div className="stage-light stage-light-right" />

// <RouletteWheel3D
//   key={
//     currentRound?.id ||
//     "no-round"
//   }
//   winningNumber={wheelTarget}
//   isSpinning={
//     phase === "SPINNING" &&
//     wheelTarget === null
//   }
//   onSettled={handleWheelSettled}
// />
//           </div>

//           <aside className="round-console">
//             <div
//               className={`round-status-panel ${
//                 phase ===
//                 "BETTING"
//                   ? "status-open"
//                   : "status-spin"
//               }`}
//             >
//               <div
//                 className="round-timer-ring"
//                 style={{
//                   "--timer-progress":
//                     `${
//                       timerProgress *
//                       360
//                     }deg`
//                 }}
//               >
//                 <div className="round-timer-inner">
//                   <strong>
//                     {timerValue}
//                   </strong>

//                   <span>
//                     SEC
//                   </span>
//                 </div>
//               </div>

//               <div className="round-status-copy">
//                 <span>
//                   {phase ===
//                   "BETTING"
//                     ? "PLACE YOUR BETS"
//                     : "NO MORE BETS"}
//                 </span>

//                 <strong>
//                   {phase ===
//                   "BETTING"
//                     ? "Betting is open"
//                     : wheelSettled
//                     ? "Winning number displayed"
//                     : "Wheel is spinning"}
//                 </strong>

//                 <small>
//                   {phase ===
//                   "BETTING"
//                     ? `${bettingRemaining}s left to confirm bets`
//                     : wheelSettled
//                     ? `Next round in ${phaseRemaining}s`
//                     : `Result phase · ${phaseRemaining}s`}
//                 </small>
//               </div>
//             </div>

//             {/* RECENT RESULTS */}
//             <div className="recent-results-card">
//               <div className="console-section-title">
//                 <span>
//                   RECENT RESULTS
//                 </span>

//                 <button
//                   type="button"
//                   onClick={() =>
//                     navigate(
//                       isComputerSession
//                         ? "/computer-history"
//                         : "/bet-history"
//                     )
//                   }
//                 >
//                   History
//                 </button>
//               </div>

//               <div className="recent-result-row">
//                 {recentResults.length ===
//                 0 ? (
//                   <span className="empty-result">
//                     No completed
//                     rounds yet
//                   </span>
//                 ) : (
//                   recentResults
//                     .slice(
//                       0,
//                       10
//                     )
//                     .map(
//                       (item) => (
//                         <div
//                           key={
//                             item.id
//                           }
//                           className={`recent-number recent-${getNumberColor(
//                             Number(
//                               item.winning_number
//                             )
//                           )}`}
//                           title={`Round #${item.round_no}`}
//                         >
//                           {
//                             item.winning_number
//                           }
//                         </div>
//                       )
//                     )
//                 )}
//               </div>
//             </div>

//             {/* ROUND INFO */}
//             <div className="round-info-grid">
//               <div>
//                 <span>
//                   Round Time
//                 </span>

//                 <strong>
//                   {totalSeconds}s
//                 </strong>
//               </div>

//               <div>
//                 <span>
//                   Betting
//                 </span>

//                 <strong>
//                   {currentRound
//                     ?.betting_seconds ||
//                     40}
//                   s
//                 </strong>
//               </div>

//               <div>
//                 <span>
//                   Min /
//                   Position
//                 </span>

//                 <strong>
//                   {minBet ||
//                     "--"}
//                 </strong>
//               </div>

//               <div>
//                 <span>
//                   Max /
//                   Position
//                 </span>

//                 <strong>
//                   {maxBet ||
//                     "--"}
//                 </strong>
//               </div>
//             </div>
//           </aside>
//         </section>

//         {/* BETTING TABLE + SLIP */}
//         <section className="betting-layout">
//           <div
//             className={`roulette-table-card ${
//               !bettingOpen
//                 ? "table-locked"
//                 : ""
//             }`}
//           >
//             {/* BET MODE */}
//             <div className="table-toolbar">
//               <div>
//                 <span className="eyebrow">
//                   BET MODE
//                 </span>

//                 <div className="precision-mode-row">
//                   {Object.keys(
//                     PRECISION_MODES
//                   ).map(
//                     (mode) => (
//                       <button
//                         key={
//                           mode
//                         }
//                         type="button"
//                         className={
//                           precisionMode ===
//                           mode
//                             ? "active"
//                             : ""
//                         }
//                         onClick={() => {
//                           setPrecisionMode(
//                             mode
//                           );

//                           setPrecisionSelection(
//                             []
//                           );
//                         }}
//                         disabled={
//                           !bettingOpen
//                         }
//                       >
//                         {BET_TYPES[
//                           mode
//                         ]?.name ||
//                           mode}
//                       </button>
//                     )
//                   )}
//                 </div>
//               </div>

//               <div className="precision-help">
//                 {precisionMode ===
//                 "SINGLE"
//                   ? "Click any number to place a chip"
//                   : `Select ${
//                       PRECISION_MODES[
//                         precisionMode
//                       ]
//                     } connected numbers`}

//                 {precisionSelection.length >
//                   0 && (
//                   <strong>
//                     {precisionSelection.join(
//                       " · "
//                     )}
//                   </strong>
//                 )}
//               </div>
//             </div>

//             {/* TABLE CHIP RACK */}
//             <div className="table-chip-rack">
//               <span className="table-chip-rack-label">
//                 SELECT CHIP
//               </span>

//               <div className="table-chip-rack-coins">
//                 {CHIP_VALUES.map((chip) => (
//                   <button
//                     key={chip}
//                     type="button"
//                     className={`casino-chip chip-${chip} ${
//                       selectedChip === chip ? "selected" : ""
//                     }`}
//                     onClick={() => {
//                       setSelectedChip(chip);
//                       sounds.playChipSound();
//                     }}
//                     disabled={!bettingOpen}
//                   >
//                     {chip >= 1000 ? `${chip / 1000}K` : chip}
//                   </button>
//                 ))}
//               </div>

//               <span className="table-chip-rack-copy">
//                 {minBet > 0 ? `MIN ${minBet}` : "SELECT CHIP"}
//               </span>
//             </div>

//             {/* TABLE */}
//             <div className="roulette-table-scroll">
//               <div className="roulette-table">
//                 {/* ZERO */}
//                 <button
//                   type="button"
//                   className={`number-cell zero-cell ${
//                     precisionSelection.includes(
//                       0
//                     )
//                       ? "precision-selected"
//                       : ""
//                   }`}
//                   onClick={() =>
//                     handleNumberClick(
//                       0
//                     )
//                   }
//                   disabled={
//                     !bettingOpen
//                   }
//                 >
//                   <span>
//                     0
//                   </span>

//                   {getTableAmount(
//                     "SINGLE",
//                     0
//                   ) > 0 && (
//                     <b>
//                       {getTableAmount(
//                         "SINGLE",
//                         0
//                       )}
//                     </b>
//                   )}
//                 </button>

//                 {/* 1-36 */}
//                 <div className="number-grid">
//                   {NUMBER_ROWS.flatMap(
//                     (row) =>
//                       row.map(
//                         (
//                           number
//                         ) => {
//                           const color =
//                             getNumberColor(
//                               number
//                             );

//                           const amount =
//                             getTableAmount(
//                               "SINGLE",
//                               number
//                             );

//                           const selected =
//                             precisionSelection.includes(
//                               number
//                             );

//                           return (
//                             <button
//                               type="button"
//                               key={
//                                 number
//                               }
//                               className={`number-cell ${color}-cell ${
//                                 selected
//                                   ? "precision-selected"
//                                   : ""
//                               }`}
//                               onClick={() =>
//                                 handleNumberClick(
//                                   number
//                                 )
//                               }
//                               disabled={
//                                 !bettingOpen
//                               }
//                             >
//                               <span>
//                                 {
//                                   number
//                                 }
//                               </span>

//                               {amount >
//                                 0 && (
//                                 <b>
//                                   {
//                                     amount
//                                   }
//                                 </b>
//                               )}
//                             </button>
//                           );
//                         }
//                       )
//                   )}
//                 </div>

//                 {/* COLUMNS */}
//                 <div className="column-bets" style={{ borderTop: '1px solid #fff', borderRight: '1px solid #fff', borderBottom: '1px solid #fff' }}>
//                   {[
//                     [
//                       "COLUMN_3",
//                       "COLUMN_3",
//                       "2:1"
//                     ],
//                     [
//                       "COLUMN_2",
//                       "COLUMN_2",
//                       "2:1"
//                     ],
//                     [
//                       "COLUMN_1",
//                       "COLUMN_1",
//                       "2:1"
//                     ]
//                   ].map(
//                     ([
//                       type,
//                       value,
//                       label
//                     ]) => (
//                       <button
//                         key={
//                           type
//                         }
//                         type="button"
//                         onClick={() =>
//                           addOutsideBet(
//                             type,
//                             value,
//                             BET_TYPES[
//                               type
//                             ].name
//                           )
//                         }
//                         disabled={
//                           !bettingOpen
//                         }
//                       >
//                         <span>
//                           {
//                             label
//                           }
//                         </span>

//                         {getTableAmount(
//                           type,
//                           value
//                         ) > 0 && (
//                           <b>
//                             {getTableAmount(
//                               type,
//                               value
//                             )}
//                           </b>
//                         )}
//                       </button>
//                     )
//                   )}
//                 </div>

//                 {/* DOZENS */}
//                 <div className="dozen-row" style={{ borderLeft: '1px solid #fff', borderRight: '1px solid #fff' }}>
//                   {[
//                     [
//                       "DOZEN_1",
//                       "DOZEN_1",
//                       "1st 12"
//                     ],
//                     [
//                       "DOZEN_2",
//                       "DOZEN_2",
//                       "2nd 12"
//                     ],
//                     [
//                       "DOZEN_3",
//                       "DOZEN_3",
//                       "3rd 12"
//                     ]
//                   ].map(
//                     ([
//                       type,
//                       value,
//                       label
//                     ]) => (
//                       <button
//                         key={
//                           type
//                         }
//                         type="button"
//                         onClick={() =>
//                           addOutsideBet(
//                             type,
//                             value,
//                             label
//                           )
//                         }
//                         disabled={
//                           !bettingOpen
//                         }
//                       >
//                         <span>
//                           {
//                             label
//                           }
//                         </span>

//                         <small>
//                           2:1
//                         </small>

//                         {getTableAmount(
//                           type,
//                           value
//                         ) > 0 && (
//                           <b>
//                             {getTableAmount(
//                               type,
//                               value
//                             )}
//                           </b>
//                         )}
//                       </button>
//                     )
//                   )}
//                 </div>

//                 {/* OUTSIDE */}
//                 <div className="outside-row">
//                   {[
//                     [
//                       "LOW",
//                       "LOW",
//                       "1 to 18",
//                       ""
//                     ],
//                     [
//                       "EVEN",
//                       "EVEN",
//                       "EVEN",
//                       ""
//                     ],
//                     [
//                       "RED",
//                       "RED",
//                       "RED",
//                       "red-zone"
//                     ],
//                     [
//                       "BLACK",
//                       "BLACK",
//                       "BLACK",
//                       "black-zone"
//                     ],
//                     [
//                       "ODD",
//                       "ODD",
//                       "ODD",
//                       ""
//                     ],
//                     [
//                       "HIGH",
//                       "HIGH",
//                       "19 to 36",
//                       ""
//                     ]
//                   ].map(
//                     ([
//                       type,
//                       value,
//                       label,
//                       className
//                     ]) => (
//                       <button
//                         key={
//                           type
//                         }
//                         type="button"
//                         className={
//                           className
//                         }
//                         onClick={() =>
//                           addOutsideBet(
//                             type,
//                             value,
//                             label
//                           )
//                         }
//                         disabled={
//                           !bettingOpen
//                         }
//                       >
//                         <span>
//                           {
//                             label
//                           }
//                         </span>

//                         {getTableAmount(
//                           type,
//                           value
//                         ) > 0 && (
//                           <b>
//                             {getTableAmount(
//                               type,
//                               value
//                             )}
//                           </b>
//                         )}
//                       </button>
//                     )
//                   )}
//                 </div>

//                 {/* SPECIAL ZERO BETS */}
//                 <div className="zero-special-row">
//                   <span>
//                     ZERO BETS
//                   </span>

//                   {[
//                     [
//                       "SPLIT",
//                       [0, 1],
//                       "0-1"
//                     ],
//                     [
//                       "SPLIT",
//                       [0, 2],
//                       "0-2"
//                     ],
//                     [
//                       "SPLIT",
//                       [0, 3],
//                       "0-3"
//                     ],
//                     [
//                       "STREET",
//                       [0, 1, 2],
//                       "0-1-2"
//                     ],
//                     [
//                       "STREET",
//                       [0, 2, 3],
//                       "0-2-3"
//                     ],
//                     [
//                       "CORNER",
//                       [0, 1, 2, 3],
//                       "0-1-2-3"
//                     ]
//                   ].map(
//                     ([
//                       type,
//                       value,
//                       label
//                     ]) => (
//                       <button
//                         key={`${type}-${label}`}
//                         type="button"
//                         onClick={() =>
//                           addBetAction(
//                             type,
//                             value,
//                             `${
//                               BET_TYPES[
//                                 type
//                               ].name
//                             } ${label}`
//                           )
//                         }
//                         disabled={
//                           !bettingOpen
//                         }
//                       >
//                         {
//                           label
//                         }

//                         {getTableAmount(
//                           type,
//                           value
//                         ) > 0 && (
//                           <b>
//                             {getTableAmount(
//                               type,
//                               value
//                             )}
//                           </b>
//                         )}
//                       </button>
//                     )
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* CLOSED OVERLAY */}
//             {!bettingOpen && (
//               <div className="betting-closed-overlay">
//                 <strong>
//                   NO MORE BETS
//                 </strong>

//                 <span>
//                   Wheel spinning ·
//                   result coming
//                 </span>
//               </div>
//             )}
//           </div>

//           {/* BET SLIP */}
//           <aside className="bet-slip-card">
//             <div className="bet-slip-title">
//               <div>
//                 <span>
//                   BET SLIP
//                 </span>

//                 <strong>
//                   {
//                     stagedGroups.length
//                   }{" "}
//                   positions ready
//                 </strong>
//               </div>

//               <span
//                 className={
//                   bettingOpen
//                     ? "open-dot"
//                     : "closed-dot"
//                 }
//               />
//             </div>

//             <div className="bet-summary-list">
//               {stagedGroups.length ===
//               0 ? (
//                 <div className="empty-bet-slip">
//                   <span>
//                     ◎
//                   </span>

//                   <strong>
//                     Place chips on
//                     the table
//                   </strong>

//                   <small>
//                     Your
//                     unconfirmed
//                     bets will
//                     appear here.
//                   </small>
//                 </div>
//               ) : (
//                 stagedGroups.map(
//                   (bet) => (
//                     <div
//                       key={
//                         betKey(
//                           bet
//                         )
//                       }
//                       className={
//                         bet.amount <
//                         minBet
//                           ? "bet-under-min"
//                           : ""
//                       }
//                     >
//                       <span>
//                         <strong>
//                           {
//                             bet.name
//                           }
//                         </strong>

//                         <small>
//                           {BET_TYPES[
//                             bet.type
//                           ]?.ratio ||
//                             ""}
//                         </small>
//                       </span>

//                       <b>
//                         🪙{" "}
//                         {bet.amount.toLocaleString()}
//                       </b>
//                     </div>
//                   )
//                 )
//               )}
//             </div>

//             {/* TOTALS */}
//             <div className="bet-totals">
//               <div>
//                 <span>
//                   Ready to
//                   confirm
//                 </span>

//                 <strong>
//                   {stagedTotal.toLocaleString()}
//                 </strong>
//               </div>

//               <div>
//                 <span>
//                   Already
//                   confirmed
//                 </span>

//                 <strong>
//                   {confirmedTotal.toLocaleString()}
//                 </strong>
//               </div>
//             </div>

//             {/* ACTIONS */}
//             <div className="bet-action-grid">
//               <button
//                 type="button"
//                 onClick={
//                   handleUndo
//                 }
//                 disabled={
//                   !bettingOpen ||
//                   betActions.length ===
//                     0
//                 }
//               >
//                 ↶ Undo
//               </button>

//               <button
//                 type="button"
//                 onClick={
//                   handleClear
//                 }
//                 disabled={
//                   !bettingOpen ||
//                   betActions.length ===
//                     0
//                 }
//               >
//                 ✕ Clear
//               </button>

//               <button
//                 type="button"
//                 onClick={
//                   handleRepeat
//                 }
//                 disabled={
//                   !bettingOpen ||
//                   lastSubmittedActions.length ===
//                     0
//                 }
//               >
//                 ⟳ Repeat
//               </button>

//               <button
//                 type="button"
//                 onClick={
//                   handleDouble
//                 }
//                 disabled={
//                   !bettingOpen ||
//                   (betActions.length ===
//                     0 &&
//                     committedActions.length ===
//                       0)
//                 }
//               >
//                 2× Double
//               </button>
//             </div>

//             {/* CONFIRM */}
//             <button
//               type="button"
//               className="confirm-bets-button"
//               onClick={
//                 isComputerSession ? undefined : handlePlaceBets
//               }
//               disabled={
//                 isComputerSession ||
//                 !bettingOpen ||
//                 placingBets ||
//                 stagedGroups.length ===
//                   0 ||
//                 invalidMinGroups.length >
//                   0 ||
//                 invalidMaxGroups.length >
//                   0 ||
//                 stagedTotal >
//                   Number(
//                     user?.wallet ||
//                       0
//                   )
//               }
//             >
//               {isComputerSession
//                 ? "VIEW ONLY"
//                 : placingBets
//                 ? "CONFIRMING..."
//                 : `CONFIRM BETS · 🪙 ${stagedTotal.toLocaleString()}`}
//             </button>

//             {invalidMinGroups.length >
//               0 && (
//               <div className="bet-warning">
//                 Add more chips:
//                 minimum {minBet}{" "}
//                 per position.
//               </div>
//             )}

//             {invalidMaxGroups.length >
//               0 && (
//               <div className="bet-warning">
//                 Maximum{" "}
//                 {maxBet} coins
//                 per position.
//               </div>
//             )}
//           </aside>
//         </section>
//       </main>

//       {/* RESULT */}
//       {roundOutcome?.visible && (
//         <div
//           className="round-result-overlay"
//           onClick={() =>
//             setRoundOutcome(
//               null
//             )
//           }
//         >
//           <div
//             className="round-result-card"
//             onClick={(
//               event
//             ) =>
//               event.stopPropagation()
//             }
//           >
//             <span className="result-kicker">
//               ROUND #
//               {
//                 roundOutcome.roundNo
//               }{" "}
//               RESULT
//             </span>

//             <div
//               className={`result-number result-${getNumberColor(
//                 roundOutcome.winningNumber
//               )}`}
//             >
//               {
//                 roundOutcome.winningNumber
//               }
//             </div>

//             {roundOutcome.settlementPending ? (
//               <>
//                 <h2>
//                   WINNING NUMBER
//                 </h2>

//                 <p>
//                   Ball settled.
//                   Final settlement
//                   completes at
//                   0 seconds.
//                 </p>
//               </>
//             ) : roundOutcome.playerBetCount >
//               0 ? (
//               roundOutcome.totalWin >
//               0 ? (
//                 <>
//                   <h2>
//                     YOU WIN
//                   </h2>

//                   <strong className="winning-coin-result">
//                     + 🪙{" "}
//                     {roundOutcome.totalWin.toLocaleString()}{" "}
//                     Winning Coins
//                   </strong>

//                   <p>
//                     Winning coins
//                     are ready as a
//                     pending claim
//                     with your Shop.
//                   </p>
//                 </>
//               ) : (
//                 <>
//                   <h2>
//                     ROUND
//                     COMPLETE
//                   </h2>

//                   <p>
//                     Next betting
//                     round is
//                     already open.
//                   </p>
//                 </>
//               )
//             ) : (
//               <>
//                 <h2>
//                   WINNING NUMBER
//                 </h2>

//                 <p>
//                   No bet was
//                   placed in this
//                   round.
//                 </p>
//               </>
//             )}

//             <button
//               type="button"
//               onClick={() =>
//                 setRoundOutcome(
//                   null
//                 )
//               }
//             >
//               CONTINUE
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Game;









import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import RouletteWheel3D from "./RouletteWheel3D";
import authService from "../services/authService";
import computerAuthService from "../services/computerAuthService";
import gameService from "../services/gameService";
import { BET_TYPES, getNumberColor } from "../utils/gameLogic";
import { sounds } from "../utils/audio";
import "./Game.css";

const CHIP_VALUES = [1, 5, 10, 50, 100, 500, 1000];

const THEMES = [
  { id: "classic", name: "Classic Green" },
  { id: "royal", name: "Royal Black Gold" },
  { id: "neon", name: "Neon Blue" },
  { id: "ruby", name: "Ruby Casino" }
];

const PRECISION_MODES = {
  SINGLE: 1,
  SPLIT: 2,
  STREET: 3,
  CORNER: 4,
  SIX_LINE: 6
};

const NUMBER_ROWS = [
  [3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36],
  [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35],
  [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34]
];

const asSortedNumbers = (value) => {
  if (Array.isArray(value)) {
    return [...value]
      .map(Number)
      .sort((a, b) => a - b);
  }

  const text = String(value ?? "").trim();

  if (text.startsWith("[") && text.endsWith("]")) {
    try {
      const parsed = JSON.parse(text);

      if (Array.isArray(parsed)) {
        return parsed
          .map(Number)
          .sort((a, b) => a - b);
      }
    } catch (error) {
      return [];
    }
  }

  if (text.includes(",")) {
    return text
      .split(",")
      .map((item) => Number(item.trim()))
      .filter(Number.isFinite)
      .sort((a, b) => a - b);
  }

  const number = Number(text);

  return Number.isFinite(number)
    ? [number]
    : [];
};

const canonicalValue = (value) => {
  if (Array.isArray(value)) {
    return JSON.stringify(
      [...value]
        .map(Number)
        .sort((a, b) => a - b)
    );
  }

  return String(value);
};

const betKey = (bet) =>
  `${bet.type}:${canonicalValue(bet.value)}`;

const aggregateBets = (actions) => {
  const map = new Map();

  actions.forEach((action) => {
    const key = betKey(action);
    const existing = map.get(key);

    if (existing) {
      existing.amount += Number(
        action.amount || 0
      );
    } else {
      map.set(key, {
        ...action,
        amount: Number(
          action.amount || 0
        )
      });
    }
  });

  return Array.from(map.values());
};

const displayValue = (type, value) => {
  if (
    [
      "RED",
      "BLACK",
      "EVEN",
      "ODD",
      "LOW",
      "HIGH"
    ].includes(type)
  ) {
    return String(value)
      .replace("LOW", "1-18")
      .replace("HIGH", "19-36");
  }

  if (type.startsWith("COLUMN_")) {
    return `${type.replace(
      "COLUMN_",
      ""
    )} Column`;
  }

  if (type.startsWith("DOZEN_")) {
    const index = Number(
      type.replace("DOZEN_", "")
    );

    return index === 1
      ? "1-12"
      : index === 2
        ? "13-24"
        : "25-36";
  }

  const numbers =
    asSortedNumbers(value);

  return numbers.length
    ? numbers.join(" • ")
    : String(value);
};

const historyToAction = (bet) => ({
  type: String(
    bet.bet_type || "SINGLE"
  ),

  value: [
    "SINGLE",
    "SPLIT",
    "STREET",
    "CORNER",
    "SIX_LINE"
  ].includes(bet.bet_type)
    ? asSortedNumbers(
      bet.bet_value
    ).length === 1
      ? asSortedNumbers(
        bet.bet_value
      )[0]
      : asSortedNumbers(
        bet.bet_value
      )
    : String(bet.bet_value),

  name: `${BET_TYPES[bet.bet_type]?.name ||
    bet.bet_type
    } ${displayValue(
      bet.bet_type,
      bet.bet_value
    )}`,

  amount: Number(
    bet.amount || 0
  )
});

const isValidPrecision = (
  type,
  selected
) => {
  const numbers = [
    ...selected
  ]
    .map(Number)
    .sort((a, b) => a - b);

  if (type === "SINGLE") {
    return (
      numbers.length === 1 &&
      numbers[0] >= 0 &&
      numbers[0] <= 36
    );
  }

  if (type === "SPLIT") {
    if (numbers.length !== 2) {
      return false;
    }

    const [a, b] = numbers;

    if (a === 0) {
      return [1, 2, 3].includes(b);
    }

    const vertical =
      b - a === 3;

    const horizontal =
      b - a === 1 &&
      Math.floor((a - 1) / 3) ===
      Math.floor((b - 1) / 3);

    return (
      vertical ||
      horizontal
    );
  }

  if (type === "STREET") {
    if (numbers.length !== 3) {
      return false;
    }

    const [a, b, c] = numbers;

    if (a === 0) {
      return (
        (b === 1 && c === 2) ||
        (b === 2 && c === 3)
      );
    }

    return (
      a >= 1 &&
      a <= 34 &&
      a % 3 === 1 &&
      b === a + 1 &&
      c === a + 2
    );
  }

  if (type === "CORNER") {
    if (numbers.length !== 4) {
      return false;
    }

    const [a, b, c, d] =
      numbers;

    if (a === 0) {
      return (
        b === 1 &&
        c === 2 &&
        d === 3
      );
    }

    return (
      a >= 1 &&
      a <= 32 &&
      a % 3 !== 0 &&
      b === a + 1 &&
      c === a + 3 &&
      d === a + 4
    );
  }

  if (type === "SIX_LINE") {
    if (numbers.length !== 6) {
      return false;
    }

    const [
      a,
      b,
      c,
      d,
      e,
      f
    ] = numbers;

    return (
      a >= 1 &&
      a <= 31 &&
      a % 3 === 1 &&
      b === a + 1 &&
      c === a + 2 &&
      d === a + 3 &&
      e === a + 4 &&
      f === a + 5
    );
  }

  return false;
};

const Game = () => {
  const navigate = useNavigate();

  // Full-view responsive dimensions & scaler (fills 100% of 15" screen edge-to-edge with no black bars)
  const [dimensions, setDimensions] = useState(() => {
    if (typeof window !== "undefined") {
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const BASE_HEIGHT = 864;
      const MIN_STAGE_WIDTH = 1460;
      const isMobile = vw <= 900 || (vw <= 1100 && vh <= 600);
      const isLandscape = vw > vh;
      const scale = Math.min(vh / BASE_HEIGHT, vw / MIN_STAGE_WIDTH);
      return {
        scale,
        stageWidth: vw / scale,
        stageHeight: vh / scale,
        vw,
        vh,
        isMobile,
        isLandscape
      };
    }
    return { scale: 1, stageWidth: 1536, stageHeight: 864, vw: 1536, vh: 864, isMobile: false, isLandscape: false };
  });

  useEffect(() => {
    const handleResize = () => {
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const BASE_HEIGHT = 864;
      const MIN_STAGE_WIDTH = 1460;
      const isMobile = vw <= 900 || (vw <= 1100 && vh <= 600);
      const isLandscape = vw > vh;
      const scale = Math.min(vh / BASE_HEIGHT, vw / MIN_STAGE_WIDTH);
      setDimensions({
        scale,
        stageWidth: vw / scale,
        stageHeight: vh / scale,
        vw,
        vh,
        isMobile,
        isLandscape
      });
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);

    let resizeObserver = null;
    if (typeof ResizeObserver !== "undefined" && document.documentElement) {
      resizeObserver = new ResizeObserver(() => {
        handleResize();
      });
      resizeObserver.observe(document.documentElement);
    }

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
      if (resizeObserver) resizeObserver.disconnect();
    };
  }, []);

  // Computer session (separate from legacy Player auth)
  const computerToken = sessionStorage.getItem("computer_token");

  const [computer, setComputer] = useState(() =>
    computerAuthService.getComputer()
  );

  const isComputerSession =
    Boolean(computerToken) && Boolean(computer);

  // Keep Computer header/profile data synced with the latest
  // read-only Computer profile from the backend.
  useEffect(() => {
    if (!isComputerSession) {
      return;
    }

    let active = true;

    const loadComputerProfile = async () => {
      try {
        const response =
          await computerAuthService.getProfile();

        if (
          active &&
          response?.success &&
          response?.computer
        ) {
          setComputer(response.computer);
        }
      } catch (error) {
        console.error(
          "Computer profile load error:",
          error
        );
      }
    };

    loadComputerProfile();

    return () => {
      active = false;
    };
  }, [isComputerSession]);

  // Log Game screen opening once for a Computer session.
  useEffect(() => {
    if (
      !isComputerSession ||
      gameOpenedLoggedRef.current
    ) {
      return;
    }

    gameOpenedLoggedRef.current = true;

    computerAuthService
      .addActivity(
        "GAME_OPENED",
        `Game screen opened on ${computer?.computer_code || "Computer"
        }.`
      )
      .catch((error) => {
        console.error(
          "Game activity log error:",
          error
        );
      });
  }, [
    isComputerSession,
    computer?.computer_code
  ]);

  const [takeModalOpen, setTakeModalOpen] = useState(false);
  const [takeModalAmount, setTakeModalAmount] = useState("");
  const [lastTakeAmount, setLastTakeAmount] = useState(() => {
    try {
      const compId = JSON.parse(sessionStorage.getItem("computer") || "{}")?.id;
      const usrId = JSON.parse(localStorage.getItem("user") || "{}")?.id;
      const key1 = compId ? `last_take_amount_comp_${compId}` : null;
      const key2 = usrId ? `last_take_amount_user_${usrId}` : null;
      const val = (key1 && localStorage.getItem(key1)) || (key2 && localStorage.getItem(key2)) || localStorage.getItem("last_take_amount");
      return val ? Number(val) : null;
    } catch {
      return null;
    }
  });
  const [takingCoins, setTakingCoins] = useState(false);
  const [pendingWin, setPendingWin] = useState(0);
  const [displayedWin, setDisplayedWin] = useState(0);
  const [scoreGlow, setScoreGlow] = useState(false);
  const pendingWinRef = useRef(0);
  const pendingWinTimerRef = useRef(null);
  const uncreditedWinRef = useRef(0);
  const winCreditTimerRef = useRef(null);

  useEffect(() => {
    if (isComputerSession) {
      computerAuthService.getHistory().then((data) => {
        const list = data?.activities || data?.history || [];
        const takeAct = list.find((a) => a.activity_type === "TAKE_COINS");
        if (takeAct && takeAct.note) {
          const match = takeAct.note.match(/Returned\s+(\d+(?:\.\d+)?)\s+coins/i);
          if (match && Number(match[1]) > 0) {
            const amt = Number(match[1]);
            setLastTakeAmount((prev) => prev || amt);
            localStorage.setItem("last_take_amount", String(amt));
            if (computer?.id) {
              localStorage.setItem(`last_take_amount_comp_${computer.id}`, String(amt));
            }
          }
        }
      }).catch(() => {});
    }
  }, [isComputerSession, computer?.id]);

  const getAvailableTakeCoins = () => {
    if (isComputerSession) {
      return Number(computer?.current_balance || 0);
    }
    return Number(user?.wallet_balance ?? user?.wallet ?? 0);
  };

  const confirmTakeCoins = async () => {
    if (takingCoins) return;

    const maxAmount = getAvailableTakeCoins();
    const amount = Number(takeModalAmount);
    if (isNaN(amount) || amount <= 0) {
      toast.error("Please enter a valid coin amount to send to shop.");
      return;
    }
    if (amount > maxAmount) {
      toast.error(`Cannot take ${amount} coins. Available Score: ${maxAmount.toFixed(2)}`);
      return;
    }

    setTakingCoins(true);
    try {
      const response = await computerAuthService.takeAllCoins(amount);

      setPendingWin(0);
      pendingWinRef.current = 0;

      if (isComputerSession || computer) {
        const nextBal = response?.computer?.current_balance !== undefined
          ? Number(response.computer.current_balance)
          : Math.max(0, Number(computer?.current_balance || 0) - amount);

        const updatedComp = {
          ...computer,
          ...(response?.computer || {}),
          current_balance: nextBal,
        };
        setComputer(updatedComp);
        sessionStorage.setItem("computer", JSON.stringify(updatedComp));
      }

      if (user) {
        const newWallet = response?.player_wallet !== undefined
          ? Number(response.player_wallet)
          : Math.max(0, Number(user?.wallet_balance ?? user?.wallet ?? 0) - amount);
        const updatedUser = { ...user, wallet: newWallet, wallet_balance: newWallet };
        setUser(updatedUser);
        localStorage.setItem("user", JSON.stringify(updatedUser));
      }

      toast.success(`${amount} coins successfully sent to Shop!`);
      setLastTakeAmount(amount);
      try {
        localStorage.setItem("last_take_amount", String(amount));
        if (isComputerSession && computer?.id) {
          localStorage.setItem(`last_take_amount_comp_${computer.id}`, String(amount));
        } else if (user?.id) {
          localStorage.setItem(`last_take_amount_user_${user.id}`, String(amount));
        }
      } catch (e) {}
      setTakeModalAmount("");
      setTakeModalOpen(false);
    } catch (error) {
      console.error("Take coins error:", error);
      toast.error(error.response?.data?.message || error.message || "Failed to send coins to shop");
    } finally {
      setTakingCoins(false);
    }
  };

  const [user, setUser] =
    useState(() =>
      authService.getCurrentUser()
    );

  const [
    currentRound,
    setCurrentRound
  ] = useState(null);

  const [
    recentResults,
    setRecentResults
  ] = useState([]);

  const [
    history,
    setHistory
  ] = useState([]);

  const [
    loading,
    setLoading
  ] = useState(true);

  const [
    selectedChip,
    setSelectedChip
  ] = useState(1);

  const [
    precisionMode,
    setPrecisionMode
  ] = useState("SINGLE");

  const [
    precisionSelection,
    setPrecisionSelection
  ] = useState([]);

  const [hoveredNumber, setHoveredNumber] = useState(null);
  const [hoveredBet, setHoveredBet] = useState(null);
  const [hasClearedOnce, setHasClearedOnce] = useState(false);

  const [
    betActions,
    setBetActions
  ] = useState([]);

  const betActionsRef = useRef([]);

  useEffect(() => {
    betActionsRef.current = betActions;
  }, [betActions]);

  const [
    committedActions,
    setCommittedActions
  ] = useState([]);

  const committedActionsRef = useRef([]);

  const [
    settlingActions,
    setSettlingActions
  ] = useState([]);

  useEffect(() => {
    committedActionsRef.current = committedActions;
  }, [committedActions]);

  const [
    lastSubmittedActions,
    setLastSubmittedActions
  ] = useState([]);

  const [
    placingBets,
    setPlacingBets
  ] = useState(false);

  const [
    wheelResult,
    setWheelResult
  ] = useState(null);

  const [
    wheelSettled,
    setWheelSettled
  ] = useState(true);

  const [
    isWheelSpinning,
    setIsWheelSpinning
  ] = useState(false);

  const isWheelSpinningRef = useRef(false);
  const wheelSpinTimerRef = useRef(null);

  useEffect(() => {
    isWheelSpinningRef.current = isWheelSpinning;
  }, [isWheelSpinning]);

  const displayedRecentResults = useMemo(() => {
    if (isWheelSpinning) {
      // While wheel is actively spinning, NEVER show the winning number until the wheel stops!
      if (wheelResult !== null && wheelResult !== undefined && recentResults.length > 0) {
        if (Number(recentResults[0]?.winning_number) === Number(wheelResult)) {
          return recentResults.slice(1, 11);
        }
      }
    }
    return recentResults.slice(0, 10);
  }, [isWheelSpinning, wheelResult, recentResults]);

  const [
    roundOutcome,
    setRoundOutcome
  ] = useState(null);

  const pendingOutcomeRef =
    useRef(null);

  const autoCloseOutcomeTimerRef =
    useRef(null);

  const [
    theme,
    setTheme
  ] = useState(
    () =>
      localStorage.getItem(
        "casinoPlayerTheme"
      ) || "classic"
  );

  const [
    pendingTheme,
    setPendingTheme
  ] = useState(null);

  const [
    soundEnabled,
    setSoundEnabled
  ] = useState(false);

  const currentRoundRef =
    useRef(null);

  const previousPhaseRef =
    useRef(null);

  const lastCountdownBeepRef =
    useRef(null);

  const outcomeRef =
    useRef(null);

  // Computer-only activity refs. These prevent the 1-second
  // round polling from writing duplicate history records.
  const gameOpenedLoggedRef =
    useRef(false);

  const lastRoundViewedRef =
    useRef(null);

  const lastResultViewedRef =
    useRef(null);

  const pendingRecentResultsRef =
    useRef(null);

  const handleWheelSettledRef =
    useRef(null);

  const bettingOpen =
    currentRound?.betting_open ===
    true;

  const phase =
    currentRound?.phase ||
    (bettingOpen
      ? "BETTING"
      : "SPINNING");

  const bettingRemaining =
    Number(
      currentRound
        ?.betting_remaining_seconds ||
      0
    );

  const phaseRemaining =
    Number(
      currentRound
        ?.phase_remaining_seconds ||
      0
    );

  const timerValue =
    Number(
      currentRound?.remaining_seconds ??
      (phase === "BETTING" ? bettingRemaining : phaseRemaining)
    );

  const timerMax =
    Number(
      currentRound?.total_seconds ||
      60
    );

  const timerProgress =
    timerMax > 0
      ? Math.max(
        0,
        Math.min(
          1,
          timerValue /
          timerMax
        )
      )
      : 0;

  const timerRadius = 52;
  const timerCircumference = 2 * Math.PI * timerRadius;
  const warningSeconds = Math.min(10, timerMax);
  const normalSeconds = timerMax - warningSeconds;
  const elapsedSeconds = Math.max(0, Math.min(timerMax, timerMax - timerValue));

  const blueSeconds = Math.min(elapsedSeconds, normalSeconds);
  const blueRatio = timerMax > 0 ? blueSeconds / timerMax : 0;
  const blueOffset = timerCircumference * (1 - blueRatio);

  const redSeconds = Math.max(0, elapsedSeconds - normalSeconds);
  const redRatio = timerMax > 0 ? redSeconds / timerMax : 0;
  const redOffset = timerCircumference * (1 - redRatio);
  const redStartAngle = timerMax > 0 ? (normalSeconds / timerMax) * 360 : 300;

  const totalSeconds =
    Number(
      currentRound?.total_seconds ||
      60
    );

  const minBet = 0; // Disabled min bet requirement

  const maxBet =
    Number(
      currentRound?.max_bet ||
      0
    );

  // Backend exposes the already-locked roulette target only
  // near the end of the current SPINNING phase.
  // It is used only to settle the wheel; the wheel component
  // reveals the number only after the ball has actually stopped.
  const spinTarget =
    currentRound?.spin_target !== null &&
      currentRound?.spin_target !== undefined &&
      Number.isInteger(
        Number(
          currentRound.spin_target
        )
      )
      ? Number(
        currentRound.spin_target
      )
      : null;

  const wheelTarget =
    wheelSettled
      ? wheelResult
      : spinTarget;

  const stagedGroups =
    useMemo(
      () =>
        aggregateBets(
          betActions
        ),
      [betActions]
    );

  const tableGroups =
    useMemo(
      () =>
        aggregateBets([
          ...settlingActions,
          ...committedActions,
          ...betActions
        ]),
      [
        settlingActions,
        committedActions,
        betActions
      ]
    );

  const committedGroups =
    useMemo(
      () =>
        aggregateBets([
          ...settlingActions,
          ...committedActions
        ]),
      [settlingActions, committedActions]
    );

  const stagedTotal =
    useMemo(
      () =>
        betActions.reduce(
          (sum, item) =>
            sum +
            Number(
              item.amount || 0
            ),
          0
        ),
      [betActions]
    );

  const confirmedTotal =
    useMemo(
      () =>
        [...settlingActions, ...committedActions].reduce(
          (sum, item) =>
            sum +
            Number(
              item.amount || 0
            ),
          0
        ),
      [settlingActions, committedActions]
    );

  const isRebetGlowing = Boolean(
    bettingOpen &&
    !isWheelSpinning &&
    lastSubmittedActions.length > 0 &&
    committedActions.length === 0 &&
    stagedGroups.length === 0
  );

  const isBetGlowing = Boolean(
    bettingOpen &&
    !isWheelSpinning &&
    !placingBets &&
    committedActions.length === 0
  );

  const pendingWinningCoins =
    useMemo(
      () =>
        history
          .filter(
            (bet) =>
              bet.status ===
              "WIN" &&
              bet.claim_status ===
              "PENDING"
          )
          .reduce(
            (sum, bet) =>
              sum +
              Number(
                bet.win_amount ||
                0
              ),
            0
          ),
      [history]
    );

  const invalidMinGroups =
    useMemo(
      () => [],
      [
        stagedGroups,
        minBet
      ]
    );

  const invalidMaxGroups =
    useMemo(
      () =>
        maxBet > 0
          ? stagedGroups.filter(
            (bet) =>
              bet.amount >
              maxBet
          )
          : [],
      [
        stagedGroups,
        maxBet
      ]
    );

  const refreshProfile =
    useCallback(
      async () => {
        if (isComputerSession) {
          try {
            const response = await computerAuthService.getProfile();
            if (response?.computer) {
              setComputer(response.computer);
              return response.computer;
            }
          } catch (error) {
            console.error("Computer profile refresh error:", error);
          }
          return null;
        }

        try {
          const response =
            await authService.getProfile();

          if (response?.user) {
            setUser(
              response.user
            );
            return response.user;
          } else {
            const current = authService.getCurrentUser();
            setUser(current);
            return current;
          }
        } catch (error) {
          // Session interceptor
          return null;
        }
      },
      [isComputerSession]
    );

  const refreshHistory =
    useCallback(
      async () => {
        try {
          const response =
            await gameService.getHistory();

          const rows =
            Array.isArray(
              response?.history
            )
              ? response.history
              : [];

          setHistory(rows);

          return rows;
        } catch (error) {
          return [];
        }
      },
      []
    );

  const fetchRecentResultsQuiet =
    useCallback(
      async () => {
        try {
          const response =
            await gameService.getRecentResults(
              10
            );

          const rows =
            Array.isArray(
              response?.results
            )
              ? response.results
              : [];

          return rows;
        } catch (error) {
          return [];
        }
      },
      []
    );

  const refreshRecentResults =
    useCallback(
      async () => {
        try {
          const response =
            await gameService.getRecentResults(
              10
            );

          const rows =
            Array.isArray(
              response?.results
            )
              ? response.results
              : [];

          setRecentResults(rows);

          return rows;
        } catch (error) {
          return [];
        }
      },
      []
    );

  const notifiedRoundOutcomeRef = useRef(null);

  const showOutcomeToast = useCallback((outcome) => {
    if (!outcome) return;
    if (notifiedRoundOutcomeRef.current === outcome.roundId) return;
    notifiedRoundOutcomeRef.current = outcome.roundId;

    const winNum = outcome.winningNumber;
    const winColor = getNumberColor(winNum);
    const badgeBg = winColor === 'red' ? '#e01026' : (winColor === 'black' ? '#111' : '#087c50');

    if (outcome.totalWin > 0) {
      sounds.playWinSound();
      toast.success(
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <div style={{
            width: '46px',
            height: '46px',
            borderRadius: '50%',
            background: badgeBg,
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '24px',
            fontFamily: "'Oswald', sans-serif",
            flexShrink: 0,
            border: '2px solid #ffd88a',
            boxShadow: '0 2px 8px rgba(0,0,0,0.6)'
          }}>
            {winNum}
          </div>
          <div>
            <div style={{ fontWeight: 'bold', fontSize: '18px', color: '#ffd88a', fontFamily: "'Oswald', sans-serif" }}>
              Winning Number: {winNum}
            </div>
            <div style={{ fontWeight: 'bold', fontSize: '16px', color: '#52c41a', letterSpacing: '0.5px', marginTop: '2px' }}>
              YOU WIN! +🪙 {outcome.totalWin.toLocaleString()}
            </div>
          </div>
        </div>,
        {
          position: "top-center",
          autoClose: 3500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
          style: {
            background: 'linear-gradient(180deg, #2b180d 0%, #150a04 100%)',
            border: '2px solid #d48530',
            borderRadius: '12px',
            boxShadow: '0 8px 30px rgba(0,0,0,0.9)'
          }
        }
      );
    } else {
      toast.info(
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <div style={{
            width: '42px',
            height: '42px',
            borderRadius: '50%',
            background: badgeBg,
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '22px',
            fontFamily: "'Oswald', sans-serif",
            flexShrink: 0,
            border: '2px solid rgba(255,255,255,0.7)',
            boxShadow: '0 2px 6px rgba(0,0,0,0.5)'
          }}>
            {winNum}
          </div>
          <div style={{ fontWeight: 'bold', fontSize: '18px', color: '#ffd88a', fontFamily: "'Oswald', sans-serif", letterSpacing: '0.5px' }}>
            Winning Number: {winNum}
          </div>
        </div>,
        {
          position: "top-center",
          autoClose: 2500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
          style: {
            background: '#1c1c1c',
            border: '1.5px solid #d48530',
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.9)'
          }
        }
      );
    }
  }, []);

  const creditWinToScore =
    useCallback(
      (overrideAmount) => {
        if (winCreditTimerRef.current) {
          clearTimeout(winCreditTimerRef.current);
          winCreditTimerRef.current = null;
        }

        const amount = Number(overrideAmount ?? uncreditedWinRef.current ?? pendingWinRef.current ?? 0);
        if (amount > 0) {
          uncreditedWinRef.current = 0;
          pendingWinRef.current = 0;
          setPendingWin(0);
          setDisplayedWin(0);

          // 1. Play green/gold score glow animation
          setScoreGlow(true);
          setTimeout(() => setScoreGlow(false), 1500);

          // 2. Add win directly into score state
          if (isComputerSession) {
            setComputer((prev) => prev ? {
              ...prev,
              current_balance: Number(prev.current_balance || 0) + amount
            } : prev);
          } else {
            setUser((prev) => prev ? {
              ...prev,
              wallet: Number(prev.wallet_balance ?? prev.wallet ?? 0) + amount,
              wallet_balance: Number(prev.wallet_balance ?? prev.wallet ?? 0) + amount
            } : prev);
          }

          toast.success(`+${amount.toFixed(2)} added to Score!`, { autoClose: 2500 });

          // 3. Sync from backend to ensure persistence
          refreshProfile();
        }
      },
      [isComputerSession, refreshProfile]
    );

  const handleDismissOutcome =
    useCallback(
      () => {
        sounds.stopWheelSpinAudio();
        if (autoCloseOutcomeTimerRef.current) {
          clearTimeout(autoCloseOutcomeTimerRef.current);
          autoCloseOutcomeTimerRef.current = null;
        }
        if (uncreditedWinRef.current > 0 || pendingWinRef.current > 0) {
          creditWinToScore();
        }
        setDisplayedWin(0);
        setRoundOutcome(null);
        outcomeRef.current = null;
        pendingOutcomeRef.current = null;
      },
      [creditWinToScore]
    );

  const handleCompletedRound =
    useCallback(
      async (
        completedRoundId,
        activeRound
      ) => {
        const [
          results,
          rows
        ] =
          await Promise.all([
            fetchRecentResultsQuiet(),
            refreshHistory()
          ]);

        const completed =
          results.find(
            (item) =>
              Number(item.id) ===
              Number(
                completedRoundId
              )
          ) || (results.length > 0 ? results[0] : null);

        if (!completed) {
          return;
        }

        if (
          isComputerSession &&
          lastResultViewedRef.current !==
          Number(completed.id)
        ) {
          lastResultViewedRef.current =
            Number(completed.id);

          computerAuthService
            .addActivity(
              "RESULT_VIEWED",
              `Round #${completed.round_no ||
              completed.id
              } result viewed.`
            )
            .catch((error) => {
              console.error(
                "Result activity log error:",
                error
              );
            });
        }

        const playerRoundBets =
          rows.filter(
            (bet) =>
              Number(
                bet.round_id
              ) ===
              Number(
                completedRoundId
              )
          );

        const totalWin =
          playerRoundBets
            .filter(
              (bet) =>
                bet.status ===
                "WIN"
            )
            .reduce(
              (sum, bet) =>
                sum +
                Number(
                  bet.win_amount ||
                  0
                ),
              0
            );

        const winNum =
          Number(
            completed.winning_number
          );

        const outcome = {
          roundId:
            Number(
              completed.id
            ),

          roundNo:
            completed.round_no,

          winningNumber:
            winNum,

          playerBetCount:
            playerRoundBets.length,

          totalWin,

          settlementPending:
            false,

          visible: true
        };

        pendingOutcomeRef.current =
          outcome;

        outcomeRef.current =
          outcome;

        if (totalWin > 0) {
          uncreditedWinRef.current = totalWin;
          pendingWinRef.current = totalWin;
          setPendingWin(totalWin);
        } else {
          uncreditedWinRef.current = 0;
          pendingWinRef.current = 0;
          setPendingWin(0);
        }

        // Keep Win display 0 while wheel is spinning
        setDisplayedWin(0);

        const remSec = Number(
          currentRoundRef.current?.remaining_seconds ?? activeRound?.remaining_seconds ?? 59
        );

        setWheelResult(
          winNum
        );

        // Spin wheel from 59s to 53s for round result
        if (playerRoundBets.length > 0) {
          setSettlingActions(playerRoundBets.map(historyToAction));
        }

        if (remSec >= 52 || isWheelSpinningRef.current) {
          pendingRecentResultsRef.current = results;
          setRoundOutcome(null);
          setWheelSettled(false);
          setIsWheelSpinning(true);
          isWheelSpinningRef.current = true;
          if (wheelSpinTimerRef.current) {
            clearTimeout(wheelSpinTimerRef.current);
          }
          wheelSpinTimerRef.current = setTimeout(() => {
            handleWheelSettledRef.current?.();
          }, 6000);
        } else {
          // Wheel already stopped: clear settling actions & show new LAST 10 DATA immediately
          if (wheelSpinTimerRef.current) {
            clearTimeout(wheelSpinTimerRef.current);
            wheelSpinTimerRef.current = null;
          }
          setSettlingActions([]);
          pendingRecentResultsRef.current = null;
          setRecentResults(results);
          setWheelSettled(
            true
          );
          setIsWheelSpinning(
            false
          );
          isWheelSpinningRef.current = false;
          if (totalWin > 0) {
            setDisplayedWin(totalWin);
          }
          if (remSec <= 45 && uncreditedWinRef.current > 0) {
            creditWinToScore(totalWin);
          }
        }
      },
      [
        refreshHistory,
        refreshRecentResults,
        isComputerSession,
        creditWinToScore
      ]
    );

  const fetchCurrentRound =
    useCallback(
      async () => {
        try {
          const response =
            await gameService.getCurrentRound();

          const nextRound =
            response?.round ||
            response?.current_round ||
            null;

          if (!nextRound) {
            return null;
          }

          const previousRound =
            currentRoundRef.current;

          if (
            previousRound &&
            Number(
              previousRound.id
            ) !==
            Number(
              nextRound.id
            )
          ) {
            // Before next round starts, automatically add any pending win into Score
            if (uncreditedWinRef.current > 0 || pendingWinRef.current > 0) {
              creditWinToScore();
            }
            setDisplayedWin(0);

            if (autoCloseOutcomeTimerRef.current) {
              clearTimeout(autoCloseOutcomeTimerRef.current);
              autoCloseOutcomeTimerRef.current = null;
            }

            setRoundOutcome(null);
            outcomeRef.current = null;

            // Keep completed round bets in settlingActions during 59s-53s spin window
            const completedBets = [
              ...(committedActionsRef.current || []),
              ...(betActionsRef.current || [])
            ];
            setSettlingActions(completedBets);

            setBetActions([]);
            betActionsRef.current = [];
            setCommittedActions([]);
            committedActionsRef.current = [];

            setPrecisionSelection(
              []
            );

            if (pendingTheme) {
              setTheme(
                pendingTheme
              );

              localStorage.setItem(
                "casinoPlayerTheme",
                pendingTheme
              );

              setPendingTheme(
                null
              );
            }

            currentRoundRef.current =
              nextRound;

            setCurrentRound(
              nextRound
            );

            handleCompletedRound(
              previousRound.id,
              nextRound
            );
          } else {
            currentRoundRef.current =
              nextRound;

            setCurrentRound(
              nextRound
            );

            // Wheel spins 59s to 53s at start of round; do NOT spin at 10s
          }

          if (
            isComputerSession &&
            lastRoundViewedRef.current !==
            Number(nextRound.id)
          ) {
            lastRoundViewedRef.current =
              Number(nextRound.id);

            computerAuthService
              .addActivity(
                "ROUND_VIEWED",
                `Round #${nextRound.round_no ||
                nextRound.id
                } viewed.`
              )
              .catch((error) => {
                console.error(
                  "Round activity log error:",
                  error
                );
              });
          }

          return nextRound;
        } catch (error) {
          if (
            error.response
              ?.status === 404
          ) {
            setCurrentRound(
              null
            );
          }

          return null;
        }
      },
      [
        handleCompletedRound,
        pendingTheme,
        isComputerSession
      ]
    );

  useEffect(() => {
    sounds.setEnabled(true);
    localStorage.setItem("casinoSoundEnabled", "true");

    const unlockAudio = () => {
      sounds.unlockAudio();
      window.removeEventListener("pointerdown", unlockAudio);
      window.removeEventListener("keydown", unlockAudio);
      window.removeEventListener("click", unlockAudio);
      window.removeEventListener("touchstart", unlockAudio);
    };
    window.addEventListener("pointerdown", unlockAudio, { once: true });
    window.addEventListener("keydown", unlockAudio, { once: true });
    window.addEventListener("click", unlockAudio, { once: true });
    window.addEventListener("touchstart", unlockAudio, { once: true });

    return () => {
      window.removeEventListener("pointerdown", unlockAudio);
      window.removeEventListener("keydown", unlockAudio);
      window.removeEventListener("click", unlockAudio);
      window.removeEventListener("touchstart", unlockAudio);
    };
  }, []);

  useEffect(() => {
    const load = async () => {
      setLoading(true);

      const [
        round,
        results,
        rows
      ] =
        await Promise.all([
          fetchCurrentRound(),
          fetchRecentResultsQuiet(),
          refreshHistory(),
          refreshProfile()
        ]);

      if (round) {
        currentRoundRef.current =
          round;

        const pendingThisRound =
          rows
            .filter(
              (bet) =>
                Number(
                  bet.round_id
                ) ===
                Number(
                  round.id
                ) &&
                bet.status ===
                "PENDING"
            )
            .map(
              historyToAction
            );

        setCommittedActions(
          pendingThisRound
        );
        committedActionsRef.current = pendingThisRound;
      }

      if (
        results.length
      ) {
        const remSec = Number(round?.remaining_seconds ?? 59);
        if (remSec > 53 && results.length > 1) {
          // If loaded during 59-53s spinning window, hold newest result until wheel stops
          pendingRecentResultsRef.current = results;
          setRecentResults(results.slice(1));
          setWheelResult(
            Number(
              results[0]
                .winning_number
            )
          );
          setWheelSettled(false);
          setIsWheelSpinning(true);

          const settlingBets = rows
            .filter((bet) => Number(bet.round_id) === Number(results[0].id))
            .map(historyToAction);
          if (settlingBets.length > 0) {
            setSettlingActions(settlingBets);
          }
        } else {
          setSettlingActions([]);
          pendingRecentResultsRef.current = null;
          setRecentResults(results);
          setWheelResult(
            Number(
              results[0]
                .winning_number
            )
          );
          setWheelSettled(true);
          setIsWheelSpinning(false);
        }
      }

      setLoading(false);
    };

    load();

    const interval =
      setInterval(
        fetchCurrentRound,
        1000
      );

    const historyInterval =
      setInterval(
        refreshHistory,
        5000
      );

    return () => {
      clearInterval(
        interval
      );

      clearInterval(
        historyInterval
      );
    };
  }, [
    fetchCurrentRound,
    refreshHistory,
    refreshProfile,
    refreshRecentResults
  ]);

  useEffect(() => {
    if (
      previousPhaseRef.current !==
      phase
    ) {
      if (
        phase ===
        "SPINNING"
      ) {
        sounds.playNoMoreBetsSound();
        setPrecisionSelection(
          []
        );
      }

      previousPhaseRef.current =
        phase;
    }
  }, [phase]);

  useEffect(() => {
    const sec = Math.round(Number(timerValue));

    // Wheel spins from 59s down to 53s: force stop wheel once timer reaches 53s
    if (sec <= 53 && isWheelSpinning) {
      handleWheelSettledRef.current?.();
    }

    // When countdown timer reaches 45 seconds, transfer winning amount into Score!
    if (sec <= 45 && wheelSettled && (uncreditedWinRef.current > 0 || pendingWinRef.current > 0)) {
      creditWinToScore();
    }

    if (sec > 10) {
      lastCountdownBeepRef.current = null;
    } else if (
      sec > 0 &&
      sec <= 10 &&
      lastCountdownBeepRef.current !== sec
    ) {
      lastCountdownBeepRef.current = sec;
      sounds.stopWheelSpinAudio();
      sounds.playCountdownSound(sec);
    }
  }, [
    timerValue,
    wheelSettled,
    creditWinToScore
  ]);

  useEffect(() => {
    if (isWheelSpinning) {
      sounds.playWheelSpinAudio();
    } else {
      sounds.stopWheelSpinAudio();
    }
    return () => {
      sounds.stopWheelSpinAudio();
    };
  }, [
    isWheelSpinning
  ]);


  const getTableAmount =
    useCallback(
      (
        type,
        value
      ) => {
        const key =
          `${type}:${canonicalValue(
            value
          )}`;

        const found =
          tableGroups.find(
            (bet) =>
              betKey(bet) ===
              key
          );

        return Number(
          found?.amount ||
          0
        );
      },
      [tableGroups]
    );

  const isNumberInvolvedInBet =
    useCallback(
      (number) => {
        return tableGroups.some((bet) => {
          if (Array.isArray(bet.value)) {
            return bet.value.includes(number);
          }
          return bet.value === number;
        });
      },
      [tableGroups]
    );

  const isNumberCoveredByOutsideBet = useCallback((number) => {
    return tableGroups.some((bet) => {
      if (bet.type === "DOZEN_1") return number >= 1 && number <= 12;
      if (bet.type === "DOZEN_2") return number >= 13 && number <= 24;
      if (bet.type === "DOZEN_3") return number >= 25 && number <= 36;
      if (bet.type === "COLUMN_1") return number >= 1 && number <= 36 && number % 3 === 1;
      if (bet.type === "COLUMN_2") return number >= 1 && number <= 36 && number % 3 === 2;
      if (bet.type === "COLUMN_3") return number >= 1 && number <= 36 && number % 3 === 0;
      if (bet.type === "LOW") return number >= 1 && number <= 18;
      if (bet.type === "HIGH") return number >= 19 && number <= 36;
      if (bet.type === "EVEN") return number % 2 === 0 && number > 0;
      if (bet.type === "ODD") return number % 2 !== 0;
      if (bet.type === "RED") return getNumberColor(number) === 'red';
      if (bet.type === "BLACK") return getNumberColor(number) === 'black';
      return false;
    });
  }, [tableGroups]);

  const getNumbersForBetType = useCallback((type) => {
    if (type === "DOZEN_1") return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    if (type === "DOZEN_2") return [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
    if (type === "DOZEN_3") return [25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36];
    if (type === "COLUMN_1") return [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34];
    if (type === "COLUMN_2") return [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35];
    if (type === "COLUMN_3") return [3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36];
    if (type === "LOW") return Array.from({ length: 18 }, (_, i) => i + 1);
    if (type === "HIGH") return Array.from({ length: 18 }, (_, i) => i + 19);
    if (type === "EVEN") return Array.from({ length: 18 }, (_, i) => (i + 1) * 2);
    if (type === "ODD") return Array.from({ length: 18 }, (_, i) => i * 2 + 1);
    if (type === "RED") return [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36];
    if (type === "BLACK") return [2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35];
    return [];
  }, []);

  const addBetAction =
    useCallback(
      (
        type,
        value,
        name
      ) => {
        if (isWheelSpinningRef.current) {
          toast.warning("Wheel is spinning. Please wait for the result.");
          return;
        }

        if (!bettingOpen) {
          toast.warning("No more bets. Wait for the next round.");
          return;
        }

        if (committedActions.length > 0) {
          toast.warning(
            "Bet already confirmed for this round. Please wait for the round result!"
          );
          return;
        }

        if (settlingActions.length > 0) {
          setSettlingActions([]);
        }

        const nextTotal =
          stagedTotal +
          selectedChip;

        const wallet = isComputerSession
          ? Number(
            computer?.current_balance ||
            0
          )
          : Number(
            user?.wallet ||
            0
          );

        if (
          nextTotal >
          wallet
        ) {
          toast.error(
            isComputerSession
              ? "Insufficient available credits."
              : "Insufficient playable wallet balance."
          );

          return;
        }

        setBetActions(
          (previous) => [
            ...previous,
            {
              type,
              value,
              name,
              amount:
                selectedChip
            }
          ]
        );
        if (displayedWin > 0) {
          setDisplayedWin(0);
        }
        if (pendingWinRef.current > 0) {
          if (autoCloseOutcomeTimerRef.current) clearTimeout(autoCloseOutcomeTimerRef.current);
          pendingWinRef.current = 0;
          setPendingWin(0);
        }
        setHasClearedOnce(false);
      },
      [
        bettingOpen,
        committedActions.length,
        settlingActions.length,
        selectedChip,
        stagedTotal,
        user?.wallet,
        computer?.current_balance,
        isComputerSession
      ]
    );


  // Visual preview only for connected-number modes.
  // This changes table highlighting only; wheel/spin code is untouched.
  const previewConnectedNumbers = (number) => {
    const n = Number(number);

    if (!Number.isInteger(n) || n < 1 || n > 36) {
      return [n];
    }

    const streetStart =
      Math.floor((n - 1) / 3) * 3 + 1;

    if (precisionMode === "STREET") {
      return [
        streetStart,
        streetStart + 1,
        streetStart + 2
      ];
    }

    if (precisionMode === "SIX_LINE") {
      const firstStreet =
        streetStart >= 34
          ? 31
          : streetStart;

      return [
        firstStreet,
        firstStreet + 1,
        firstStreet + 2,
        firstStreet + 3,
        firstStreet + 4,
        firstStreet + 5
      ];
    }

    return [n];
  };

  const handleSplitLineClick = (e, num1, num2) => {
    e.stopPropagation();

    if (!bettingOpen) {
      toast.warning("Betting is closed.");
      return;
    }

    if (committedActions.length > 0) {
      toast.warning(
        "Bet already confirmed for this round. Please wait for the round result!"
      );
      return;
    }

    const sorted = [Number(num1), Number(num2)].sort((a, b) => a - b);

    if (!isValidPrecision("SPLIT", sorted)) {
      toast.error("Invalid SPLIT selection.");
      return;
    }

    addBetAction("SPLIT", sorted, `Split ${sorted.join("-")}`);
    setPrecisionSelection([]);
  };

  const handleSixLineClick = (e, num1) => {
    e.stopPropagation();

    if (!bettingOpen) {
      toast.warning("Betting is closed.");
      return;
    }

    if (committedActions.length > 0) {
      toast.warning(
        "Bet already confirmed for this round. Please wait for the round result!"
      );
      return;
    }

    const sorted = [num1, num1 + 1, num1 + 2, num1 + 3, num1 + 4, num1 + 5];

    if (!isValidPrecision("SIX_LINE", sorted)) {
      toast.error("Invalid SIX LINE selection.");
      return;
    }

    addBetAction("SIX_LINE", sorted, `Six Line ${num1}-${num1 + 5}`);
    setPrecisionSelection([]);
  };

  const handleStreetClick = (e, num1) => {
    e.stopPropagation();

    if (!bettingOpen) {
      toast.warning("Betting is closed.");
      return;
    }

    if (committedActions.length > 0) {
      toast.warning(
        "Bet already confirmed for this round. Please wait for the round result!"
      );
      return;
    }

    const sorted = [num1, num1 + 1, num1 + 2];

    if (!isValidPrecision("STREET", sorted)) {
      toast.error("Invalid STREET selection.");
      return;
    }

    addBetAction("STREET", sorted, `Street ${num1}-${num1 + 2}`);
    setPrecisionSelection([]);
  };

  const handleCornerClick = (e, num1, num2, num3, num4) => {
    e.stopPropagation();

    if (!bettingOpen) {
      toast.warning("Betting is closed.");
      return;
    }

    if (committedActions.length > 0) {
      toast.warning(
        "Bet already confirmed for this round. Please wait for the round result!"
      );
      return;
    }

    const sorted = [Number(num1), Number(num2), Number(num3), Number(num4)].sort((a, b) => a - b);

    if (!isValidPrecision("CORNER", sorted)) {
      toast.error("Invalid CORNER selection.");
      return;
    }

    addBetAction("CORNER", sorted, `Corner ${sorted.join("-")}`);
    setPrecisionSelection([]);
  };

  const handleFullScreen = () => {
    const docElm = document.documentElement;
    const isFullScreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;

    if (!isFullScreen) {
      try {
        if (docElm.requestFullscreen) {
          const promise = docElm.requestFullscreen();
          if (promise) {
            promise.catch((err) => {
              toast.error("Your browser blocked Fullscreen mode. Please allow it in site settings.");
              console.error("Fullscreen error:", err);
            });
          }
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen();
        } else if (docElm.webkitRequestFullscreen) {
          docElm.webkitRequestFullscreen();
        } else if (docElm.msRequestFullscreen) {
          docElm.msRequestFullscreen();
        } else {
          toast.warning("Fullscreen mode is not supported by your current browser (e.g., iOS Safari).");
        }
      } catch (err) {
        toast.error("An error occurred while entering fullscreen.");
        console.error(err);
      }
    } else {
      try {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  const handleNumberClick =
    (number) => {
      if (!bettingOpen) {
        toast.warning(
          "Betting is closed."
        );

        return;
      }

      if (committedActions.length > 0) {
        toast.warning(
          "Bet already confirmed for this round. Please wait for the round result!"
        );

        return;
      }

      if (
        precisionMode ===
        "SINGLE"
      ) {
        addBetAction(
          "SINGLE",
          number,
          `Number ${number}`
        );

        return;
      }

      if (precisionMode === "SPLIT") {
        if (precisionSelection.length === 1) {
          const first = precisionSelection[0];

          if (first === number) {
            setPrecisionSelection([]);
            return;
          }

          if (isValidPrecision("SPLIT", [first, number])) {
            const sorted = [first, number].sort((a, b) => a - b);
            addBetAction("SPLIT", sorted, `Split ${sorted.join("-")}`);
            setPrecisionSelection([]);
            return;
          } else {
            setPrecisionSelection([number]);
            return;
          }
        } else {
          setPrecisionSelection([number]);
          return;
        }
      }

      if (precisionMode === "STREET") {
        const streetNumbers = previewConnectedNumbers(number);
        if (isValidPrecision("STREET", streetNumbers)) {
          addBetAction(
            "STREET",
            streetNumbers,
            `Street ${streetNumbers[0]}-${streetNumbers[2]}`
          );
          setPrecisionSelection([]);
        }
        return;
      }

      if (precisionMode === "SIX_LINE") {
        const sixNumbers = previewConnectedNumbers(number);
        if (isValidPrecision("SIX_LINE", sixNumbers)) {
          addBetAction(
            "SIX_LINE",
            sixNumbers,
            `Six Line ${sixNumbers[0]}-${sixNumbers[5]}`
          );
          setPrecisionSelection([]);
        }
        return;
      }

      const required =
        PRECISION_MODES[
        precisionMode
        ];

      let updated =
        precisionSelection.includes(
          number
        )
          ? precisionSelection.filter(
            (item) =>
              item !== number
          )
          : [
            ...precisionSelection,
            number
          ];

      if (
        updated.length >
        required
      ) {
        updated = [number];
      }

      setPrecisionSelection(
        updated
      );

      if (
        updated.length ===
        required
      ) {
        if (
          !isValidPrecision(
            precisionMode,
            updated
          )
        ) {
          toast.error(
            `Invalid ${BET_TYPES[
              precisionMode
            ]?.name ||
            precisionMode
            } selection.`
          );

          setPrecisionSelection(
            []
          );

          return;
        }

        const sorted = [
          ...updated
        ].sort(
          (a, b) => a - b
        );

        addBetAction(
          precisionMode,
          sorted,
          `${BET_TYPES[
            precisionMode
          ]?.name ||
          precisionMode
          } ${sorted.join("-")}`
        );

        setPrecisionSelection(
          []
        );
      }
    };

  const addOutsideBet = (
    type,
    value,
    label
  ) => {
    addBetAction(
      type,
      value,
      label
    );
  };

  const handleUndo = () => {
    setBetActions(
      (previous) =>
        previous.slice(
          0,
          -1
        )
    );
  };

  const handleClear = () => {
    if (hasClearedOnce) return;
    setBetActions((prev) => (prev.length > 0 ? prev.slice(0, -1) : []));
    setHasClearedOnce(true);

    setPrecisionSelection(
      []
    );
  };

  const handleRepeat = () => {
    if (
      !bettingOpen ||
      isWheelSpinning ||
      committedActions.length > 0 ||
      lastSubmittedActions.length === 0
    ) {
      return;
    }
    if (settlingActions.length > 0) {
      setSettlingActions([]);
    }

    const repeatTotal =
      lastSubmittedActions.reduce(
        (sum, item) =>
          sum +
          Number(
            item.amount ||
            0
          ),
        0
      );

    const availableBal = isComputerSession
      ? Number(computer?.current_balance || 0)
      : Number(user?.wallet || 0);

    if (
      repeatTotal >
      availableBal
    ) {
      toast.error(
        "Balance is not enough to repeat the previous bet."
      );

      return;
    }

    if (displayedWin > 0) setDisplayedWin(0);
    if (uncreditedWinRef.current > 0 || pendingWinRef.current > 0) {
      creditWinToScore();
    }

    setBetActions(
      lastSubmittedActions.map(
        (item) => ({
          ...item
        })
      )
    );
  };

  const handleDouble = () => {
    if (!bettingOpen || isWheelSpinning || committedActions.length > 0) {
      return;
    }
    if (settlingActions.length > 0) {
      setSettlingActions([]);
    }

    if (displayedWin > 0) setDisplayedWin(0);
    if (uncreditedWinRef.current > 0 || pendingWinRef.current > 0) {
      creditWinToScore();
    }

    const source =
      betActions.length > 0
        ? betActions
        : committedActions;

    if (
      source.length === 0
    ) {
      return;
    }

    const additional =
      source.reduce(
        (sum, item) =>
          sum +
          Number(
            item.amount ||
            0
          ),
        0
      );

    const availableBal = isComputerSession
      ? Number(computer?.current_balance || 0)
      : Number(user?.wallet || 0);

    if (
      additional >
      availableBal
    ) {
      toast.error(
        "Balance is not enough to double the bet."
      );

      return;
    }

    if (
      betActions.length >
      0
    ) {
      setBetActions(
        (previous) =>
          previous.map(
            (item) => ({
              ...item,
              amount:
                Number(
                  item.amount ||
                  0
                ) * 2
            })
          )
      );
    } else {
      setBetActions(
        source.map(
          (item) => ({
            ...item
          })
        )
      );
    }
  };

  const handlePlaceBets =
    async () => {
      if (
        !currentRound ||
        !bettingOpen ||
        isWheelSpinning ||
        placingBets ||
        committedActions.length > 0
      ) {
        return;
      }
      if (settlingActions.length > 0) {
        setSettlingActions([]);
      }

      if (stagedGroups.length === 0) {
        toast.info("Please place chips on the table first!");
        return;
      }

      if (
        invalidMinGroups.length >
        0
      ) {
        toast.error(
          `Minimum bet per position is ${minBet}. Add more chips on highlighted positions.`
        );

        return;
      }

      if (
        invalidMaxGroups.length >
        0
      ) {
        toast.error(
          `Maximum bet per position is ${maxBet}.`
        );

        return;
      }

      if (uncreditedWinRef.current > 0 || pendingWinRef.current > 0) {
        creditWinToScore();
      }

      const availableBal = isComputerSession
        ? Number(computer?.current_balance || 0)
        : Number(user?.wallet || 0);

      if (
        stagedTotal >
        availableBal
      ) {
        toast.error(
          isComputerSession
            ? "Insufficient computer credits."
            : "Insufficient playable wallet balance."
        );

        return;
      }

      const payloadBets =
        stagedGroups.map(
          (bet) => ({
            bet_type:
              bet.type,

            bet_value:
              Array.isArray(
                bet.value
              )
                ? JSON.stringify(
                  bet.value
                )
                : String(
                  bet.value
                ),

            amount:
              Number(
                bet.amount
              )
          })
        );

      try {
        setPlacingBets(
          true
        );

        const response =
          await gameService.placeBets(
            {
              round_id:
                currentRound.id,

              bets:
                payloadBets
            }
          );

        if (
          !response?.success
        ) {
          throw new Error(
            response?.message ||
            "Unable to place bets."
          );
        }

        if (
          isComputerSession &&
          response?.current_balance !==
          undefined
        ) {
          setComputer(
            (prev) => ({
              ...prev,
              current_balance:
                response.current_balance
            })
          );
        }

        setCommittedActions(
          (previous) => {
            const next = [
              ...previous,
              ...stagedGroups
            ];
            committedActionsRef.current = next;
            return next;
          }
        );

        setLastSubmittedActions(
          betActions.map(
            (item) => ({
              ...item
            })
          )
        );

        setBetActions([]);

        setPrecisionSelection(
          []
        );

        await refreshProfile();

        await refreshHistory();

        toast.success(
          `Bets confirmed: ${Number(
            response.total_amount ||
            stagedTotal
          ).toLocaleString()} coins`
        );
      } catch (error) {
        toast.error(
          error.response?.data
            ?.message ||
          error.message ||
          "Unable to place bets."
        );

        await fetchCurrentRound();
      } finally {
        setPlacingBets(
          false
        );
      }
    };

  const handleThemeChange =
    (event) => {
      const nextTheme =
        event.target.value;

      if (
        phase ===
        "SPINNING"
      ) {
        setPendingTheme(
          nextTheme
        );

        toast.info(
          "Theme will change on the next round."
        );

        return;
      }

      setTheme(
        nextTheme
      );

      localStorage.setItem(
        "casinoPlayerTheme",
        nextTheme
      );
    };

  const handleWheelSettled =
    useCallback(
      () => {
        if (wheelSpinTimerRef.current) {
          clearTimeout(wheelSpinTimerRef.current);
          wheelSpinTimerRef.current = null;
        }
        setIsWheelSpinning(false);
        isWheelSpinningRef.current = false;
        setWheelSettled(true);
        setSettlingActions([]);
        sounds.stopWheelSpinAudio();
        sounds.playBallSettleSound();

        // Reveal the updated LAST 10 DATA now that wheel has stopped!
        if (pendingRecentResultsRef.current) {
          setRecentResults(pendingRecentResultsRef.current);
          pendingRecentResultsRef.current = null;
        } else {
          refreshRecentResults();
        }

        // When wheel stops: Reveal win amount in Win box, play victory sound, and show toast
        if (pendingOutcomeRef.current) {
          const outcome = pendingOutcomeRef.current;
          setRoundOutcome(outcome);
          showOutcomeToast(outcome);

          if (outcome.totalWin > 0) {
            // 1. Show win amount in Win box
            setDisplayedWin(outcome.totalWin);
            sounds.playWinSound();

            // 2. Keep win amount in "Win :" until timer reaches 45 seconds, then credit to Score!
            if (winCreditTimerRef.current) {
              clearTimeout(winCreditTimerRef.current);
            }
            const currentSec = Math.round(Number(timerValue));
            if (currentSec <= 45) {
              creditWinToScore(outcome.totalWin);
            } else {
              const msTo45 = Math.max(500, (currentSec - 45) * 1000);
              winCreditTimerRef.current = setTimeout(() => {
                creditWinToScore(outcome.totalWin);
              }, msTo45);
            }
          } else {
            setDisplayedWin(0);
          }

          if (autoCloseOutcomeTimerRef.current) {
            clearTimeout(autoCloseOutcomeTimerRef.current);
          }
          autoCloseOutcomeTimerRef.current = setTimeout(() => {
            setRoundOutcome(null);
            outcomeRef.current = null;
            pendingOutcomeRef.current = null;
          }, 4500);
        }
      },
      [creditWinToScore, showOutcomeToast, timerValue]
    );

  handleWheelSettledRef.current = handleWheelSettled;

  const handleTakeCoins = async () => {
    // 1. If there is a win pending in "Win :", merge it immediately into Score
    if (uncreditedWinRef.current > 0 || pendingWinRef.current > 0 || pendingWin > 0) {
      creditWinToScore();
      if (autoCloseOutcomeTimerRef.current) {
        clearTimeout(autoCloseOutcomeTimerRef.current);
        autoCloseOutcomeTimerRef.current = null;
      }
      if (pendingWinTimerRef.current) {
        clearTimeout(pendingWinTimerRef.current);
        pendingWinTimerRef.current = null;
      }
      pendingWinRef.current = 0;
      setPendingWin(0);
    }

    if (roundOutcome) {
      setRoundOutcome(null);
    }

    // 2. Fetch latest balance / score
    let scoreVal = isComputerSession
      ? Number(computer?.current_balance || 0)
      : Number(user?.wallet_balance ?? user?.wallet ?? 0);

    if (isComputerSession) {
      try {
        const res = await computerAuthService.getProfile();
        if (res?.computer) {
          setComputer(res.computer);
          sessionStorage.setItem("computer", JSON.stringify(res.computer));
          scoreVal = Number(res.computer.current_balance || 0);
        }
      } catch (err) { }
    } else {
      try {
        const res = await authService.getProfile();
        if (res?.user) {
          setUser(res.user);
          localStorage.setItem("user", JSON.stringify(res.user));
          scoreVal = Number(res.user.wallet_balance ?? res.user.wallet ?? 0);
        }
      } catch (err) { }
    }

    if (scoreVal <= 0) {
      toast.error(`Score is ${scoreVal.toFixed(2)}. No coins available to return to shop.`);
      return;
    }

    const initialTake = (lastTakeAmount && Number(lastTakeAmount) > 0)
      ? String(Math.min(Number(lastTakeAmount), scoreVal))
      : String(Math.min(1, scoreVal));

    setTakeModalAmount(initialTake);
    setTakeModalOpen(true);
  };

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.error("Error attempting to enable fullscreen:", err);
      });
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  const handleLogout = () => {
    if (isComputerSession) {
      sessionStorage.removeItem("computer_token");
      sessionStorage.removeItem("computer");
      navigate("/login", { replace: true });
      return;
    }

    authService.logout();
    navigate("/login", { replace: true });
  };

  const renderPlacedChip = (amount) => {
    let chipClass = "chip-1";
    if (amount >= 1000) chipClass = "chip-1000";
    else if (amount >= 500) chipClass = "chip-500";
    else if (amount >= 100) chipClass = "chip-100";
    else if (amount >= 50) chipClass = "chip-50";
    else if (amount >= 25) chipClass = "chip-25";
    else if (amount >= 10) chipClass = "chip-10";
    else if (amount >= 5) chipClass = "chip-5";

    return (
      <b className={`casino-chip ${chipClass} placed-chip`}>
        {amount >= 1000 ? `${amount / 1000}K` : amount}
      </b>
    );
  };

  if (loading) {
    return (
      <div className="roulette-loading-screen">
        <div className="roulette-loading-wheel">
          ♛
        </div>

        <div>
          Preparing Roulette
          Table...
        </div>
      </div>
    );
  }

  const renderTakeModal = () => (
    <div className="take-modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.85)', zIndex: 10000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div className="take-modal-card" style={{ background: '#1c1c1c', border: '2px solid #d48530', borderRadius: '15px', padding: '24px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: '320px', maxWidth: '420px', width: '92%', boxShadow: '0 10px 40px rgba(0,0,0,0.9)' }}>
        <h2 style={{ color: '#d48530', margin: '0 0 16px 0', fontFamily: '"Roboto"', fontSize: '22px', fontWeight: 'bold' }}>Take Coins to Shop</h2>

        {/* Prominent Score & Last Take Value Displays */}
        <div style={{ display: 'flex', gap: '10px', width: '100%', marginBottom: '16px' }}>
          <div style={{
            flex: 1,
            background: 'linear-gradient(180deg, #2b180d 0%, #150a04 100%)',
            border: '1.5px solid #d48530',
            borderRadius: '10px',
            padding: '10px',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            boxShadow: 'inset 0 1px 3px rgba(255,255,255,0.1), 0 4px 10px rgba(0,0,0,0.5)'
          }}>
            <span style={{ color: '#edc47b', fontSize: '13px', fontWeight: 'bold', textShadow: '1px 1px 2px rgba(0,0,0,0.8)' }}>Score</span>
            <strong style={{ color: '#ffffff', fontSize: '18px', fontWeight: '900', letterSpacing: '0.5px', marginTop: '2px' }}>
              {getAvailableTakeCoins().toFixed(2)}
            </strong>
          </div>

          <div style={{
            flex: 1,
            background: 'linear-gradient(180deg, #2b180d 0%, #150a04 100%)',
            border: '1.5px solid #d48530',
            borderRadius: '10px',
            padding: '10px',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            boxShadow: 'inset 0 1px 3px rgba(255,255,255,0.1), 0 4px 10px rgba(0,0,0,0.5)'
          }}>
            <span style={{ color: '#edc47b', fontSize: '13px', fontWeight: 'bold', textShadow: '1px 1px 2px rgba(0,0,0,0.8)' }}>Last Take</span>
            <strong style={{ color: '#ffd88a', fontSize: '18px', fontWeight: '900', letterSpacing: '0.5px', marginTop: '2px' }}>
              {lastTakeAmount ? Number(lastTakeAmount).toFixed(2) : '-'}
            </strong>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginBottom: '8px' }}>
          <span style={{ color: '#bbb', fontSize: '13px' }}>Amount to Take:</span>
          <div style={{ display: 'flex', gap: '8px' }}>
            {lastTakeAmount && Number(lastTakeAmount) > 0 && (
              <button
                type="button"
                onClick={() => setTakeModalAmount(String(Math.min(Number(lastTakeAmount), getAvailableTakeCoins())))}
                style={{
                  background: 'transparent',
                  border: '1px solid #d48530',
                  borderRadius: '4px',
                  color: '#ffd88a',
                  fontSize: '11px',
                  fontWeight: 'bold',
                  padding: '2px 8px',
                  cursor: 'pointer'
                }}
              >
                Last ({Number(lastTakeAmount).toFixed(0)})
              </button>
            )}
            <button
              type="button"
              onClick={() => setTakeModalAmount(String(getAvailableTakeCoins()))}
              style={{
                background: 'transparent',
                border: '1px solid #d48530',
                borderRadius: '4px',
                color: '#ffd88a',
                fontSize: '11px',
                fontWeight: 'bold',
                padding: '2px 8px',
                cursor: 'pointer'
              }}
            >
              Max / All
            </button>
          </div>
        </div>

        <input
          type="number"
          value={takeModalAmount}
          onChange={(e) => setTakeModalAmount(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && Number(takeModalAmount) > 0 && Number(takeModalAmount) <= getAvailableTakeCoins()) {
              confirmTakeCoins();
            }
          }}
          placeholder="Enter coin amount"
          style={{
            width: '100%',
            boxSizing: 'border-box',
            padding: '10px',
            fontSize: '20px',
            fontWeight: 'bold',
            borderRadius: '8px',
            border: Number(takeModalAmount) > getAvailableTakeCoins() ? '2px solid #ff4d4f' : '1.5px solid #d48530',
            background: '#111',
            color: Number(takeModalAmount) > getAvailableTakeCoins() ? '#ff7875' : '#ffd88a',
            marginBottom: Number(takeModalAmount) > getAvailableTakeCoins() ? '8px' : '18px',
            textAlign: 'center',
            outline: 'none',
            boxShadow: 'inset 0 2px 6px rgba(0,0,0,0.8)'
          }}
          autoFocus
        />

        {Number(takeModalAmount) > getAvailableTakeCoins() && (
          <div style={{ color: '#ff4d4f', fontSize: '12px', marginBottom: '14px', fontWeight: 'bold', textAlign: 'center' }}>
            Cannot take more than available Score ({getAvailableTakeCoins().toFixed(2)})
          </div>
        )}

        <div style={{ display: 'flex', gap: '12px', width: '100%' }}>
          <button
            type="button"
            onClick={() => setTakeModalOpen(false)}
            disabled={takingCoins}
            style={{
              flex: 1,
              padding: '10px',
              background: '#333',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '15px',
              fontWeight: 'bold'
            }}
          >
            Cancel
          </button>
          {Number(takeModalAmount) > 0 && Number(takeModalAmount) <= getAvailableTakeCoins() && (
            <button
              type="button"
              onClick={confirmTakeCoins}
              disabled={takingCoins}
              style={{
                flex: 1,
                padding: '10px',
                background: takingCoins
                  ? '#555'
                  : 'linear-gradient(180deg, #d48530 0%, #aa5f17 45%, #6f3404 100%)',
                border: '1.5px solid #ffd88a',
                color: '#fff',
                borderRadius: '8px',
                cursor: takingCoins ? 'not-allowed' : 'pointer',
                fontSize: '15px',
                fontWeight: 'bold',
                boxShadow: '0 4px 10px rgba(0,0,0,0.5)',
                transition: 'all 0.15s ease'
              }}
            >
              {takingCoins ? 'Sending...' : 'Confirm'}
            </button>
          )}
        </div>
      </div>
    </div>
  );



  const isMobilePortrait = Boolean(dimensions.isMobile && !dimensions.isLandscape);
  const isMobileLandscape = Boolean(dimensions.isMobile && dimensions.isLandscape);

  return (
    <div
      className="casino-game-root"
      style={{
        width: '100vw',
        height: '100vh',
        background: '#1a110a',
        position: 'relative',
        overflow: 'hidden',
        fontFamily: '"Roboto"'
      }}
    >
      <div
        className={`casino-game-scalable-stage ${isMobilePortrait ? "is-mobile-portrait" : ""} ${isMobileLandscape ? "is-mobile-landscape" : ""}`}
        style={{
          width: `${dimensions.stageWidth}px`,
          height: `${dimensions.stageHeight}px`,
          position: 'absolute',
          top: 0,
          left: 0,
          transform: `scale(${dimensions.scale})`,
          transformOrigin: 'top left',
          overflow: 'hidden'
        }}
      >

      {/* FULL-WIDTH DARK UPPER FILL - behind wheel area */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: isMobilePortrait ? undefined : 'calc(52% + 35px)', height: isMobilePortrait ? '490px' : undefined, background: 'linear-gradient(180deg, #0d0800 0%, #1a110a 60%, #221408 100%)', zIndex: 0 }}></div>

      {/* 3D WHEEL BACKGROUND */}
      <div style={{ position: 'absolute', top: isMobilePortrait ? '10px' : '-4%', left: '0', right: '0', height: isMobilePortrait ? '380px' : '60%', display: 'flex', justifyContent: 'center', zIndex: 3, transform: 'scale(0.8)' }}>
        <RouletteWheel3D
          winningNumber={wheelResult}
          isSpinning={isWheelSpinning}
          spinDuration={6.0}
          onSettled={handleWheelSettled}
        />
      </div>

      {/* TOP LEFT PANEL - Logo + Score panel */}
      <div style={{ position: 'absolute', top: '5px', left: '10px', zIndex: 10, display: 'flex', flexDirection: 'column', gap: '2px' }}>
        <h1 className="casino-title">Fun Roulette</h1>

        {/* SCORE PANEL */}
        <div style={{ position: 'relative', width: '320px', height: '155px', marginLeft: '0px' }}>
          <svg width="320" height="155" viewBox="0 0 320 155" style={{ position: 'absolute', top: 0, left: 0, filter: 'drop-shadow(3px 4px 6px rgba(0,0,0,0.85))' }}>
            <defs>
              {/* Wood grain gradient for border */}
              <linearGradient id="woodBorder" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#c8853a" />
                <stop offset="20%" stopColor="#7a3e10" />
                <stop offset="45%" stopColor="#4a1f08" />
                <stop offset="70%" stopColor="#6b3510" />
                <stop offset="85%" stopColor="#c07830" />
                <stop offset="100%" stopColor="#3a1a06" />
              </linearGradient>
              {/* Inner panel fill */}
              <linearGradient id="panelFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#0f0f0f" />
                <stop offset="100%" stopColor="#050505" />
              </linearGradient>
            </defs>

            {/* Outermost dark shadow edge */}
            <polygon points="0,0 265,0 320,155 0,155" fill="none" stroke="#1a0a02" strokeWidth="14" />
            {/* Wood colour layer */}
            <polygon points="0,0 265,0 320,155 0,155" fill="none" stroke="url(#woodBorder)" strokeWidth="10" />
            {/* Bright inner highlight */}
            <polygon points="0,0 265,0 320,155 0,155" fill="none" stroke="#d4913e" strokeWidth="3" strokeLinejoin="miter" />
            {/* Innermost dark inset */}
            <polygon points="7,7 261,7 313,148 7,148" fill="none" stroke="#2a1205" strokeWidth="2" />

            {/* Panel background */}
            <polygon points="9,9 259,9 311,146 9,146" fill="url(#panelFill)" />

            {/* Divider lines */}
            <line x1="9" y1="57" x2="277" y2="57" stroke="#3a1f0a" strokeWidth="2" />
            <line x1="9" y1="105" x2="295" y2="105" stroke="#3a1f0a" strokeWidth="2" />
          </svg>
          <div style={{ position: 'relative', zIndex: 1, padding: '8px 16px', display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-around' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ width: '80px', color: '#bbb', fontSize: '20px', fontWeight: 'bold' }}>Score :</span>
              <strong style={{
                color: scoreGlow ? '#52c41a' : '#fff',
                fontSize: '20px',
                fontWeight: 'bold',
                textShadow: scoreGlow ? '0 0 14px rgba(82, 196, 26, 0.95), 0 0 24px rgba(82, 196, 26, 0.6)' : 'none',
                transform: scoreGlow ? 'scale(1.15)' : 'scale(1)',
                transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
                display: 'inline-block'
              }}>
                {(isComputerSession ? Number(computer?.current_balance || 0) : Number(user?.wallet_balance ?? user?.wallet ?? 0)).toFixed(2)}
              </strong>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ width: '80px', color: '#bbb', fontSize: '20px', fontWeight: 'bold' }}>Win :</span>
              <strong style={{
                color: displayedWin > 0 ? '#50ff50' : '#fff',
                fontSize: '20px',
                fontWeight: 'bold',
                textShadow: displayedWin > 0 ? '0 0 12px rgba(80,255,80,0.85)' : 'none',
                transform: displayedWin > 0 ? 'scale(1.08)' : 'scale(1)',
                transition: 'all 0.3s ease',
                display: 'inline-block'
              }}>
                {displayedWin.toFixed(2)}
              </strong>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ width: '80px', color: '#bbb', fontSize: '20px', fontWeight: 'bold' }}>Bet :</span>
              <strong style={{ color: '#fff', fontSize: '20px', fontWeight: 'bold' }}>{stagedTotal + confirmedTotal}</strong>
            </div>
          </div>
        </div>
      </div>

      {/* BOTTOM LEFT BUTTONS - Double/Rebet/Bet - resting on a wood plank with concave inside curve */}
      <div style={{ position: 'absolute', bottom: isMobilePortrait ? undefined : 'calc(51% + 46px)', top: isMobilePortrait ? '418px' : undefined, left: '0px', zIndex: 120, display: 'flex', gap: '10px', background: 'linear-gradient(180deg, #5c3516 0%, #3a1e09 100%)', padding: '6px 75px 6px 15px', borderTop: '2px solid #85532b', borderBottom: '3px solid #1a0c02', filter: 'drop-shadow(5px 8px 6px rgba(0,0,0,0.8))', WebkitMaskImage: 'radial-gradient(circle at 100% -20px, transparent 75px, black 76px)', maskImage: 'radial-gradient(circle at 100% -20px, transparent 75px, black 76px)' }}>
        <button type="button" onClick={handleDouble} disabled={!bettingOpen || isWheelSpinning} style={{ background: 'linear-gradient(180deg, #b86923 0%, #85400d 45%, #592400 100%)', border: '2px solid #ffd88a', borderRadius: '6px', padding: '8px 22px', color: '#ffffff', textShadow: '1px 1px 2px rgba(0,0,0,0.9)', fontWeight: 'bold', fontSize: '17px', cursor: (!bettingOpen || isWheelSpinning) ? 'not-allowed' : 'pointer', boxShadow: 'inset 0px 10px 12px -8px rgba(255,255,255,0.9), inset 0px -2px 4px rgba(0,0,0,0.5), 0px 4px 6px rgba(0,0,0,0.8)', minWidth: '85px', filter: (!bettingOpen || isWheelSpinning) ? 'brightness(0.6)' : 'none' }}>
          Double
        </button>
        <button
          type="button"
          onClick={handleRepeat}
          disabled={!bettingOpen || isWheelSpinning || lastSubmittedActions.length === 0 || committedActions.length > 0}
          className={isRebetGlowing ? "golden-glow-btn" : ""}
          style={{
            background: 'linear-gradient(180deg, #b86923 0%, #85400d 45%, #592400 100%)',
            border: '2px solid #ffd88a',
            borderRadius: '6px',
            padding: '8px 22px',
            color: '#ffffff',
            textShadow: '1px 1px 2px rgba(0,0,0,0.9)',
            fontWeight: 'bold',
            fontSize: '17px',
            cursor: (!bettingOpen || isWheelSpinning || lastSubmittedActions.length === 0 || committedActions.length > 0) ? 'not-allowed' : 'pointer',
            boxShadow: 'inset 0px 10px 12px -8px rgba(255,255,255,0.9), inset 0px -2px 4px rgba(0,0,0,0.5), 0px 4px 6px rgba(0,0,0,0.8)',
            minWidth: '85px',
            filter: (!bettingOpen || isWheelSpinning || lastSubmittedActions.length === 0 || committedActions.length > 0) ? 'brightness(0.6)' : 'none'
          }}
        >
          Rebet
        </button>
        <button
          type="button"
          onClick={handlePlaceBets}
          disabled={!bettingOpen || isWheelSpinning || placingBets || committedActions.length > 0}
          className={isBetGlowing ? "golden-glow-btn" : ""}
          style={{
            background: 'linear-gradient(180deg, #b86923 0%, #85400d 45%, #592400 100%)',
            border: '2px solid #ffd88a',
            borderRadius: '6px',
            padding: '8px 22px',
            color: '#ffffff',
            textShadow: '1px 1px 2px rgba(0,0,0,0.9)',
            fontWeight: 'bold',
            fontSize: '17px',
            cursor: (!bettingOpen || isWheelSpinning || placingBets || committedActions.length > 0) ? 'not-allowed' : 'pointer',
            boxShadow: 'inset 0px 10px 12px -8px rgba(255,255,255,0.9), inset 0px -2px 4px rgba(0,0,0,0.5), 0px 4px 6px rgba(0,0,0,0.8)',
            minWidth: '85px',
            filter: (!bettingOpen || isWheelSpinning || placingBets || committedActions.length > 0) ? 'brightness(0.6)' : 'none'
          }}
        >
          Bet
        </button>
      </div>

      {/* DRAW TIME & TIMER CIRCLE - Centered above right action buttons */}
      <div style={{ position: 'absolute', top: isMobilePortrait ? '15px' : '70px', right: isMobilePortrait ? '110px' : '100px', width: '271px', zIndex: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', pointerEvents: 'none' }}>
        {/* DRAW TIME label */}
        <div style={{ color: '#fcee9d', fontSize: '15px', fontWeight: 'bold', letterSpacing: '1px', textShadow: '1px 1px 2px #000, 0 0 6px rgba(196,139,38,0.5)', textAlign: 'center', marginBottom: '6px' }}>
          DRAW TIME
        </div>

        {/* TIMER CIRCLE */}
        <div style={{ width: '130px', height: '130px', position: 'relative' }}>
          <svg viewBox="0 0 140 140" width="130" height="130" style={{ position: 'absolute', top: 0, left: 0, transform: 'rotate(-90deg)' }}>
            <defs>
              <radialGradient id="timerBg" cx="40%" cy="35%">
                <stop offset="0%" stopColor="#222b35" />
                <stop offset="100%" stopColor="#0b0f14" />
              </radialGradient>
            </defs>

            {/* Inner background disc */}
            <circle cx="70" cy="70" r="65" fill="url(#timerBg)" stroke="#4a5568" strokeWidth="4" />

            {/* Base track: Crisp clean light/white track as seen in user reference */}
            <circle cx="70" cy="70" r="52" fill="none" stroke="#e2e8f0" strokeWidth="14" />

            {/* 1. Sky Blue Arc (covers 0s to 50s elapsed) */}
            <circle
              cx="70" cy="70" r="52"
              fill="none"
              stroke="#00d2ff"
              strokeWidth="14"
              strokeLinecap="butt"
              strokeDasharray={`${timerCircumference}`}
              strokeDashoffset={`${blueOffset}`}
              style={{
                transition: 'stroke-dashoffset 1s linear',
                filter: 'drop-shadow(0 0 6px rgba(0, 210, 255, 0.7))'
              }}
            />

            {/* 2. Red Arc (covers last 10s warning phase, starts at 10 o'clock = 300 deg) */}
            <circle
              cx="70" cy="70" r="52"
              fill="none"
              stroke="#ff3b30"
              strokeWidth="14"
              strokeLinecap="butt"
              strokeDasharray={`${timerCircumference}`}
              strokeDashoffset={`${redOffset}`}
              transform={`rotate(${redStartAngle} 70 70)`}
              style={{
                transition: 'stroke-dashoffset 1s linear',
                filter: 'drop-shadow(0 0 8px rgba(255, 59, 48, 0.8))'
              }}
            />
          </svg>
          <div style={{ position: 'absolute', top: '7px', left: '7px', right: '7px', bottom: '7px', borderRadius: '50%', border: '1px solid rgba(255,255,255,0.15)', pointerEvents: 'none' }}></div>
          <div style={{
            position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#ffffff',
            fontSize: '52px', fontFamily: "'Oswald', sans-serif",
            fontWeight: '700', letterSpacing: '0px',
            textShadow: '0 2px 4px rgba(0,0,0,0.9), 0 0 8px rgba(255,255,255,0.2)',
          }}>
            {timerValue}
          </div>
        </div>
      </div>

      {/* BOTTOM RIGHT BUTTONS - Take/Clear/Quit - resting on a wood plank with concave inside curve */}
      <div style={{ position: 'absolute', bottom: isMobilePortrait ? undefined : 'calc(51% + 46px)', top: isMobilePortrait ? '418px' : undefined, right: '0px', zIndex: 120, display: 'flex', gap: '10px', background: 'linear-gradient(180deg, #5c3516 0%, #3a1e09 100%)', padding: '6px 15px 6px 75px', borderTop: '2px solid #85532b', borderBottom: '3px solid #1a0c02', filter: 'drop-shadow(-5px 8px 6px rgba(0,0,0,0.8))', WebkitMaskImage: 'radial-gradient(circle at 0% -20px, transparent 75px, black 76px)', maskImage: 'radial-gradient(circle at 0% -20px, transparent 75px, black 76px)' }}>
        <button
          type="button"
          onClick={handleTakeCoins}
          style={{
            background: 'linear-gradient(180deg, #b86923 0%, #85400d 45%, #592400 100%)',
            border: '2px solid #ffd88a',
            borderRadius: '6px',
            padding: '8px 22px',
            color: '#ffffff',
            textShadow: '1px 1px 2px rgba(0,0,0,0.9)',
            fontWeight: 'bold',
            fontSize: '17px',
            cursor: 'pointer',
            boxShadow: 'inset 0px 10px 12px -8px rgba(255,255,255,0.9), inset 0px -2px 4px rgba(0,0,0,0.5), 0px 4px 6px rgba(0,0,0,0.8)',
            minWidth: '85px'
          }}
        >
          Take
        </button>
        <button
          type="button"
          onClick={handleClear}
          disabled={!bettingOpen || timerValue <= 15}
          style={{
            background: 'linear-gradient(180deg, #b86923 0%, #85400d 45%, #592400 100%)',
            border: '2px solid #ffd88a',
            borderRadius: '6px',
            padding: '8px 22px',
            color: '#ffffff',
            textShadow: '1px 1px 2px rgba(0,0,0,0.9)',
            fontWeight: 'bold',
            fontSize: '17px',
            cursor: 'pointer',
            boxShadow: 'inset 0px 10px 12px -8px rgba(255,255,255,0.9), inset 0px -2px 4px rgba(0,0,0,0.5), 0px 4px 6px rgba(0,0,0,0.8)',
            minWidth: '85px',
            filter: (!bettingOpen || timerValue <= 15) ? 'brightness(0.6)' : 'none'
          }}
        >
          Clear
        </button>
        <button
          type="button"
          onClick={() => navigate(isComputerSession ? "/computer-dashboard" : "/dashboard")}
          style={{
            background: 'linear-gradient(180deg, #b86923 0%, #85400d 45%, #592400 100%)',
            border: '2px solid #ffd88a',
            borderRadius: '6px',
            padding: '8px 22px',
            color: '#ffffff',
            textShadow: '1px 1px 2px rgba(0,0,0,0.9)',
            fontWeight: 'bold',
            fontSize: '17px',
            cursor: 'pointer',
            boxShadow: 'inset 0px 10px 12px -8px rgba(255,255,255,0.9), inset 0px -2px 4px rgba(0,0,0,0.5), 0px 4px 6px rgba(0,0,0,0.8)',
            minWidth: '85px'
          }}
        >
          Quit
        </button>
      </div>

      {/* LAST 10 DATA - pinned cleanly to the far right edge */}
      <div style={{ position: 'absolute', top: isMobilePortrait ? '15px' : '54px', right: isMobilePortrait ? '15px' : '50px', zIndex: 120, display: 'flex', flexDirection: 'row', alignItems: 'flex-start', background: 'rgba(0,0,0,0.6)', borderBottomLeftRadius: '6px', borderLeft: '1px solid rgb(68, 68, 68)', borderBottom: '1px solid rgb(68, 68, 68)', overflow: 'hidden' }}>
        <div style={{ display: 'flex', flexDirection: 'column', color: 'rgb(211, 170, 84)', fontSize: '13px', fontWeight: 'bold', lineHeight: '1.55', alignItems: 'center', textShadow: '1px 1px 1px rgb(0, 0, 0)', padding: '6px 3px 6px 4px', letterSpacing: '0.5px' }}>
          <span>L</span><span>A</span><span>S</span><span>T</span>
          <div style={{ height: '4px' }}></div>
          <span>1</span><span>0</span>
          <div style={{ height: '4px' }}></div>
          <span>D</span><span>A</span><span>T</span><span>A</span>
        </div>
        <div style={{ background: '#000', display: 'flex', flexDirection: 'column', borderLeft: '1.5px solid #555' }}>
          {displayedRecentResults.length === 0 ? (
            <span style={{ fontSize: '13px', padding: '10px 4px', writingMode: 'vertical-rl', color: '#888' }}>-</span>
          ) : (
            displayedRecentResults.map((item) => (
              <div key={item.id} style={{
                width: '38px',
                height: '22px',
                background: getNumberColor(Number(item.winning_number)) === 'red' ? '#c81010' : (getNumberColor(Number(item.winning_number)) === 'black' ? '#1c1c1c' : '#0a883a'),
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#fff',
                fontSize: '13px',
                fontWeight: 'bold',
                borderBottom: '1px solid #333'
              }}>
                {item.winning_number}
              </div>
            ))
          )}
        </div>
      </div>

      {/* BOTTOM BOARD */}
      <div style={{ position: 'absolute', bottom: '35px', left: '0px', right: '0px', top: isMobilePortrait ? '488px' : undefined, height: isMobilePortrait ? undefined : '52%', background: '#1bc13e', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

        {/* THICK WOOD RAIL - replaces thin borderTop */}
        <div style={{ width: '100%', flexShrink: 0, position: 'relative', height: '22px', overflow: 'hidden' }}>
          {/* Bottom shadow */}
          <div style={{ position: 'absolute', inset: 0, background: '#150900' }}></div>
          {/* Wood grain body */}
          <div style={{ position: 'absolute', inset: '2px 0 2px 0', background: 'linear-gradient(180deg, #c07828 0%, #7a3e10 20%, #4a1f08 45%, #6b3510 70%, #c07830 85%, #3a1a06 100%)' }}></div>
          {/* Bright top highlight line */}
          <div style={{ position: 'absolute', top: '2px', left: 0, right: 0, height: '3px', background: 'linear-gradient(90deg, #e8a84a, #f0c060, #e8a84a, #c07830, #e8a84a)' }}></div>
          {/* Bottom dark edge */}
          <div style={{ position: 'absolute', bottom: '2px', left: 0, right: 0, height: '2px', background: '#2a1205' }}></div>
        </div>

        {/* CHIPS - LEFT GROUP */}
        <div style={{ position: 'absolute', top: isMobilePortrait ? '25px' : (isMobileLandscape ? '16px' : '44px'), left: isMobilePortrait ? '40px' : 'calc(50% - 470px)', display: 'flex', gap: '18px', zIndex: 100 }}>
          {[1, 5, 10, 25].map((chip) => (
            <div key={chip} style={{ border: selectedChip === chip ? '3px solid rgb(0, 255, 0)' : '3px solid transparent', borderRadius: '2px', padding: '4px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <button
                onClick={() => setSelectedChip(chip)}
                className={`casino-chip chip-${chip}`}
                style={{ margin: 0, transform: isMobilePortrait ? 'scale(1.4)' : 'scale(1.25)' }}
                disabled={!bettingOpen}
              >
                {chip}
              </button>
            </div>
          ))}
        </div>

        {/* CHIPS - RIGHT GROUP + INFO ICON */}
        <div style={{ position: 'absolute', top: isMobilePortrait ? '25px' : (isMobileLandscape ? '16px' : '44px'), right: isMobilePortrait ? '40px' : 'calc(50% - 470px)', display: 'flex', gap: '18px', alignItems: 'center', zIndex: 100 }}>
          <div style={{ display: 'flex', gap: '18px' }}>
            {[50, 100, 500, 1000].map((chip) => (
              <div key={chip} style={{ border: selectedChip === chip ? '3px solid rgb(0, 255, 0)' : '3px solid transparent', borderRadius: '2px', padding: '4px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <button
                  onClick={() => setSelectedChip(chip)}
                  className={`casino-chip chip-${chip}`}
                  style={{ margin: 0, transform: isMobilePortrait ? 'scale(1.4)' : 'scale(1.25)' }}
                  disabled={!bettingOpen}
                >
                  {chip >= 1000 ? '1K' : chip}
                </button>
              </div>
            ))}
          </div>
          {/* INFO ICON REMOVED */}
        </div>

        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Lobster&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
          .arcade-roulette-table-wrapper {
             width: 100%;
             max-width: 1400px;
             margin: 0 auto;
             background: #1bc13e !important;
          }

          .roulette-table {
             background: #1bc13e !important;
          }

          @keyframes golden-button-pulse {
            0% {
              box-shadow: 
                inset 0px 10px 14px -6px rgba(255, 255, 255, 0.95),
                inset 0px -2px 6px rgba(0, 0, 0, 0.6),
                0 0 8px 2px rgba(255, 215, 0, 0.6),
                0 4px 8px rgba(0, 0, 0, 0.8);
              border-color: #ffd88a;
              transform: scale(1);
              filter: brightness(1);
            }
            50% {
              box-shadow: 
                inset 0px 12px 16px -6px rgba(255, 255, 255, 1),
                inset 0px -2px 6px rgba(0, 0, 0, 0.4),
                0 0 22px 6px rgba(255, 215, 0, 0.95),
                0 0 38px 14px rgba(255, 160, 0, 0.5),
                0 6px 14px rgba(0, 0, 0, 0.9);
              border-color: #ffffff;
              transform: scale(1.06);
              filter: brightness(1.28);
              text-shadow: 0 0 10px #ffe680, 0 0 18px #ffb700, 1px 1px 2px #000;
            }
            100% {
              box-shadow: 
                inset 0px 10px 14px -6px rgba(255, 255, 255, 0.95),
                inset 0px -2px 6px rgba(0, 0, 0, 0.6),
                0 0 8px 2px rgba(255, 215, 0, 0.6),
                0 4px 8px rgba(0, 0, 0, 0.8);
              border-color: #ffd88a;
              transform: scale(1);
              filter: brightness(1);
            }
          }

          .golden-glow-btn {
            animation: golden-button-pulse 1.1s infinite ease-in-out !important;
            z-index: 20 !important;
            position: relative !important;
          }

          .arcade-roulette-table-wrapper .number-cell:not(.zero-cell) > span:first-child {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: 90% !important;
            height: 85% !important;
            border-radius: 50% !important;
            margin: auto !important;
            font-size: 21px !important;
            font-family: 'Roboto', sans-serif !important;
            font-weight: bold !important;
            border: 1.5px solid #ffffff !important;
            text-shadow: none !important;
            box-shadow: none !important;
            filter: none !important;
            transition: all 0.15s ease !important;
          }

          .arcade-roulette-table-wrapper .number-cell.zero-cell > span:first-child,
          .arcade-roulette-table-wrapper .zero-cell > span:first-child {
            border: none !important;
            border-radius: 0 !important;
            width: auto !important;
            height: auto !important;
            box-shadow: none !important;
            filter: none !important;
          }

          .arcade-roulette-table-wrapper .number-cell.zero-cell { overflow: visible !important; 
            background: transparent !important;
            border: 0 !important;
            border-right: 1px solid #fff !important;
          }
          .arcade-roulette-table-wrapper .number-cell.zero-cell::before {
            content: '';
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            background: #fff;
            clip-path: polygon(25% 0, 100% 0, 100% 100%, 25% 100%, 0 50%);
            z-index: 0;
          }
          .arcade-roulette-table-wrapper .number-cell.zero-cell::after { transition: all 0.2s;

            content: '';
            position: absolute;
            top: 1px; left: 1px; right: 0; bottom: 1px;
            background: #1bc13e;
            clip-path: polygon(25% 0, 100% 0, 100% 100%, 25% 100%, 0 50%);
            z-index: 0;
            transition: background 0.15s ease;
          }
          .arcade-roulette-table-wrapper .number-cell.zero-cell:hover::before,
          .arcade-roulette-table-wrapper .number-cell.zero-cell.hotspot-highlighted::before,
          .arcade-roulette-table-wrapper .number-cell.zero-cell.has-bet::before,
          .arcade-roulette-table-wrapper .number-cell.zero-cell.precision-selected::before {
            background: #ffffff !important;
            filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.9)) !important;
          }
          .arcade-roulette-table-wrapper .number-cell.zero-cell:hover::after,
          .arcade-roulette-table-wrapper .number-cell.zero-cell.hotspot-highlighted::after,
          .arcade-roulette-table-wrapper .number-cell.zero-cell.has-bet::after,
          .arcade-roulette-table-wrapper .number-cell.zero-cell.precision-selected::after {
            background: #5aef7a !important;
          }
          .arcade-roulette-table-wrapper .number-cell.zero-cell:hover > span,
          .arcade-roulette-table-wrapper .number-cell.zero-cell.hotspot-highlighted > span,
          .arcade-roulette-table-wrapper .number-cell.zero-cell.has-bet > span,
          .arcade-roulette-table-wrapper .number-cell.zero-cell.precision-selected > span {
            color: #ffffff !important;
            text-shadow: 0 0 8px rgba(255, 255, 255, 0.8) !important;
          }

          .arcade-roulette-table-wrapper .number-cell:not(.zero-cell).hotspot-highlighted {
            z-index: 4 !important;
          }
          .arcade-roulette-table-wrapper .number-cell:not(.zero-cell):hover {
            z-index: 50 !important;
          }

          /* WHITE BORDER ON HOVER & FOR PLACED/SELECTED BETS */
          .arcade-roulette-table-wrapper .number-cell:not(.zero-cell):hover > span:first-child,
          .arcade-roulette-table-wrapper .number-cell:not(.zero-cell).hotspot-highlighted > span:first-child,
          .arcade-roulette-table-wrapper .number-cell:not(.zero-cell).has-bet > span:first-child,
          .arcade-roulette-table-wrapper .number-cell.covered-by-outside > span:first-child {
            border-color: #ffffff !important;
            box-shadow: 0 0 6px rgba(255, 255, 255, 0.6) !important;
            transform: none !important;
            filter: none !important;
          }

          .arcade-roulette-table-wrapper .zero-cell > span {
            text-shadow: none !important;
            box-shadow: none !important;
            filter: none !important;
            position: relative;
            z-index: 1;
            transition: all 0.15s ease !important;
          }
          .arcade-roulette-table-wrapper .zero-cell:hover > span,
          .arcade-roulette-table-wrapper .zero-cell.hotspot-highlighted > span {
            text-shadow: none !important;
            box-shadow: none !important;
            transform: none !important;
          }

          .casino-game-root, .casino-game-root *, button, input {
            font-family: 'Roboto' !important;
          }
          .casino-game-root h1.casino-title {
            font-family: 'Lobster', cursive !important;
            font-size: 68px;
            margin: 0;
            padding: 0 25px 0 5px;
            font-weight: normal;
            font-style: italic;
            letter-spacing: 1px;
            white-space: nowrap;
            display: inline-block;
            background: -webkit-linear-gradient(#ffe38c, #c98e24);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            -webkit-text-stroke: 1.5px #5c3507;
            filter: drop-shadow(1px 1px 0px #7a480d) 
                    drop-shadow(1px 1px 0px #573104) 
                    drop-shadow(1px 1px 0px #381f01) 
                    drop-shadow(2px 2px 3px rgba(0,0,0,0.9));
          }
          .casino-chip {
            font-size: 15px !important;
          }
          

          .arcade-roulette-table-wrapper .placed-chip {
            position: absolute !important;
            z-index: 60 !important;
            top: 50% !important;
            left: 50% !important;
            right: auto !important;
            bottom: auto !important;
            transform: translate(-50%, -50%) !important;
            pointer-events: none !important;
            height: 40px !important;
            width: 40px !important;
            min-width: 40px !important;
            min-height: 40px !important;
            margin: 0 !important;
            font-size: 13px !important;
            font-weight: 900 !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            line-height: 1 !important;
            letter-spacing: -0.2px !important;
            box-shadow: 0 3px 8px rgba(0, 0, 0, 0.85), inset -1px -2px 3px rgba(0, 0, 0, 0.6), inset 1px 2px 3px rgba(255, 255, 255, 0.6), inset 0 0 0 1.2px rgba(0, 0, 0, 0.35) !important;
          }
          .arcade-roulette-table-wrapper .split-line-overlay,
          .arcade-roulette-table-wrapper .corner-overlay,
          .arcade-roulette-table-wrapper .street-overlay,
          .arcade-roulette-table-wrapper .six-line-overlay {
            overflow: visible !important;
            position: absolute !important;
            cursor: pointer !important;
            background: transparent !important;
            border: none !important;
            transition: background 0.15s ease, box-shadow 0.15s ease;
          }
          .arcade-roulette-table-wrapper .split-line-right { top: 5px; bottom: 5px; right: -10px; width: 20px; z-index: 20; }
          .arcade-roulette-table-wrapper .split-line-bottom { left: 5px; right: 5px; bottom: -10px; height: 20px; z-index: 20; }
          .arcade-roulette-table-wrapper .corner-overlay {
            bottom: -14px;
            right: -14px;
            width: 28px;
            height: 28px;
            z-index: 55 !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
          }
          .arcade-roulette-table-wrapper .basket-overlay {
            position: absolute !important;
            right: -15px !important;
            bottom: -15px !important;
            top: auto !important;
            left: auto !important;
            transform: none !important;
            width: 30px !important;
            height: 30px !important;
            z-index: 100 !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            overflow: visible !important;
          }
          .arcade-roulette-table-wrapper .basket-overlay .placed-chip {
            position: absolute !important;
            top: 50% !important;
            left: 50% !important;
            transform: translate(-50%, -50%) !important;
            z-index: 210 !important;
            transition: none !important;
          }
          .arcade-roulette-table-wrapper .zero-cell,
          .arcade-roulette-table-wrapper .zero-cell:hover {
            transform: none !important;
          }
          .arcade-roulette-table-wrapper .zero-cell > b {
            position: absolute !important;
            top: 50% !important;
            left: 50% !important;
            transform: translate(-50%, -50%) !important;
            transition: none !important;
          }
          .arcade-roulette-table-wrapper .six-line-overlay { bottom: -15px; right: -15px; width: 30px; height: 30px; z-index: 25; }
          .arcade-roulette-table-wrapper .street-overlay { bottom: -15px; left: 20%; right: 20%; height: 25px; z-index: 25; }
          
          .arcade-roulette-table-wrapper .corner-overlay::before {
            display: none !important;
          }

          .arcade-roulette-table-wrapper .corner-overlay .placed-chip {
            top: 50% !important;
            left: 50% !important;
            right: auto !important;
            bottom: auto !important;
            transform: translate(-50%, -50%) !important;
            z-index: 60 !important;
          }

          .arcade-roulette-table-wrapper .split-line-overlay:hover,
          .arcade-roulette-table-wrapper .corner-overlay:hover,
          .arcade-roulette-table-wrapper .street-overlay:hover,
          .arcade-roulette-table-wrapper .six-line-overlay:hover,
          .arcade-roulette-table-wrapper .split-line-overlay.has-bet,
          .arcade-roulette-table-wrapper .corner-overlay.has-bet,
          .arcade-roulette-table-wrapper .street-overlay.has-bet,
          .arcade-roulette-table-wrapper .six-line-overlay.has-bet {
            background: rgba(255, 255, 255, 0.18) !important;
            box-shadow: 0 0 5px rgba(255, 255, 255, 0.4) !important;
            border-radius: 3px !important;
            z-index: 58 !important;
          }
          .arcade-roulette-table-wrapper .red-zone::after,
          .arcade-roulette-table-wrapper .black-zone::after {
            display: none !important;
          }
          .arcade-roulette-table-wrapper .number-cell:not(.zero-cell):hover,
          .arcade-roulette-table-wrapper .number-cell:not(.zero-cell).hotspot-highlighted,
          .arcade-roulette-table-wrapper .number-cell:not(.zero-cell).has-bet {
            background: #1bc13e !important;
            box-shadow: inset 0 0 0 1.5px rgba(255, 255, 255, 0.7) !important;
            transition: box-shadow 0.15s ease !important;
          }

          /* FAINT WHITE OVERLAY WASH OVER ENTIRE CELL AND NUMBER (LIKE REFERENCE IMAGE) */
          .arcade-roulette-table-wrapper .number-cell:not(.zero-cell):hover::after,
          .arcade-roulette-table-wrapper .number-cell:not(.zero-cell).hotspot-highlighted::after,
          .arcade-roulette-table-wrapper .number-cell:not(.zero-cell).has-bet::after,
          .arcade-roulette-table-wrapper .number-cell.covered-by-outside::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(255, 255, 255, 0.20) !important;
            pointer-events: none;
            z-index: 3;
            transition: background 0.15s ease;
          }

          .arcade-roulette-table-wrapper .zero-cell,
          .arcade-roulette-table-wrapper .zero-cell:hover,
          .arcade-roulette-table-wrapper .zero-cell.hotspot-highlighted,
          .arcade-roulette-table-wrapper .zero-cell.precision-selected,
          .arcade-roulette-table-wrapper .zero-cell.has-bet,
          .arcade-roulette-table-wrapper .number-cell.zero-cell,
          .arcade-roulette-table-wrapper .number-cell.zero-cell:hover,
          .arcade-roulette-table-wrapper .number-cell.zero-cell.hotspot-highlighted,
          .arcade-roulette-table-wrapper .number-cell.zero-cell.precision-selected,
          .arcade-roulette-table-wrapper .number-cell.zero-cell.has-bet {
            background: transparent !important;
            background-color: transparent !important;
            box-shadow: none !important;
            border: 0 !important;
            outline: none !important;
          }

          .arcade-roulette-table-wrapper .dozen-row button:hover,
          .arcade-roulette-table-wrapper .outside-row button:hover,
          .arcade-roulette-table-wrapper .column-bets button:hover,
          .arcade-roulette-table-wrapper .dozen-row button.has-bet,
          .arcade-roulette-table-wrapper .outside-row button.has-bet,
          .arcade-roulette-table-wrapper .column-bets button.has-bet {
            background: rgba(255, 255, 255, 0.22) !important;
            color: #ffffff !important;
            box-shadow: inset 0 0 0 1.5px rgba(255, 255, 255, 0.7) !important;
          }
          .arcade-roulette-table-wrapper .dozen-row button:hover span,
          .arcade-roulette-table-wrapper .outside-row button:hover span,
          .arcade-roulette-table-wrapper .column-bets button:hover span,
          .arcade-roulette-table-wrapper .dozen-row button.has-bet span,
          .arcade-roulette-table-wrapper .outside-row button.has-bet span,
          .arcade-roulette-table-wrapper .column-bets button.has-bet span {
            color: #ffffff !important;
          }
          .arcade-roulette-table-wrapper .number-cell.covered-by-outside {
            background: #1bc13e !important;
            box-shadow: inset 0 0 0 1.5px rgba(255, 255, 255, 0.7) !important;
          }
          .arcade-roulette-table-wrapper .number-cell {
            transition: background 0.15s ease, box-shadow 0.15s ease !important;
          }

          /* FORCE CLEAN WHITE BORDERS */
          .arcade-roulette-table-wrapper.arcade-roulette-table-wrapper.arcade-roulette-table-wrapper .number-cell {
            border: 0 !important;
            border-right: 1.5px solid #ffffff !important;
            border-bottom: 1.5px solid #ffffff !important;
          }
          .arcade-roulette-table-wrapper.arcade-roulette-table-wrapper.arcade-roulette-table-wrapper .number-grid .number-cell:nth-child(12n) {
            border-right: 0 !important;
          }
          .arcade-roulette-table-wrapper.arcade-roulette-table-wrapper.arcade-roulette-table-wrapper .number-grid .number-cell:nth-child(n+25) {
            border-bottom: 0 !important;
          }
          
          .arcade-roulette-table-wrapper.arcade-roulette-table-wrapper.arcade-roulette-table-wrapper .dozen-row button { border: 0 !important; border-bottom: 1.5px solid #ffffff !important; border-right: 1.5px solid #ffffff !important; }
          .arcade-roulette-table-wrapper.arcade-roulette-table-wrapper.arcade-roulette-table-wrapper .outside-row button { border: 0 !important; border-bottom: 1.5px solid #ffffff !important; border-right: 1.5px solid #ffffff !important; }
          .arcade-roulette-table-wrapper.arcade-roulette-table-wrapper.arcade-roulette-table-wrapper .dozen-row button:last-child,
          .arcade-roulette-table-wrapper.arcade-roulette-table-wrapper.arcade-roulette-table-wrapper .outside-row button:last-child {
            border-right: 0 !important;
          }
          
          .arcade-roulette-table-wrapper.arcade-roulette-table-wrapper.arcade-roulette-table-wrapper .column-bets button { border: 0 !important; border-bottom: 1.5px solid #ffffff !important; }
          .arcade-roulette-table-wrapper.arcade-roulette-table-wrapper.arcade-roulette-table-wrapper .column-bets button:last-child {
            border-bottom: 0 !important;
          }
          
          /* Ensure zero cell right border is white */
          .arcade-roulette-table-wrapper.arcade-roulette-table-wrapper.arcade-roulette-table-wrapper .number-cell.zero-cell {
            border: 0 !important;
            border-right: 1.5px solid #ffffff !important;
            background: transparent !important;
            background-color: transparent !important;
            box-shadow: none !important;
          }

          /* MOBILE PORTRAIT: COMPACT & BALANCED (A LITTLE WIDTH DECREASE) */
          .casino-game-scalable-stage.is-mobile-portrait .arcade-roulette-table-wrapper {
             width: 1280px !important;
             max-width: 1280px !important;
             margin: 0 auto !important;
             transform: none !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .roulette-table {
             min-width: 1280px !important;
             width: 1280px !important;
             max-width: 1280px !important;
             grid-template-columns: 70px 1140px 70px !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .number-grid {
             width: 1140px !important;
             max-width: 1140px !important;
             grid-template-columns: repeat(12, 95px) !important;
             grid-template-rows: repeat(3, 110px) !important;
             gap: 0 !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .number-cell:not(.zero-cell) {
             width: 95px !important;
             max-width: 95px !important;
             height: 110px !important;
             display: flex !important;
             align-items: center !important;
             justify-content: center !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .number-cell:not(.zero-cell) > span:first-child {
             width: 44px !important;
             height: 44px !important;
             font-size: 22px !important;
             border: 2px solid #ffffff !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .number-cell.zero-cell {
             width: 70px !important;
             max-width: 70px !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .number-cell.zero-cell > span:first-child {
             font-size: 30px !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .column-bets {
             width: 70px !important;
             max-width: 70px !important;
             display: grid !important;
             grid-template-rows: repeat(3, 110px) !important;
             height: 330px !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .column-bets button {
             width: 70px !important;
             height: 110px !important;
             font-size: 16px !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .dozen-row {
             width: 1140px !important;
             max-width: 1140px !important;
             grid-template-columns: repeat(3, 380px) !important;
             height: 60px !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .dozen-row button {
             width: 380px !important;
             height: 60px !important;
             font-size: 17px !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .outside-row {
             width: 1140px !important;
             max-width: 1140px !important;
             grid-template-columns: repeat(6, 190px) !important;
             height: 60px !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .outside-row button {
             width: 190px !important;
             height: 60px !important;
             font-size: 15px !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .outside-row button svg,
          .casino-game-scalable-stage.is-mobile-portrait .outside-row button .diamond-icon {
             transform: scale(1.1) !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .placed-chip {
             width: 34px !important;
             height: 34px !important;
             min-width: 34px !important;
             min-height: 34px !important;
             font-size: 11px !important;
             font-weight: 900 !important;
             top: 50% !important;
             left: 50% !important;
             right: auto !important;
             bottom: auto !important;
             transform: translate(-50%, -50%) !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .corner-overlay {
             width: 36px !important;
             height: 36px !important;
             right: -18px !important;
             bottom: -18px !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .split-line-right {
             width: 26px !important;
             right: -13px !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .split-line-bottom {
             height: 28px !important;
             bottom: -14px !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .street-overlay {
             height: 28px !important;
             bottom: -14px !important;
          }
          .casino-game-scalable-stage.is-mobile-portrait .six-line-overlay {
             width: 36px !important;
             height: 36px !important;
             right: -18px !important;
             bottom: -18px !important;
          }

          /* MOBILE LANDSCAPE: FULL WIDTH TABLE */
          .casino-game-scalable-stage.is-mobile-landscape .arcade-roulette-table-wrapper {
             max-width: 1680px !important;
             width: 94% !important;
             margin: 0 auto !important;
             margin-top: 65px !important;
             transform: none !important;
          }
          .casino-game-scalable-stage.is-mobile-landscape .roulette-table {
             min-width: 1650px !important;
             width: 100% !important;
             grid-template-columns: 90px minmax(1470px, 1fr) 90px !important;
          }
          .casino-game-scalable-stage.is-mobile-landscape .number-grid {
             grid-template-columns: repeat(12, minmax(110px, 1fr)) !important;
             grid-template-rows: repeat(3, 75px) !important;
          }
          .casino-game-scalable-stage.is-mobile-landscape .number-cell:not(.zero-cell) {
             height: 75px !important;
             display: flex !important;
             align-items: center !important;
             justify-content: center !important;
          }
          .casino-game-scalable-stage.is-mobile-landscape .number-cell:not(.zero-cell) > span:first-child {
             width: 48px !important;
             height: 48px !important;
             font-size: 24px !important;
          }
          .casino-game-scalable-stage.is-mobile-landscape .column-bets {
             display: grid !important;
             grid-template-rows: repeat(3, 75px) !important;
             height: 225px !important;
          }
          .casino-game-scalable-stage.is-mobile-landscape .column-bets button {
             height: 75px !important;
             font-size: 18px !important;
          }
          .casino-game-scalable-stage.is-mobile-landscape .dozen-row button {
             height: 42px !important;
             font-size: 18px !important;
          }
          .casino-game-scalable-stage.is-mobile-landscape .outside-row button {
             height: 42px !important;
             font-size: 15px !important;
          }

        `}</style>

        <div className="arcade-roulette-table-wrapper" style={{ fontFamily: 'Arial, sans-serif', position: 'relative', width: '100%', marginTop: isMobilePortrait ? '100px' : (isMobileLandscape ? '65px' : '120px'), transform: (isMobilePortrait || isMobileLandscape) ? 'none' : 'perspective(1000px) rotateX(8deg)', transformOrigin: 'center top', border: 'none', borderRadius: '0', boxShadow: 'none', background: '#1bc13e' }}>

          <div className="roulette-table" style={{ position: 'relative', gap: 0, padding: 0, borderTop: '1.5px solid #ffffff', borderLeft: '1.5px solid #ffffff', background: '#1bc13e' }}>
            {/* ZERO */}
            <div
              className={`number-cell zero-cell ${precisionSelection.includes(0) ? "precision-selected" : ""} ${isNumberInvolvedInBet(0) ? "has-bet" : ""} ${(hoveredBet && hoveredBet.includes(0)) ? "hotspot-highlighted" : ""}`}
              onClick={() => handleNumberClick(0)}
              onMouseEnter={() => setHoveredBet([0])}
              onMouseLeave={() => setHoveredBet(null)}
              style={{ width: '100%', height: '100%', borderRadius: 0, position: 'relative', cursor: bettingOpen ? 'pointer' : 'default', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'transparent', boxShadow: 'none' }}
            >
              <span style={{ color: '#fff', fontSize: '28px', fontWeight: 'bold', fontFamily: '"Roboto"', fontStyle: 'italic', zIndex: 1, textShadow: 'none', boxShadow: 'none' }}>0</span>
              {getTableAmount("SINGLE", 0) > 0 && renderPlacedChip(getTableAmount("SINGLE", 0))}

              {/* BASKET 0-1-2-3 (First Four) OVERLAY ON THE RIGHT BORDER OF ZERO */}
              <span
                className={`basket-overlay ${getTableAmount("CORNER", [0, 1, 2, 3]) > 0 ? "has-bet" : ""}`}
                title="Basket 0-1-2-3"
                onClick={(e) => { e.stopPropagation(); if (bettingOpen) handleCornerClick(e, 0, 1, 2, 3); }}
                onMouseEnter={(e) => { if (bettingOpen) { e.stopPropagation(); setHoveredBet([0, 1, 2, 3]); } }}
                onMouseLeave={(e) => { e.stopPropagation(); setHoveredBet(null); }}
                style={{
                  position: 'absolute',
                  right: '-15px',
                  bottom: '-15px',
                  width: '30px',
                  height: '30px',
                  zIndex: 100,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: bettingOpen ? 'pointer' : 'default',
                  pointerEvents: bettingOpen ? 'auto' : 'none'
                }}
              >
                {getTableAmount("CORNER", [0, 1, 2, 3]) > 0 && renderPlacedChip(getTableAmount("CORNER", [0, 1, 2, 3]))}
              </span>
            </div>

            {/* 1-36 */}
            <div className="number-grid" style={{ gap: 0, borderTop: '1px solid #fff', borderRight: '1px solid #fff', borderBottom: '1px solid #fff', borderLeft: '1px solid #fff' }}>
              {NUMBER_ROWS.flatMap((row) => row.map((number) => {
                const color = getNumberColor(number);
                const amount = getTableAmount("SINGLE", number);
                const isHoverHighlighted = hoveredNumber && (precisionMode === "SIX_LINE" || precisionMode === "STREET") && previewConnectedNumbers(hoveredNumber).includes(number);
                const selected = precisionSelection.includes(number) || isHoverHighlighted;
                const hasRightSplit = number <= 33;
                const hasBottomSplit = number % 3 !== 1;

                return (
                  <div
                    key={number}
                    className={`number-cell ${color}-cell ${selected ? "precision-selected" : ""} ${isNumberInvolvedInBet(number) ? "has-bet" : ""} ${isNumberCoveredByOutsideBet(number) ? "covered-by-outside" : ""} ${(hoveredBet && hoveredBet.includes(number)) ? "hotspot-highlighted" : ""}`}
                    onClick={() => handleNumberClick(number)}
                    onMouseEnter={() => setHoveredBet([number])}
                    onMouseLeave={() => setHoveredBet(null)}
                    style={{ background: '#1bc13e', borderRadius: 0, overflow: 'visible', position: 'relative', cursor: bettingOpen ? 'pointer' : 'default', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRight: (number === 34 || number === 35 || number === 36) ? 'none' : '1px solid #fff', borderBottom: '1px solid #fff' }}
                  >
                    <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '21px', fontFamily: "'Roboto', sans-serif", background: color === 'red' ? '#c42634' : '#282b2a', width: '90%', height: '85%', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '0px', textShadow: 'none', boxShadow: 'none' }}>{number}</span>
                    {amount > 0 && renderPlacedChip(amount)}

                    {hasRightSplit && (
                      <span className={`split-line-overlay split-line-right ${getTableAmount("SPLIT", [number, number + 3].sort((a, b) => a - b)) > 0 ? "has-bet" : ""}`} title={`Split ${Math.min(number, number + 3)}-${Math.max(number, number + 3)}`} onClick={(e) => bettingOpen && handleSplitLineClick(e, number, number + 3)} onMouseEnter={() => { if (bettingOpen) setHoveredBet([number, number + 3]); }} onMouseLeave={() => setHoveredBet(null)} style={{ pointerEvents: bettingOpen ? 'auto' : 'none' }}>
                        {getTableAmount("SPLIT", [number, number + 3].sort((a, b) => a - b)) > 0 && renderPlacedChip(getTableAmount("SPLIT", [number, number + 3].sort((a, b) => a - b)))}
                      </span>
                    )}
                    {hasBottomSplit && (
                      <span className={`split-line-overlay split-line-bottom ${getTableAmount("SPLIT", [number, number - 1].sort((a, b) => a - b)) > 0 ? "has-bet" : ""}`} title={`Split ${Math.min(number, number - 1)}-${Math.max(number, number - 1)}`} onClick={(e) => bettingOpen && handleSplitLineClick(e, number, number - 1)} onMouseEnter={() => { if (bettingOpen) setHoveredBet([number, number - 1]); }} onMouseLeave={() => setHoveredBet(null)} style={{ pointerEvents: bettingOpen ? 'auto' : 'none' }}>
                        {getTableAmount("SPLIT", [number, number - 1].sort((a, b) => a - b)) > 0 && renderPlacedChip(getTableAmount("SPLIT", [number, number - 1].sort((a, b) => a - b)))}
                      </span>
                    )}
                    {(hasRightSplit && hasBottomSplit) && (
                      <span className={`corner-overlay ${getTableAmount("CORNER", [number - 1, number, number + 2, number + 3].sort((a, b) => a - b)) > 0 ? "has-bet" : ""}`} title={`Corner ${number - 1}-${number}-${number + 2}-${number + 3}`} onClick={(e) => bettingOpen && handleCornerClick(e, number - 1, number, number + 2, number + 3)} onMouseEnter={() => { if (bettingOpen) setHoveredBet([number - 1, number, number + 2, number + 3]); }} onMouseLeave={() => setHoveredBet(null)} style={{ pointerEvents: bettingOpen ? 'auto' : 'none' }}>
                        {getTableAmount("CORNER", [number - 1, number, number + 2, number + 3].sort((a, b) => a - b)) > 0 && renderPlacedChip(getTableAmount("CORNER", [number - 1, number, number + 2, number + 3].sort((a, b) => a - b)))}
                      </span>
                    )}
                    {(hasRightSplit && number % 3 === 1) && (
                      <span className={`six-line-overlay ${getTableAmount("SIX_LINE", [number, number + 1, number + 2, number + 3, number + 4, number + 5]) > 0 ? "has-bet" : ""}`} title={`Six Line ${number}-${number + 5}`} onClick={(e) => bettingOpen && handleSixLineClick(e, number)} onMouseEnter={() => { if (bettingOpen) setHoveredBet([number, number + 1, number + 2, number + 3, number + 4, number + 5]); }} onMouseLeave={() => setHoveredBet(null)} style={{ pointerEvents: bettingOpen ? 'auto' : 'none' }}>
                        {getTableAmount("SIX_LINE", [number, number + 1, number + 2, number + 3, number + 4, number + 5]) > 0 && renderPlacedChip(getTableAmount("SIX_LINE", [number, number + 1, number + 2, number + 3, number + 4, number + 5]))}
                      </span>
                    )}
                    {(number % 3 === 1) && (
                      <span className={`street-overlay ${getTableAmount("STREET", [number, number + 1, number + 2]) > 0 ? "has-bet" : ""}`} title={`Street ${number}-${number + 2}`} onClick={(e) => bettingOpen && handleStreetClick(e, number)} onMouseEnter={() => { if (bettingOpen) setHoveredBet([number, number + 1, number + 2]); }} onMouseLeave={() => setHoveredBet(null)} style={{ pointerEvents: bettingOpen ? 'auto' : 'none' }}>
                        {getTableAmount("STREET", [number, number + 1, number + 2]) > 0 && renderPlacedChip(getTableAmount("STREET", [number, number + 1, number + 2]))}
                      </span>
                    )}
                  </div>
                );
              }))}
            </div>

            {/* COLUMNS */}
            <div className="column-bets" style={{ borderTop: '1px solid #fff', borderRight: '1px solid #fff', borderBottom: '1px solid #fff' }}>
              {[["COLUMN_3", "COLUMN_3", "2 to 1"], ["COLUMN_2", "COLUMN_2", "2 to 1"], ["COLUMN_1", "COLUMN_1", "2 to 1"]].map(([type, value, label]) => (
                <button
                  key={type}
                  type="button"
                  onClick={() => addOutsideBet(type, value, BET_TYPES[type].name)}
                  onMouseEnter={() => setHoveredBet(getNumbersForBetType(type))}
                  onMouseLeave={() => setHoveredBet(null)}
                  className={getTableAmount(type, value) > 0 ? "has-bet" : ""}
                  disabled={!bettingOpen}
                  style={{ background: 'transparent', borderRadius: 0, color: '#fff', fontWeight: 'bold', fontSize: '16px', fontFamily: '"Roboto"', borderBottom: '1px solid #fff', borderLeft: '1px solid #fff' }}
                >
                  <span>{label}</span>
                  {getTableAmount(type, value) > 0 && renderPlacedChip(getTableAmount(type, value))}
                </button>
              ))}
            </div>

            {/* DOZENS */}
            <div className="dozen-row" style={{ borderLeft: '1px solid #fff', borderRight: '1px solid #fff' }}>
              {[["DOZEN_1", "DOZEN_1", "1st 12"], ["DOZEN_2", "DOZEN_2", "2nd 12"], ["DOZEN_3", "DOZEN_3", "3rd 12"]].map(([type, value, label]) => (
                <button
                  key={type}
                  type="button"
                  onClick={() => addOutsideBet(type, value, label)}
                  onMouseEnter={() => setHoveredBet(getNumbersForBetType(type))}
                  onMouseLeave={() => setHoveredBet(null)}
                  className={getTableAmount(type, value) > 0 ? "has-bet" : ""}
                  disabled={!bettingOpen}
                  style={{ background: 'transparent', borderRadius: 0, color: '#fff', fontWeight: 'bold', fontSize: '18px', fontStyle: 'italic', fontFamily: '"Roboto"', borderRight: label === '3rd 12' ? 'none' : '1px solid #fff' }}
                >
                  <span>{label}</span>
                  {getTableAmount(type, value) > 0 && renderPlacedChip(getTableAmount(type, value))}
                </button>
              ))}
            </div>

            {/* OUTSIDE */}
            <div className="outside-row" style={{ position: 'relative', borderLeft: '1px solid #fff', borderRight: '1px solid #fff' }}>
              {[["LOW", "LOW", "1 to 18", ""], ["EVEN", "EVEN", "EVEN", ""], ["BLACK", "BLACK", "BLACK", "black-zone"], ["RED", "RED", "RED", "red-zone"], ["ODD", "ODD", "ODD", ""], ["HIGH", "HIGH", "19 to 36", ""]].map(([type, value, label, className]) => (
                <button
                  key={type}
                  type="button"
                  className={`${className || ""} ${getTableAmount(type, value) > 0 ? "has-bet" : ""}`}
                  onClick={() => addOutsideBet(type, value, label)}
                  onMouseEnter={() => setHoveredBet(getNumbersForBetType(type))}
                  onMouseLeave={() => setHoveredBet(null)}
                  disabled={!bettingOpen}
                  style={{ background: 'transparent', borderRadius: 0, color: '#fff', fontWeight: 'bold', fontSize: '18px', fontStyle: 'italic', position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', fontFamily: '"Roboto"', borderRight: label === '19 to 36' ? 'none' : '1px solid #fff', borderBottom: '1px solid #fff' }}
                >
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                    {label === "RED" ? (
                      <div style={{ width: '60px', height: '30px', background: '#d81525', clipPath: 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)' }}></div>
                    ) : label === "BLACK" ? (
                      <div style={{ width: '60px', height: '30px', background: '#000', clipPath: 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)' }}></div>
                    ) : (
                      <span>{label}</span>
                    )}
                  </div>
                  {getTableAmount(type, value) > 0 && renderPlacedChip(getTableAmount(type, value))}
                </button>
              ))}

              {/* NEIGHBOUR BET button removed */}
            </div>

          </div>
        </div>

      </div>

      {/* ROUNDED WOODEN RIM ABOVE STATUS BAR */}
      <div style={{ position: 'absolute', bottom: '35px', left: '0', right: '0', height: '24px', background: 'linear-gradient(to bottom, #8a4816 0%, #d88139 25%, #e49141 50%, #8a4816 75%, #3e1b06 100%)', borderTop: '2px solid #5a3e10', borderBottom: '2px solid #1a0a00', boxShadow: '0 -3px 8px rgba(0,0,0,0.5)', zIndex: 110 }}></div>

      {/* FLAT STATUS BAR */}
      <div style={{ position: 'absolute', bottom: '0', left: '0', right: '0', height: '35px', background: '#1c0c05', display: 'flex', alignItems: 'center', zIndex: 110, padding: '0 20px' }}>
        <div style={{ width: '100%', textAlign: 'center' }}>
          <span className={phase !== "SPINNING" && stagedGroups.length === 0 && committedGroups.length === 0 ? "blink-text" : ""} style={{ color: '#fff', fontSize: '14px' }}>
            {isWheelSpinning ? "Wheel is spinning" : (stagedGroups.length > 0 ? "Confirm bet" : (committedGroups.length > 0 ? "Bet Confirmed" : "Place your chips"))}
          </span>
        </div>
        {/* FULLSCREEN BUTTON */}
        <button
          type="button"
          onClick={() => {
            if (!document.fullscreenElement) {
              document.documentElement.requestFullscreen();
            } else {
              document.exitFullscreen();
            }
          }}
          style={{ position: 'absolute', right: '15px', width: '26px', height: '26px', background: 'transparent', border: '1.5px solid #d4a350', borderRadius: '4px', color: '#d4a350', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', padding: 0 }}
          title="Toggle Fullscreen"
        >
          ⛶
        </button>
      </div>

      {/* RESULT MODAL - REPLACED BY REACT-TOASTIFY NOTIFICATIONS */}

      {/* TAKE MODAL */}
      {takeModalOpen && renderTakeModal()}
      </div>
    </div>
  );

};

export default Game;
































